import Series from "./series";

export default class seriesMasterList {
  masterList: Series[] = [
    new Series(
      "2K Sports",
      "Mamba Forever",
      null,
      [
        ["NBA 2K Playgrounds 2"],
        ["NBA 2K25", "NBA 2K25 (Xbox One)"],
        ["PGA TOUR 2K25"],
        ["TopSpin 2K25"],
        ["WWE 2K25", "WWE 2K25 (Xbox One)"],
        ["WWE 2K Battlegrounds"],
      ],
      [[], ["One"], [], [], ["One"], []]
    ),
    new Series(
      "60 Seconds!",
      "Tsar Bomba",
      null,
      [["60 Seconds! Reatomized"], ["60 Parsecs!"]],
      [[], []]
    ),
    new Series(
      "A Plague Tale",
      "Protector of the Carrier",
      "#C6BF75",
      [
        ["A Plague Tale: Innocence", "A Plague Tale: Innocence (Windows)"],
        ["A Plague Tale: Requiem"],
        ["Resonance: A Plague Tale Legacy"],
      ],
      [["Windows"], [], []]
    ),
    new Series(
      "A44 Games",
      "Child of Gefn",
      "#787EE2",
      [["Ashen"], ["Flintlock: The Siege of Dawn"]],
      [[], []]
    ),
    new Series(
      "Aaero",
      "Proxima Centauri",
      null,
      [["Aaero"], ["Aaero 2"]],
      [[], []]
    ),
    new Series(
      "Ace Attorney",
      "The Turnabout Terror",
      "#B95B81",
      [
        ["Phoenix Wright: Ace Attorney Trilogy"],
        ["Apollo Justice: Ace Attorney Trilogy"],
        ["Ace Attorney Investigations Collection"],
      ],
      [[], [], []]
    ),
    new Series(
      "Adventure Time",
      "Son of the Comet",
      null,
      [
        ["Adventure Time: The Secret of the Nameless Kingdom"],
        [
          "Adventure Time: Finn and Jake Investigations",
          "Adventure Time: Finn and Jake Investigations (Xbox 360)",
        ],
        ["Adventure Time: Pirates of the Enchiridion"],
      ],
      [[], ["360"], []]
    ),
    new Series(
      "Aeterna",
      "The Cursed Monarch of Light & Dark",
      null,
      [["Summum Aeterna"], ["Aeterna Noctis"], ["Aeterna Lucis"]],
      [[], [], []]
    ),
    new Series(
      "AeternoBlade",
      "Lord of Chronos",
      null,
      [
        ["AeternoBlade"],
        ["AeternoBlade II: Infinity", "AeternoBlade II: Infinity (Xbox One)"],
      ],
      [[], ["One"]]
    ),
    new Series(
      "After",
      "A Live Worth Living",
      null,
      [["Afterlove EP"], ["What Comes After"]],
      [[], []]
    ),
    new Series(
      "Agatha Christie",
      "Monsieur Popeau",
      null,
      [
        [
          "Agatha Christie - The ABC Murders",
          "Agatha Christie - The ABC Murders (Xbox One)",
        ],
        ["Agatha Christie - Hercule Poirot: The First Cases"],
        ["Agatha Christie - Hercule Poirot: The London Case"],
        ["Agatha Christie - Murder on the Orient Express"],
        ["Agatha Christie - Death on the Nile"],
      ],
      [["One"], [], [], [], []]
    ),
    new Series(
      "Age of Empires",
      "King of Kings",
      null,
      [
        ["Age of Empires IV: Anniversary Edition"],
        ["Age of Mythology: Retold"],
      ],
      [[], []]
    ),
    new Series(
      "Age of Wonders",
      "Mr. Universe",
      null,
      [
        ["Age of Wonders: Planetfall", "Age of Wonders: Planetfall (Windows)"],
        ["Age of Wonders 4", "Age of Wonders 4 (Windows)"],
      ],
      [["Windows"], ["Windows"]]
    ),
    new Series(
      "Aggro Crab",
      "Self-Actualized",
      null,
      [["Another Crab's Treasure"], ["Going Under"]],
      [[], []]
    ),
    new Series(
      "AI: The Somnium Files",
      "DDD: CEO",
      "#69F9FB",
      [
        ["AI: The Somnium Files"],
        ["AI: The Somnium Files - nirvanA Initiative"],
      ],
      [[], []]
    ),
    new Series(
      "Alchemist",
      "Walking Encyclopedia",
      null,
      [["Alchemist Simulator"], ["Alchemist: The Potion Monger"]],
      [[], []]
    ),
    new Series(
      "Alien",
      "Sole Survivor of the USCSS Nostromo",
      null,
      [
        [
          "Alien: Isolation",
          "Alien: Isolation (Xbox 360)",
          "Alien: Isolation (Windows)",
        ],
        ["Aliens: Fireteam Elite"],
        ["Aliens: Dark Descent"],
      ],
      [["360", "Windows"], [], []]
    ),
    new Series(
      "American McGee's Alice",
      "Ended Insanity",
      null,
      [["Alice: Madness Returns"]],
      [[]]
    ),
    new Series(
      "Amnesia",
      "Descended From Darkness",
      "#A78E62",
      [
        ["Amnesia: Collection", "Amnesia: Collection (Windows)"],
        ["Amnesia: Rebirth"],
        ["Amnesia: The Bunker"],
      ],
      [["Windows"], [], []]
    ),
    new Series(
      "Anima",
      "Hand of Tanathos",
      null,
      [
        ["Anima: Gate of Memories"],
        ["Anima: Gate of Memories \u2013 The Nameless Chronicles"],
        ["Anima: Song from the Abyss"],
      ],
      [[], [], []]
    ),
    new Series(
      "Animus",
      "Unremembered",
      null,
      [["Animus - Stand Alone"], ["Animus: Revenant"]],
      [[], []]
    ),
    new Series(
      "Anodyne",
      "Young Nova",
      null,
      [["Anodyne"], ["Anodyne 2: Return to Dust"]],
      [[], []]
    ),
    new Series(
      "Aqua Kitty",
      "Super Kitty Savior",
      null,
      [["AQUA KITTY UDX: Xbox One Ultra Edition"], ["ASTRO AQUA KITTY"]],
      [[], []]
    ),
    new Series(
      "Aragami",
      "Spirit of Vengeance",
      "#4B4B4B",
      [["Aragami: Shadow Edition"], ["Aragami 2"]],
      [[], []]
    ),
    new Series(
      "Arcadegeddon",
      "I'm The Pluggernaut",
      null,
      [["Arcadegeddon"]],
      [[]]
    ),
    new Series(
      "Arcade Game Series",
      "Mr. Driller",
      null,
      [
        ["ARCADE GAME SERIES: DIG DUG"],
        ["ARCADE GAME SERIES: GALAGA"],
        ["ARCADE GAME SERIES: Ms. Pac-Man"],
        ["ARCADE GAME SERIES: Pac-Man"],
      ],
      [[], [], [], []]
    ),
    new Series(
      "Aritana",
      "Guardian of YpY",
      null,
      [["Aritana and the Harpy's Feather"], ["Aritana and the Twin Masks"]],
      [[], []]
    ),
    new Series(
      "ARK",
      "Ascended Homo Deus",
      "#CFF926",
      [
        ["ARK: Survival Evolved"],
        ["ARK: Survival Ascended"],
        ["Ark II"],
        ["PixARK"],
      ],
      [[], [], [], []]
    ),
    new Series(
      "Arkane Connected Universe",
      "The Outsider to the Void",
      "#7C8081 #3A4A5F",
      [
        [
          "Dishonored Definitive Edition",
          "Dishonored",
          "Dishonored Definitive Edition (Windows)",
        ],
        ["Dishonored 2", "Dishonored 2 (Windows)"],
        [
          "Dishonored: Death of the Outsider",
          "Dishonored: Death of the Outsider (Windows)",
        ],
        ["DEATHLOOP"],
      ],
      [["360", "Windows"], ["Windows"], ["Windows"], []]
    ),
    new Series(
      "Dishonored",
      "Lord Protector to the Empress",
      null,
      [
        [
          "Dishonored Definitive Edition",
          "Dishonored",
          "Dishonored Definitive Edition (Windows)",
        ],
        ["Dishonored 2", "Dishonored 2 (Windows)"],
        [
          "Dishonored: Death of the Outsider",
          "Dishonored: Death of the Outsider (Windows)",
        ],
      ],
      [["360", "Windows"], ["Windows"], ["Windows"]]
    ),
    new Series(
      "DEATHLOOP",
      "Visionary Killer to the Loop",
      null,
      [["DEATHLOOP"]],
      [[]]
    ),
    new Series(
      "Arkanoid",
      "Certificate of DOH",
      null,
      [["ARKANOID Live!"], ["Arkanoid Eternal Battle"]],
      [[], []]
    ),
    new Series(
      "Artifex Mundi",
      "Destiny Written in Blood",
      null,
      [
        ["9 Clues: The Secret of Serpent Creek"],
        ["9 Clues 2: The Ward"],
        ["Abyss: The Wraiths of Eden"],
        ["Agent Walker: Secret Journey"],
        ["Chronicles of Magic: Divided Kingdom"],
        ["Clockwork Tales: Of Glass and Ink"],
        ["Crime Secrets: Crimson Lily"],
        ["Dark Arcana: The Carnival"],
        ["Demon Hunter: Ascendance"],
        ["Demon Hunter: Chronicles from Beyond"],
        ["Demon Hunter: New Chapter"],
        ["Demon Hunter: Revelation"],
        ["Demon Hunter: Riddles of Light"],
        ["Dreamwalker: Never Fall Asleep"],
        ["Endless Fables: Dark Moor"],
        ["Endless Fables: Shadow Within"],
        ["Enigmatis: The Ghosts of Maple Creek"],
        ["Enigmatis 2: The Mists of Ravenwood"],
        ["Enigmatis 3: The Shadow of Karkhala"],
        ["Eventide: Slavic Fable"],
        ["Eventide 2: Sorcerer's Mirror"],
        ["Eventide 3: Legacy of Legends"],
        ["Faces of Illusion: The Twin Phantoms"],
        ["Family Mysteries: Poisonous Promises"],
        ["Family Mysteries 2: Echoes of Tomorrow"],
        ["Family Mysteries 3: Criminal Mindset"],
        ["Ghost Files: Memory of a Crime"],
        ["Ghost Files: The Face of Guilt"],
        [
          "Grim Legends: The Forsaken Bride",
          "Grim Legends: The Forsaken Bride (Xbox One)",
        ],
        ["Grim Legends 2: Song of the Dark Swan"],
        ["Grim Legends 3: The Dark City"],
        ["Irony Curtain: From Matryoshka with Love"],
        ["King's Heir: Rise to the Throne"],
        ["Lost Grimoires: Stolen Kingdom"],
        ["Lost Grimoires 2: Shard of Mystery"],
        ["Lost Grimoires 3: The Forgotten Well"],
        ["Modern Tales: Age of Invention"],
        ["My Brother Rabbit"],
        ["Noir Chronicles: City of Crime"],
        ["Path of Sin: Greed"],
        ["Persian Nights: Sands of Wonders"],
        ["Persian Nights 2: Moonlight Veil"],
        ["Queen's Quest 2: Stories of Forgotten Past"],
        ["Queen's Quest 3: The End of Dawn"],
        ["Queen's Quest 4: Sacred Truce"],
        ["Queen's Quest 5: Symphony of Death"],
        ["Scarlett Mysteries: Cursed Child"],
        ["Skyland: Heart of the Mountain"],
        ["The Myth Seekers: The Legacy of Vulkan"],
        ["The Myth Seekers 2: The Sunken City"],
        ["The Secret Order: Return to the Buried Kingdom"],
        ["The Secret Order: Shadow Breach"],
        ["Tibetan Quest: Beyond World's End"],
        ["Tiny Tales: Heart of the Forest"],
        ["Uncharted Tides: Port Royal"],
        ["Yuletide Legends: Who Framed Santa Claus"],
      ],
      [
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        ["One"],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
      ]
    ),
    new Series(
      "Asdivine",
      "Jack of all Stats",
      null,
      [
        ["Asdivine Hearts"],
        ["Asdivine Hearts ll"],
        ["Asdivine Dios"],
        ["Asdivine Menace"],
        ["Asdivine Kamura"],
        ["Asdivine Cross"],
        ["Asdivine Saga"],
      ],
      [[], [], [], [], [], [], []]
    ),
    new Series(
      "Assassin's Creed",
      "Mentor to Assassins",
      "#DADADA #F00201",
      [
        ["Assassin's Creed"],
        ["Assassin's Creed The Ezio Collection"],
        [
          "Assassin's Creed: Brotherhood",
          "Assassin's Creed: Brotherhood (Xbox 360)",
        ],
        [
          "Assassin's Creed: Revelations",
          "Assassin's Creed: Revelations (Xbox 360)",
        ],
        ["Assassin's Creed III Remastered"],
        ["Assassin's Creed III", "Assassin's Creed III (Xbox 360)"],
        [
          "Assassin's Creed Liberation HD",
          "Assassin's Creed Liberation HD (Xbox 360)",
        ],
        [
          "Assassin's Creed IV: Black Flag",
          "Assassin's Creed IV: Black Flag (Xbox 360)",
        ],
        ["Assassin's Creed Unity"],
        [
          "Assassin's Creed Rogue Remastered",
          "Assassin's Creed Rogue Remastered (Xbox 360)",
        ],
        ["Assassin's Creed Syndicate"],
        ["Assassin's Creed Origins"],
        ["Assassin's Creed Odyssey"],
        ["Assassin's Creed Valhalla"],
        ["Assassin's Creed Mirage"],
        ["Assassin's Creed Shadows"],
        ["Assassin's Creed Codename HEXE"],
        ["Assassin's Creed Chronicles: China"],
        ["Assassin's Creed Chronicles: India"],
        ["Assassin's Creed Chronicles: Russia"],
        ["Discovery Tour: Viking Age"],
      ],
      [
        [],
        [],
        ["360"],
        ["360"],
        [],
        ["360"],
        ["360"],
        ["360"],
        [],
        ["360"],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
      ]
    ),
    new Series(
      "Assassin's Creed (Desmond)",
      "Master Assassin",
      null,
      [
        ["Assassin's Creed"],
        ["Assassin's Creed The Ezio Collection"],
        [
          "Assassin's Creed: Brotherhood",
          "Assassin's Creed: Brotherhood (Xbox 360)",
        ],
        [
          "Assassin's Creed: Revelations",
          "Assassin's Creed: Revelations (Xbox 360)",
        ],
        ["Assassin's Creed III Remastered"],
        ["Assassin's Creed III", "Assassin's Creed III (Xbox 360)"],
        [
          "Assassin's Creed Liberation HD",
          "Assassin's Creed Liberation HD (Xbox 360)",
        ],
      ],
      [[], [], ["360"], ["360"], [], ["360"], ["360"]]
    ),
    new Series(
      "Assassin's Creed (Analysts)",
      "Master Pirate",
      null,
      [
        [
          "Assassin's Creed IV: Black Flag",
          "Assassin's Creed IV: Black Flag (Xbox 360)",
        ],
        ["Assassin's Creed Unity"],
        [
          "Assassin's Creed Rogue Remastered",
          "Assassin's Creed Rogue Remastered (Xbox 360)",
        ],
        ["Assassin's Creed Syndicate"],
      ],
      [["360"], [], ["360"], []]
    ),
    new Series(
      "Assassin's Creed (Layla)",
      "Master Hidden One",
      null,
      [
        ["Assassin's Creed Origins"],
        ["Assassin's Creed Odyssey"],
        ["Assassin's Creed Valhalla"],
      ],
      [[], [], []]
    ),
    new Series(
      "Assassin's Creed (Readers)",
      "Master Shinobi",
      null,
      [["Assassin's Creed Mirage"], ["Assassin's Creed Shadows"]],
      [[], []]
    ),
    new Series(
      "Assassin's Creed Chronicles",
      "Master of Shadows",
      null,
      [
        ["Assassin's Creed Chronicles: China"],
        ["Assassin's Creed Chronicles: India"],
        ["Assassin's Creed Chronicles: Russia"],
      ],
      [[], [], []]
    ),
    new Series(
      "Assetto Corsa",
      "GT Champion",
      null,
      [["Assetto Corsa"], ["Assetto Corsa Competizione"]],
      [[], []]
    ),
    new Series(
      "Asterix And Obelix",
      "Legendary Gaulish Warrior",
      null,
      [
        ["Asterix & Obelix XXL: Romastered"],
        ["Asterix & Obelix XXL 2"],
        ["Asterix & Obelix XXL3: The Crystal Menhir"],
        ["Asterix & Obelix XXXL: The Ram From Hibernia"],
        ["Asterix & Obelix: Heroes"],
        ["Asterix & Obelix: Slap Them All!"],
        ["Asterix & Obelix: Slap Them All! 2"],
      ],
      [[], [], [], [], [], [], []]
    ),
    new Series(
      "Atari",
      "Red Sunset",
      "#E41B23",
      [
        ["Atari Flashback Classics Vol. 1"],
        ["Atari Flashback Classics Vol. 2"],
        ["Atari Flashback Classics Vol. 3"],
        ["Asteroids: Recharged"],
        ["Berzerk: Recharged"],
        ["Black Widow: Recharged"],
        ["Breakout: Recharged"],
        ["Caverns of Mars: Recharged"],
        ["Centipede: Recharged"],
        ["Gravitar: Recharged"],
        ["Missile Command: Recharged"],
        ["Quantum: Recharged"],
        ["Yars: Recharged"],
      ],
      [[], [], [], [], [], [], [], [], [], [], [], [], []]
    ),
    new Series(
      "Attack on Titan",
      "Devil of all Earth",
      null,
      [["Attack on Titan"], ["Attack on Titan 2"]],
      [[], []]
    ),
    new Series(
      "Avatar",
      "Fully Realized Avatar",
      null,
      [
        ["Avatar: The Last Airbender - The Burning Earth"],
        ["Avatar: The Last Airbender - Quest for Balance"],
      ],
      [[], []]
    ),
    new Series(
      "Axiom Verge",
      "Overclocked",
      null,
      [["Axiom Verge"], ["Axiom Verge 2"]],
      [[], []]
    ),
    new Series(
      "Battlefield",
      "Weapon of Mass Destruction",
      "#F69735 #464864",
      [
        ["Battlefield 4", "Battlefield 4 (Xbox 360)"],
        ["Battlefield 1"],
        ["Battlefield V"],
        ["Battlefield 2042", "Battlefield 2042 (Xbox One)"],
      ],
      [["360"], [], [], ["One"]]
    ),
    new Series(
      "Battlefield (Great War Era)",
      "Through Mud and Blood",
      null,
      [["Battlefield 1"], ["Battlefield V"]],
      [[], []]
    ),
    new Series(
      "Battlefield (Modern Era)",
      "Semper Fidelis",
      null,
      [["Battlefield 4"], ["Battlefield 2042"]],
      [[], []]
    ),
    new Series(
      "Battlestations",
      "Fleet Admiral",
      null,
      [["Battlestations: Midway"], ["Battlestations: Pacific"]],
      [[], []]
    ),
    new Series(
      "Behemoth Universe",
      "We Come In Peace",
      null,
      [
        ["Castle Crashers Remastered"],
        ["Pit People"],
        ["Alien Hominid HD"],
        ["Alien Hominid Invasion"],
      ],
      [[], [], [], []]
    ),
    new Series(
      "Beholder",
      "Beholden to None",
      null,
      [["Beholder Complete Edition"], ["Beholder 2"], ["Beholder 3"]],
      [[], [], []]
    ),
    new Series(
      "Ben 10",
      "The Cosmic Savior",
      "#87CF2E",
      [["Ben 10"], ["Ben 10: Power Trip"]],
      [[], []]
    ),
    new Series(
      "Bendy: Lone Wolfl",
      "Little Devil Darlin'",
      "#FFCD65",
      [
        ["Bendy and the Ink Machine", "Bendy and the Ink Machine (Xbox One)"],
        ["Bendy and the Dark Arrival", "Bendy and the Dark Arrival (Xbox One)"],
        ["Bendy: Lone Wolf"],
      ],
      [["One"], ["One"], []]
    ),
    new Series(
      "BioShock",
      "Songbird of Rapture",
      "#38A696",
      [
        ["BioShock Remastered", "BioShock Remastered (Xbox 360)"],
        ["BioShock 2 Remastered", "BioShock 2 Remastered (Xbox 360)"],
        [
          "BioShock Infinite: The Complete Edition",
          "BioShock Infinite: The Complete Edition (Xbox 360)",
        ],
      ],
      [["360"], ["360"], ["360"]]
    ),
    new Series(
      "Blasphemous",
      "Warrior of the Silent Sorrow",
      null,
      [["Blasphemous"], ["Blasphemous 2"]],
      [[], []]
    ),
    new Series(
      "Blaster Master Zero",
      "Blaster 'Master' Zero",
      null,
      [
        ["Blaster Master Zero"],
        ["Blaster Master Zero 2"],
        ["Blaster Master Zero 3"],
      ],
      [[], [], []]
    ),
    new Series(
      "Bleach",
      "Kami of Death",
      null,
      [["Bleach: Brave Souls"], ["Bleach: Rebirth of Souls"]],
      [[], []]
    ),
    new Series(
      "Bleed",
      "Best Hero of All Time",
      null,
      [["Bleed"], ["Bleed 2"]],
      [[], []]
    ),
    new Series(
      "Blood Dragon",
      "Cybercommando",
      null,
      [
        [
          "Far Cry 3 Blood Dragon Classic Edition",
          "Far Cry 3 Blood Dragon Classic Edition (Xbox 360)",
        ],
        ["Trials of the Blood Dragon"],
      ],
      [["360"], []]
    ),
    new Series(
      "BloodRayne",
      "Playboy Dhampir",
      null,
      [
        ["BloodRayne: ReVamped"],
        ["BloodRayne 2: ReVamped"],
        ["BloodRayne: Betrayal - Fresh Bites"],
      ],
      [[], [], []]
    ),
    new Series(
      "Bloons",
      "MOAB Mauler",
      null,
      [["Bloons TD 5"], ["Bloons TD 6", "Bloons TD 6 (Windows)"]],
      [[], ["Windows"]]
    ),
    new Series(
      "Bomberman",
      "Everyone's Hero",
      null,
      [["SUPER BOMBERMAN R"], ["SUPER BOMBERMAN R 2"]],
      [[], []]
    ),
    new Series(
      "Borderlands",
      "True Ultimate Vault Hunter",
      "#F6D20C #E1A251",
      [
        [
          "Borderlands: Game of the Year Edition",
          "Borderlands: Game of the Year Edition (Xbox 360)",
        ],
        ["Borderlands 2", "Borderlands 2 (Xbox 360)"],
        [
          "Tiny Tina's Assault on Dragon Keep: A Wonderlands One-shot Adventure",
        ],
        ["Tiny Tina's Wonderlands"],
        [
          "Borderlands: The Pre-Sequel",
          "Borderlands: The Pre-Sequel (Xbox 360)",
        ],
        ["Tales from the Borderlands", "Tales from the Borderlands (Xbox 360)"],
        ["Borderlands 3", "Borderlands 3 (Windows)"],
        ["New Tales From The Borderlands"],
        ["Borderlands 4"],
      ],
      [["360"], ["360"], [], [], ["360"], ["360"], ["Windows"], [], []]
    ),
    new Series(
      "Borderlands (Mainline)",
      "Next-Level Vault Hunter",
      null,
      [
        [
          "Borderlands: Game of the Year Edition",
          "Borderlands: Game of the Year Edition (Xbox 360)",
        ],
        ["Borderlands 2", "Borderlands 2 (Xbox 360)"],
        [
          "Borderlands: The Pre-Sequel",
          "Borderlands: The Pre-Sequel (Xbox 360)",
        ],
        ["Borderlands 3", "Borderlands 3 (Windows)"],
        ["Borderlands 4"],
      ],
      [["360"], ["360"], ["360"], ["Windows"], []]
    ),
    new Series(
      "Tales from the Borderlands",
      "Tall Tale Vault Hunter",
      null,
      [
        ["Tales from the Borderlands", "Tales from the Borderlands (Xbox 360)"],
        ["New Tales From The Borderlands"],
      ],
      [["360"], []]
    ),
    new Series(
      "Wonderlands",
      "Chaotic Great Vault Hunter",
      null,
      [
        [
          "Tiny Tina's Assault on Dragon Keep: A Wonderlands One-shot Adventure",
        ],
        ["Tiny Tina's Wonderlands"],
      ],
      [[], []]
    ),
    new Series(
      "Bossa Studios's I Am",
      "I Am Iron Bread",
      null,
      [["I Am Bread"], ["I Am Fish"]],
      [[], []]
    ),
    new Series(
      "Brawlhalla",
      "Chosen Legend",
      "#FFEC2C",
      [["Brawlhalla"]],
      [[]]
    ),
    new Series(
      "Bud Spencer & Terence Hill",
      "Banana Joe",
      null,
      [
        ["Bud Spencer & Terence Hill - Slaps And Beans"],
        ["Bud Spencer & Terence Hill - Slaps and Beans 2"],
      ],
      [[], []]
    ),
    new Series(
      "Call of Duty",
      "Mile High Club",
      "#92B853 #F46000",
      [
        ["Call of Duty 2"],
        ["Call of Duty 3"],
        [
          "Call of Duty 4: Modern Warfare Remastered",
          "Call of Duty 4: Modern Warfare Remastered (Xbox 360)",
          "Call of Duty 4: Modern Warfare Remastered (Windows)",
        ],
        ["Call of Duty: World at War"],
        [
          "Call of Duty: Modern Warfare 2 Campaign Remastered",
          "Call of Duty: Modern Warfare 2 Campaign Remastered (Xbox 360)",
          "Call of Duty: Modern Warfare 2 Campaign Remastered (Windows)",
        ],
        ["Call of Duty: Black Ops"],
        [
          "Call of Duty: Modern Warfare 3",
          "Call of Duty: Modern Warfare 3 (Windows)",
        ],
        ["Call of Duty: Black Ops II", "Call of Duty: Black Ops II (Windows)"],
        [
          "Call of Duty: Ghosts",
          "Call of Duty: Ghosts (Xbox 360)",
          "Call of Duty: Ghosts (Windows)",
        ],
        [
          "Call of Duty: Advanced Warfare",
          "Call of Duty: Advanced Warfare (Xbox 360)",
          "Call of Duty: Advanced Warfare (Windows)",
        ],
        [
          "Call of Duty: Black Ops III",
          "Call of Duty: Black Ops III (Xbox 360)",
          "Call of Duty: Black Ops III (Windows)",
        ],
        [
          "Call of Duty: Infinite Warfare",
          "Call of Duty: Infinite Warfare (Windows)",
        ],
        ["Call of Duty: WWII", "Call of Duty: WWII (Windows)"],
        ["Call of Duty: Black Ops 4"],
        ["Call of Duty: Modern Warfare"],
        ["Call of Duty: Black Ops Cold War"],
        ["Call of Duty: Vanguard"],
        ["Call of Duty"],
      ],
      [
        [],
        [],
        ["360", "Windows"],
        [],
        ["360", "Windows"],
        [],
        ["Windows"],
        ["Windows"],
        ["360", "Windows"],
        ["360", "Windows"],
        ["360", "Windows"],
        ["Windows"],
        ["Windows"],
        [],
        [],
        [],
        [],
        [],
      ]
    ),
    new Series(
      "Call of Duty: Modern Warfare",
      "I'm the Juggernaut…",
      null,
      [
        [
          "Call of Duty 4: Modern Warfare Remastered",
          "Call of Duty 4: Modern Warfare Remastered (Xbox 360)",
          "Call of Duty 4: Modern Warfare Remastered (Windows)",
        ],
        [
          "Call of Duty: Modern Warfare 2 Campaign Remastered",
          "Call of Duty: Modern Warfare 2 Campaign Remastered (Xbox 360)",
          "Call of Duty: Modern Warfare 2 Campaign Remastered (Windows)",
        ],
        [
          "Call of Duty: Modern Warfare 3",
          "Call of Duty: Modern Warfare 3 (Windows)",
        ],
      ],
      [["360", "Windows"], ["360", "Windows"], ["Windows"]]
    ),
    new Series(
      "Call of Duty: Black Ops",
      "...And I Will Have My Revenge",
      null,
      [
        ["Call of Duty: World at War"],
        ["Call of Duty: Black Ops", "Call of Duty: Black Ops (Windows)"],
        ["Call of Duty: Black Ops II", "Call of Duty: Black Ops II (Windows)"],
        [
          "Call of Duty: Black Ops III",
          "Call of Duty: Black Ops III (Xbox 360)",
          "Call of Duty: Black Ops III (Windows)",
        ],
        ["Call of Duty: Black Ops 4"],
      ],
      [[], ["Windows"], ["Windows"], ["360", "Windows"], []]
    ),
    new Series(
      "Call of Duty: Independent",
      "The Ghost Killer",
      null,
      [
        [
          "Call of Duty: Ghosts",
          "Call of Duty: Ghosts (Xbox 360)",
          "Call of Duty: Ghosts (Windows)",
        ],
        [
          "Call of Duty: Advanced Warfare",
          "Call of Duty: Advanced Warfare (Xbox 360)",
          "Call of Duty: Advanced Warfare (Windows)",
        ],
        [
          "Call of Duty: Infinite Warfare",
          "Call of Duty: Infinite Warfare (Windows)",
        ],
      ],
      [["360", "Windows"], ["360", "Windows"], ["Windows"]]
    ),
    new Series(
      "Call of Duty: Warzone",
      "Personal Decorator",
      null,
      [
        ["Call of Duty: World at War"],
        ["Call of Duty: Black Ops", "Call of Duty: Black Ops (Windows)"],
        ["Call of Duty: WWII", "Call of Duty: WWII (Windows)"],
        ["Call of Duty: Modern Warfare"],
        ["Call of Duty: Black Ops Cold War"],
        ["Call of Duty: Vanguard"],
        ["Call of Duty"],
      ],
      [[], ["Windows"], ["Windows"], [], [], [], []]
    ),
    new Series(
      "Call of Juarez",
      "Last Man Standing",
      null,
      [
        ["Call of Juarez: Bound in Blood"],
        ["Call of Juarez: The Cartel"],
        ["Call of Juarez: Gunslinger"],
      ],
      [[], [], []]
    ),
    new Series(
      "Call of the Wild",
      "The Apex Heartbreaker",
      null,
      [["theHunter: Call of the Wild"], ["Call of the Wild: The Angler"]],
      [[], []]
    ),
    new Series(
      "Capcom Fighting Collection",
      "Night Warrior",
      null,
      [["Capcom Fighting Collection"], ["Capcom Fighting Collection 2"]],
      [[], []]
    ),
    new Series(
      "Capcom Arcade",
      "CapcoMaster",
      null,
      [
        ["CAPCOM Arcade Cabinet"],
        ["Capcom Arcade Stadium"],
        ["Capcom Arcade 2nd Stadium"],
      ],
      [[], [], []]
    ),
    new Series(
      "Cars",
      "Speed. I Am Speed.",
      null,
      [
        ["Cars: Mater-National Championship"],
        ["Cars 2: The Video Game"],
        ["Cars 3: Driven to Win", "Cars 3: Driven to Win (Xbox 360)"],
      ],
      [[], [], ["360"]]
    ),
    new Series(
      "CASE",
      "LAST RETAR",
      null,
      [["CASE: Animatronics"], ["CASE 2: Animatronics Survival"]],
      [[], []]
    ),
    new Series(
      "CastleStorm",
      "Upgrayedded",
      null,
      [
        [
          "CastleStorm \u2013 Definitive Edition",
          "CastleStorm \u2013 Definitive Edition (Xbox 360)",
        ],
        ["CastleStorm II"],
      ],
      [["360"], []]
    ),
    new Series(
      "Castlevania + Bloodstained",
      "Bloodstained Belmont",
      "#CE135F #FFDD04",
      [
        ["Castlevania Anniversary Collection"],
        ["Castlevania Advance Collection"],
        ["Castlevania Dominus Collection"],
        ["Castlevania: Symphony of the Night"],
        ["Castlevania: Harmony of Despair"],
        ["Castlevania: Lords of Shadow"],
        ["Castlevania: Lords of Shadow - Mirror of Fate HD"],
        ["Castlevania: Lords of Shadow 2"],
        ["Bloodstained: Curse of the Moon"],
        ["Bloodstained: Curse of the Moon 2"],
        [
          "Bloodstained: Ritual of the Night",
          "Bloodstained: Ritual of the Night (Windows)",
        ],
        ["Bloodstained: The Scarlet Entanglement"],
      ],
      [[], [], [], [], [], [], [], [], [], [], ["Windows"], []]
    ),
    new Series(
      "Castlevania",
      "Vampire Killer",
      null,
      [
        ["Castlevania Anniversary Collection"],
        ["Castlevania Advance Collection"],
        ["Castlevania Dominus Collection"],
        ["Castlevania: Symphony of the Night"],
        ["Castlevania: Harmony of Despair"],
      ],
      [[], [], [], [], []]
    ),
    new Series(
      "Lord of Shadows",
      "Prince of Darkness",
      null,
      [
        ["Castlevania: Lords of Shadow"],
        ["Castlevania: Lords of Shadow - Mirror of Fate HD"],
        ["Castlevania: Lords of Shadow 2"],
      ],
      [[], [], []]
    ),
    new Series(
      "Bloodstained",
      "Demon Killer",
      null,
      [
        ["Bloodstained: Curse of the Moon"],
        ["Bloodstained: Curse of the Moon 2"],
        [
          "Bloodstained: Ritual of the Night",
          "Bloodstained: Ritual of the Night (Windows)",
        ],
        ["Bloodstained: The Scarlet Entanglement"],
      ],
      [[], [], ["Windows"], []]
    ),
    new Series(
      "Cat Quest",
      "Pawlatinum Meowster",
      null,
      [["Cat Quest ll"], ["Cat Quest lll"]],
      [[], []]
    ),
    new Series(
      "Cats and Seek",
      "Her Royal Catness",
      null,
      [["Cats and Seek: Osaka"], ["Cats and Seek: Dino Park"]],
      [[], []]
    ),
    new Series(
      "Cave Digger",
      "Space Whale",
      null,
      [["Cave Digger"], ["Cave Digger 2"]],
      [[], []]
    ),
    new Series(
      "Century: Age of Ashes",
      "Born of the Sea of Flame",
      null,
      [["Century: Age of Ashes"]],
      [[]]
    ),
    new Series(
      "Chroma",
      "Teslamancer",
      null,
      [["Teslagrad Remastered"], ["Teslagrad 2"], ["World to the West"]],
      [[], [], []]
    ),
    new Series(
      "Citizen Sleeper",
      "Starward",
      "#F7DD0C",
      [["Citizen Sleeper"], ["Citizen Sleeper 2: Starward Vector"]],
      [[], []]
    ),
    new Series(
      "Civilization",
      "That We May Live In Peace",
      null,
      [
        ["Sid Meier's Civilization Revolution"],
        ["Sid Meier's Civilization VI"],
        ["Sid Meier's Civilization VII"],
      ],
      [[], [], []]
    ),
    new Series("Clea", "War Maiden", null, [["Clea"], ["Clea 2"]], [[], []]),
    new Series(
      "Coffee Talk",
      "Barista Guru",
      "#BA8BDB",
      [
        ["Coffee Talk"],
        ["Coffee Talk Episode 2: Hibiscus and Butterfly"],
        ["Coffee Talk Tokyo"],
      ],
      [[], [], []]
    ),
    new Series(
      "Commandos",
      "Man of Courage",
      null,
      [
        ["Commandos 2 - HD Remaster"],
        ["Commandos 3 - HD Remaster"],
        ["Commandos: Origins"],
      ],
      [[], [], []]
    ),
    new Series(
      "Conan",
      "By This Axe I Rule!",
      null,
      [["Conan"], ["Conan Exiles"], ["Conan Chop Chop"]],
      [[], [], []]
    ),
    new Series(
      "Contra",
      "Headbanded Hero",
      null,
      [
        ["Contra Anniversary Collection"],
        ["CONTRA: ROGUE CORPS"],
        ["Contra: Operation Galuga"],
      ],
      [[], [], []]
    ),
    new Series(
      "Cook, Serve, Delicious!",
      "Stress Chef Supreme",
      null,
      [
        ["Cook, Serve, Delicious!"],
        ["Cook, Serve, Delicious! 2!!"],
        ["Cook, Serve, Delicious! 3?!"],
      ],
      [[], [], []]
    ),
    new Series(
      "Costume Quest",
      "Mask-O'-Raider",
      "#F8A41E",
      [["Costume Quest"], ["Costume Quest 2", "Costume Quest 2 (Xbox 360)"]],
      [[], ["360"]]
    ),
    new Series(
      "Cotton",
      "Willow Addict",
      null,
      [["Cotton 100%"], ["Panorama Cotton"]],
      [[], []]
    ),
    new Series(
      "Crackdown",
      "Key of the City",
      null,
      [
        ["Crackdown"],
        ["Crackdown 2"],
        ["Crackdown 3: Campaign"],
        ["Crackdown 3: Wrecking Zone"],
      ],
      [[], [], [], []]
    ),
    new Series(
      "Crash + Spyro",
      "N. Sane Dragon",
      "#FE592F #9370DB",
      [
        ["Crash Bandicoot N. Sane Trilogy"],
        ["Crash Bandicoot 4: It's About Time"],
        ["Crash Team Racing Nitro-Fueled"],
        ["Crash Team Rumble"],
        ["Spyro Reignited Trilogy"],
      ],
      [[], [], [], [], []]
    ),
    new Series(
      "Crash Bandicoot",
      "Blunder from Down Under",
      null,
      [
        ["Crash Bandicoot N. Sane Trilogy"],
        ["Crash Bandicoot 4: It's About Time"],
        ["Crash Team Racing Nitro-Fueled"],
        ["Crash Team Rumble"],
      ],
      [[], [], [], []]
    ),
    new Series(
      "Spyro the Dragon",
      "Title of the Dragon",
      null,
      [["Spyro Reignited Trilogy"]],
      [[]]
    ),
    new Series(
      "CRSED: F.O.A.D.",
      "Fulfillment of All Desires",
      null,
      [["CRSED: F.O.A.D."]],
      [[]]
    ),
    new Series(
      "Crysis",
      "They Call Me Prophet",
      "#9F200C",
      [
        ["Crysis Remastered", "Crysis Remastered (Xbox 360)"],
        ["Crysis 2 Remastered", "Crysis 2 Remastered (Xbox 360)"],
        ["Crysis 3 Remastered", "Crysis 3 Remastered (Xbox 360)"],
      ],
      [["360"], ["360"], ["360"]]
    ),
    new Series(
      "Danganronpa",
      "Desire for Despair",
      null,
      [
        ["Danganronpa: Trigger Happy Havoc Anniversary Edition"],
        ["Danganronpa 2: Goodbye Despair Anniversary Edition"],
        ["Danganronpa V3: Killing Harmony Anniversary Edition"],
      ],
      [[], [], []]
    ),
    new Series(
      "Dangerous",
      "Wreck-Tacular",
      null,
      [
        ["Danger Zone"],
        ["Danger Zone 2"],
        ["Dangerous Golf"],
        ["Dangerous Driving"],
      ],
      [[], [], [], []]
    ),
    new Series(
      "Dark Pictures Anthology",
      "The Curator of Stories",
      "#E5E1D5",
      [
        [
          "The Dark Pictures Anthology: Man of Medan",
          "The Dark Pictures Anthology: Man of Medan (Windows)",
        ],
        ["The Dark Pictures Anthology: Little Hope"],
        ["The Dark Pictures Anthology: House of Ashes"],
        ["The Dark Pictures Anthology: The Devil in Me"],
        ["Directive 8020: A Dark Pictures Game"],
      ],
      [["Windows"], [], [], [], []]
    ),
    new Series(
      "Darkest Dungeon",
      "Come Unto Your Maker",
      null,
      [
        ["Darkest Dungeon", "Darkest Dungeon (Windows)"],
        ["Darkest Dungeon II"],
      ],
      [["Windows"], []]
    ),
    new Series(
      "Darksiders",
      "Harbinger of Doom",
      "#C180E5",
      [
        [
          "Darksiders Warmastered Edition",
          "Darksiders Warmastered Edition (Xbox 360)",
        ],
        [
          "Darksiders II Deathinitive Edition",
          "Darksiders II Deathinitive Edition (Xbox 360)",
        ],
        ["Darksiders III", "Darksiders III (Windows)"],
        ["Darksiders Genesis", "Darksiders Genesis (Windows)"],
      ],
      [["360"], ["360"], ["Windows"], ["Windows"]]
    ),
    new Series(
      "Darwin Project",
      "I Do It for the Fans",
      null,
      [["Darwin Project"]],
      [[]]
    ),
    new Series("Dauntless", "Behemoth's Bane", null, [["Dauntless"]], [[]]),
    new Series(
      "Daymare",
      "H.A.D.E.S. Finest",
      null,
      [
        ["Daymare: 1998"],
        ["Daymare: 1994 Sandcastle", "Daymare: 1994 Sandcastle (Xbox One)"],
      ],
      [[], ["One"]]
    ),
    new Series(
      "DC Comics",
      "The Dark Knight",
      "#376B8C #000000",
      [
        ["Batman: Arkham Asylum", "Batman: Arkham Asylum (Xbox 360)"],
        ["Batman: Arkham City", "Batman: Arkham City (Xbox 360)"],
        ["Batman: Arkham Knight"],
        ["Suicide Squad: Kill the Justice League"],
        ["Gotham Knights"],
        ["DC Universe Online"],
        ["Injustice"],
        ["Injustice 2", "Injustice 2 (Windows)"],
        [
          "Batman: The Telltale Series",
          "Batman: The Telltale Series (Xbox 360)",
          "Batman: The Telltale Series (Windows)",
        ],
        [
          "Batman: The Enemy Within - The Telltale Series",
          "Batman: The Enemy Within - The Telltale Series (Windows)",
        ],
        ["LEGO Batman"],
        ["LEGO Batman 2: DC Super Heroes"],
        [
          "LEGO Batman 3: Beyond Gotham",
          "LEGO Batman 3: Beyond Gotham (Xbox 360)",
        ],
        ["LEGO DC Super-Villains"],
      ],
      [
        ["360"],
        ["360"],
        [],
        [],
        [],
        [],
        [],
        ["Windows"],
        ["360", "Windows"],
        ["Windows"],
        [],
        [],
        ["360"],
        [],
      ]
    ),
    new Series(
      "Batman: Arkham",
      "Enigma",
      null,
      [
        ["Batman: Arkham Asylum", "Batman: Arkham Asylum (Xbox 360)"],
        ["Batman: Arkham City", "Batman: Arkham City (Xbox 360)"],
        ["Batman: Arkham Knight"],
        ["Suicide Squad: Kill the Justice League"],
      ],
      [["360"], ["360"], [], []]
    ),
    new Series(
      "Batman: The Telltale Series",
      "Clown Prince of Crime",
      null,
      [
        [
          "Batman: The Telltale Series",
          "Batman: The Telltale Series (Xbox 360)",
          "Batman: The Telltale Series (Windows)",
        ],
        [
          "Batman: The Enemy Within - The Telltale Series",
          "Batman: The Enemy Within - The Telltale Series (Windows)",
        ],
      ],
      [["360", "Windows"], ["Windows"]]
    ),
    new Series(
      "DC Universe Online",
      "Champion of Earth",
      null,
      [["DC Universe Online"]],
      [[]]
    ),
    new Series(
      "Injustice",
      "Cupid of Crime",
      null,
      [["Injustice"], ["Injustice 2", "Injustice 2 (Windows)"]],
      [[], ["Windows"]]
    ),
    new Series(
      "LEGO DC Comics",
      "Boy Wonder",
      null,
      [
        ["LEGO Batman"],
        ["LEGO Batman 2: DC Super Heroes"],
        [
          "LEGO Batman 3: Beyond Gotham",
          "LEGO Batman 3: Beyond Gotham (Xbox 360)",
        ],
        ["LEGO DC Super-Villains"],
      ],
      [[], [], ["360"], []]
    ),
    new Series(
      "de Blob",
      "Paragon of Free Expression",
      null,
      [["de Blob"], ["de Blob 2", "de Blob 2 (Xbox 360)"]],
      [[], ["360"]]
    ),
    new Series(
      "Dead by Daylight",
      "The Iridescent One",
      "#A40308",
      [
        ["Dead by Daylight", "Dead by Daylight (Windows)"],
        ["The Casting of Frank Stone"],
      ],
      [["Windows"], []]
    ),
    new Series(
      "Dead Island",
      "Butcher of Banoi",
      "#FE3341",
      [
        [
          "Dead Island Definitive Edition",
          "Dead Island Definitive Edition (Xbox 360)",
        ],
        [
          "Dead Island: Riptide Definitive Edition",
          "Dead Island: Riptide Definitive Edition (Xbox 360)",
        ],
        ["Escape Dead Island"],
        ["Dead Island Retro Revenge"],
        ["Dead Island 2"],
      ],
      [["360"], ["360"], [], [], []]
    ),
    new Series(
      "Dead or Alive",
      "Kunoichi of Destiny",
      "#4254BA",
      [
        ["Dead or Alive 5 Last Round", "Dead or Alive 5 Last Round (Xbox 360)"],
        ["Dead or Alive 6"],
      ],
      [["360"], []]
    ),
    new Series(
      "Dead Rising",
      "7 Day Survivor",
      null,
      [
        [
          "Dead Rising Deluxe Remaster",
          "Dead Rising Deluxe Remaster (Xbox One)",
          "Dead Rising Deluxe Remaster (Xbox 360)",
        ],
        ["Dead Rising 2: Case Zero"],
        ["Dead Rising 2", "Dead Rising 2 (Xbox 360)"],
        ["Dead Rising 2: Case West"],
        [
          "Dead Rising 2: Off The Record",
          "Dead Rising 2: Off The Record (Xbox 360)",
        ],
        ["Dead Rising 3"],
        ["Dead Rising 4", "Dead Rising 4 (Windows)"],
      ],
      [["One", "360"], [], ["360"], [], ["360"], [], ["Windows"]]
    ),
    new Series(
      "Dead Space",
      "Epic Tier 4 Engineer",
      "#8CD4CC",
      [
        ["Dead Space (2008)"],
        ["Dead Space: Ignition"],
        ["Dead Space 2"],
        ["Dead Space 3"],
        ["Dead Space"],
      ],
      [[], [], [], [], []]
    ),
    new Series(
      "Deathsmiles",
      "True Tyrant",
      null,
      [["Deathsmiles I\u30fbII"], ["Deathsmiles"], ["Deathsmiles II X"]],
      [[], [], []]
    ),
    new Series("Deceit 2", "Master of Ritual", null, [["Deceit 2"]], [[]]),
    new Series(
      "Deep Rock Galactic",
      "ROCK & STONE",
      "#FCE306",
      [["Deep Rock Galactic"]],
      [[]]
    ),
    new Series(
      "Deliver Us",
      "Stargazer",
      null,
      [["Deliver Us The Moon"], ["Deliver Us Mars"]],
      [[], []]
    ),
    new Series(
      "Demon Slayer",
      "Dancer of the Fire God",
      null,
      [
        ["Demon Slayer -Kimetsu no Yaiba- The Hinokami Chronicles"],
        ["Demon Slayer -Kimetsu no Yaiba- The Hinokami Chronicles 2"],
        ["Demon Slayer -Kimetsu no Yaiba- Sweep the Board!"],
      ],
      [[], [], []]
    ),
    new Series(
      "Deponia",
      "Inspector Trash Vest",
      null,
      [
        ["Deponia"],
        ["Chaos On Deponia"],
        ["Goodbye Deponia"],
        ["Deponia Doomsday"],
      ],
      [[], [], [], []]
    ),
    new Series(
      "Despot",
      "Super Munchkin!",
      null,
      [["Despotism 3k"], ["Despot's Game"], ["Slime 3K: Rise Against Despot"]],
      [[], [], []]
    ),
    new Series(
      "Destiny",
      "Humanity's Chosen",
      "#D1CAC3",
      [["Destiny", "Destiny (Xbox 360)"], ["Destiny 2"]],
      [["360"], []]
    ),
    new Series(
      "Destroy All Humans!",
      "Cryptosporidium",
      null,
      [
        ["Destroy All Humans!", "Destroy All Humans! (Windows)"],
        ["Destroy All Humans! - Clone Carnage"],
        [
          "Destroy All Humans! 2: Reprobed",
          "Destroy All Humans! 2: Reprobed (Xbox One)",
        ],
      ],
      [["Windows"], [], ["One"]]
    ),
    new Series(
      "Deus Ex",
      "Deus ex Machina",
      null,
      [["Deus Ex: Human Revolution"], ["Deus Ex: Mankind Divided"]],
      [[], []]
    ),
    new Series(
      "Devil May Cry",
      "Danced with the Devil",
      null,
      [
        [
          "Devil May Cry HD Collection",
          "Devil May Cry HD Collection (Xbox 360)",
        ],
        [
          "Devil May Cry 4 Special Edition",
          "Devil May Cry 4 Special Edition (Xbox 360)",
        ],
        ["Devil May Cry 5 Special Edition"],
        [
          "DmC: Devil May Cry: Definitive Edition",
          "DmC: Devil May Cry: Definitive Edition (Xbox 360)",
        ],
      ],
      [["360"], ["360"], [], ["360"]]
    ),
    new Series(
      "Diablo",
      "Dark Lord of Hellfire",
      null,
      [
        ["Diablo II: Resurrected"],
        ["Diablo III: Reaper of Souls - Ultimate Evil Edition"],
        ["Diablo IV"],
      ],
      [[], [], []]
    ),
    new Series(
      "Diabolical Mind",
      "Demonic Lunar Goddess",
      null,
      [["Xenon Valkyrie+"], ["Riddled Corpses EX"], ["Demon's Tier+"]],
      [[], [], []]
    ),
    new Series(
      "DiRT",
      "43 Forever",
      null,
      [
        ["DiRT Rally"],
        ["DiRT Rally 2.0", "DiRT Rally 2.0 (Windows)"],
        ["DiRT 4"],
        ["DIRT 5"],
      ],
      [[], ["Windows"], [], []]
    ),
    new Series(
      "Disney",
      "Little Blue Wrecking Ball",
      null,
      [
        ["Disney Universe"],
        ["The Disney Afternoon Collection"],
        ["Disney Classic Games: Aladdin and The Lion King"],
        ["Rush: A Disney Pixar Adventure"],
        ["Disneyland Adventures"],
        ["Disney Dreamlight Valley"],
        ["Disney Speedstorm"],
      ],
      [[], [], [], [], [], [], []]
    ),
    new Series(
      "Divinity",
      "Ego Draconis",
      null,
      [
        ["Divinity: Original Sin - Enhanced Edition"],
        ["Divinity: Original Sin 2 - Definitive Edition"],
      ],
      [[], []]
    ),
    new Series(
      "Doctor Who",
      "Ka Faraq Gatri",
      "#003865",
      [
        ["Doctor Who: The Lonely Assassins"],
        ["Doctor Who: The Edge of Reality"],
      ],
      [[], []]
    ),
    new Series(
      "Don't Starve",
      "The Nightmare King",
      null,
      [["Don't Starve: Giant Edition"], ["Don't Starve Together"]],
      [[], []]
    ),
    new Series(
      "Doodle",
      "Master of the Worlds",
      "#21BBFE",
      [
        ["Doodle Mafia: Crime City"],
        ["Doodle God: Evolution"],
        ["Doodle Devil: 3volution"],
      ],
      [[], [], []]
    ),
    new Series(
      "DOOM",
      "The Only Thing They Fear",
      "#CB5E29 #C90E21",
      [
        ["DOOM (1993)"],
        ["DOOM II (Classic)"],
        ["DOOM + DOOM II"],
        ["DOOM 64"],
        ["DOOM 3", "DOOM 3 (Xbox 360)"],
        ["DOOM: The Dark Ages"],
        ["DOOM"],
        ["DOOM Eternal", "DOOM Eternal (Windows)"],
      ],
      [[], [], [], [], ["360"], [], [], ["Windows"]]
    ),
    new Series(
      "DOOM (Collection)",
      "The Icon of Sin",
      null,
      [["DOOM + DOOM II"]],
      [[]]
    ),
    new Series(
      "DOOM (Guy)",
      "Rip & Tear, Until It Is Done",
      null,
      [["DOOM (1993)"], ["DOOM II (Classic)"], ["DOOM 64"]],
      [[], [], []]
    ),
    new Series(
      "DOOM (Marine)",
      "BFG Division",
      null,
      [["DOOM 3", "DOOM 3 (Xbox 360)"]],
      [["360"]]
    ),
    new Series(
      "DOOM (Rebirth)",
      "Harbinger of Flesh & Metal",
      null,
      [["DOOM: The Dark Ages"]],
      [[]]
    ),
    new Series(
      "DOOM (Slayer)",
      "Send Unto Them...Only Me",
      null,
      [["DOOM"], ["DOOM Eternal", "DOOM Eternal (Windows)"]],
      [[], ["Windows"]]
    ),
    new Series(
      "Doom & Destiny",
      "I know EVERYTHING!",
      null,
      [["Doom & Destiny"], ["Doom & Destiny Worlds"], ["Nerd Survivors"]],
      [[], [], []]
    ),
    new Series(
      "Double Dragon",
      "Way of the Dragon",
      null,
      [
        ["DOUBLE DRAGON"],
        ["DOUBLE DRAGON ll: The Revenge"],
        ["DOUBLE DRAGON lll: The Sacred Stones"],
        ["Super Double Dragon"],
        ["DOUBLE DRAGON 4"],
        ["Double Dragon Advance"],
        ["Double Dragon Gaiden: Rise Of The Dragons"],
        ["Double Dragon Revive"],
      ],
      [[], [], [], [], [], [], [], []]
    ),
    new Series(
      "Dragon Age",
      "Dragon's Bane",
      null,
      [
        ["Dragon Age: Origins"],
        ["Dragon Age II"],
        ["Dragon Age: Inquisition"],
        ["Dragon Age: The Veilguard"],
      ],
      [[], [], [], []]
    ),
    new Series(
      "Dragon Ball",
      "Ultra Instinct Mastered",
      null,
      [
        ["Dragon Ball XenoVerse", "Dragon Ball XenoVerse (Xbox 360)"],
        ["Dragon Ball XenoVerse 2"],
        ["Dragon Ball FighterZ", "Dragon Ball FighterZ (Windows)"],
        ["Dragon Ball Z: Kakarot"],
        ["Dragon Ball: The Breakers"],
        ["Dragon Ball: Sparking! ZERO"],
      ],
      [["360"], [], ["Windows"], [], [], []]
    ),
    new Series(
      "Dragon Quest",
      "Erdrick",
      null,
      [
        ["DRAGON QUEST XI S: Echoes of an Elusive Age"],
        ["DRAGON QUEST Builders 2"],
        ["Infinity Strash: DRAGON QUEST The Adventure of Dai"],
        ["DRAGON QUEST I & II HD-2D Remake"],
        ["DRAGON QUEST lll HD-2D Remake"],
      ],
      [[], [], [], [], []]
    ),
    new Series(
      "Dragon's Dogma",
      "Awakened One",
      null,
      [["Dragon's Dogma: Dark Arisen"], ["Dragon's Dogma 2"]],
      [[], []]
    ),
    new Series(
      "Draw a Stickman",
      "Epic Stickman",
      null,
      [["Draw a Stickman: EPIC"], ["Draw a Stickman: EPIC 2"]],
      [[], []]
    ),
    new Series(
      "Duck Detective",
      "Power of De-duck-tion",
      null,
      [
        ["Duck Detective: The Secret Salami"],
        ["Duck Detective: The Ghost of Glamping"],
      ],
      [[], []]
    ),
    new Series(
      "Duke Nukem",
      "Hail to the King",
      null,
      [
        ["Duke Nukem 3D: 20th Anniversary Edition World Tour"],
        ["Duke Nukem: Manhattan Project"],
        ["Duke Nukem Forever"],
      ],
      [[], [], []]
    ),
    new Series(
      "DUNE",
      "Kwisatz Haderach",
      null,
      [["Dune: Spice Wars"], ["Dune: Imperium"], ["Dune: Awakening"]],
      [[], [], []]
    ),
    new Series(
      "Dungeon Defenders",
      "Champion of Etheria",
      null,
      [["Dungeon Defenders II"], ["Dungeon Defenders: Awakened"]],
      [[], []]
    ),
    new Series(
      "Dungeons & Dragons",
      "Dungeon Master",
      "#E0AE92 #FF000C",
      [
        ["Baldur's Gate: Dark Alliance"],
        ["Baldur's Gate: Dark Alliance II"],
        ["Baldur's Gate and Baldur's Gate II: Enhanced Editions"],
        ["Baldur's Gate 3"],
        ["Idle Champions of the Forgotten Realms"],
        ["Neverwinter Nights: Enhanced Edition"],
        ["Dungeons & Dragons Neverwinter Nights 2: Enhanced Edition"],
        ["Planescape: Torment and Icewind Dale: Enhanced Editions"],
      ],
      [[], [], [], [], [], [], [], []]
    ),
    new Series(
      "Baldur's Gate",
      "Hero of the Forgotten Realms",
      null,
      [
        ["Baldur's Gate: Dark Alliance"],
        ["Baldur's Gate: Dark Alliance II"],
        ["Baldur's Gate and Baldur's Gate II: Enhanced Editions"],
        ["Baldur's Gate 3"],
      ],
      [[], [], [], []]
    ),
    new Series(
      "Idle Champions",
      "Messenger of the Kitten Lord",
      null,
      [["Idle Champions of the Forgotten Realms"]],
      [[]]
    ),
    new Series(
      "Neverwinter Nights",
      "Dying Light",
      null,
      [
        ["Dying Light"],
        ["Dying Light 2: Stay Human"],
        ["Dying Light: The Beast"],
      ],
      [[], [], []]
    ),
    new Series(
      "EA Sports",
      "Future of the Franchise",
      null,
      [
        ["EA SPORTS College Football 26"],
        ["EA SPORTS FC 25"],
        ["EA SPORTS Madden NFL 25"],
        ["EA SPORTS NHL 25"],
        ["EA SPORTS PGA Tour"],
        ["EA SPORTS UFC 5"],
        ["EA SPORTS WRC"],
      ],
      [[], [], [], [], [], [], []]
    ),
    new Series(
      "Earth Defense Force",
      "Infernal Master Destroyer Deluxe",
      null,
      [
        ["Earth Defense Force 2017"],
        ["Earth Defense Force: Insect Armageddon"],
        ["Earth Defense Force 2025"],
      ],
      [[], [], []]
    ),
    new Series(
      "Eiyuden Chronicle",
      "108th Star of Destiny",
      null,
      [["Eiyuden Chronicle: Rising"], ["Eiyuden Chronicle: Hundred Heroes"]],
      [[], []]
    ),
    new Series(
      "Elemental War",
      "Elementalist",
      null,
      [["Elemental War TD"], ["Elemental War 2"]],
      [[], []]
    ),
    new Series(
      "ELEX",
      "Commander of the 6th Power",
      null,
      [["ELEX"], ["ELEX II"]],
      [[], []]
    ),
    new Series(
      "Emily Wants to Play",
      "MLG Pizza Deliverer",
      null,
      [["Emily Wants to Play"], ["Emily Wants to Play Too"], ["Pacify"]],
      [[], [], []]
    ),
    new Series(
      "ENDER",
      "Umbral Knight",
      null,
      [
        ["ENDER LILIES: Quietus of the Knights"],
        ["ENDER MAGNOLIA: Bloom in the Mist"],
      ],
      [[], []]
    ),
    new Series("Enlisted", "Outlisted", null, [["Enlisted"]], [[]]),
    new Series(
      "Epic Mickey",
      "Mousetastic",
      null,
      [
        ["Disney Epic Mickey: Rebrushed"],
        ["Disney Epic Mickey 2: The Power of Two"],
      ],
      [[], []]
    ),
    new Series(
      "EVERSPACE",
      "No Asteroid Unturned",
      null,
      [["EVERSPACE"], ["EVERSPACE 2"]],
      [[], []]
    ),
    new Series(
      "F1",
      "The Red Baron",
      null,
      [
        ["F1 23"],
        ["F1 24"],
        ["F1 25"],
        ["F1 Manager 2023"],
        ["F1 Manager 2024"],
      ],
      [[], [], [], [], []]
    ),
    new Series(
      "Fable",
      "Ruler of Albion",
      "#59BFD9",
      [
        ["Fable II Pub Games"],
        ["Fable II"],
        ["Fable III"],
        ["Fable Heroes"],
        ["Fable"],
      ],
      [[], [], [], [], []]
    ),
    new Series(
      "Falconeer",
      "Warbird of Great Ursee",
      null,
      [["The Falconeer"], ["Bulwark Evolution: Falconeer Chronicles"]],
      [[], []]
    ),
    new Series(
      "Fall Guys",
      "Golden Guy",
      "#F964B6",
      [["Fall Guys"], ["Stumble Guys"]],
      [[], []]
    ),
    new Series(
      "Fallout",
      "Legend of the Wastes",
      "#487AB6 #FAEF70",
      [
        ["Fallout 3"],
        ["Fallout New Vegas"],
        ["Fallout 4"],
        ["Fallout 76", "Fallout 76 (Windows)"],
        ["Fallout Shelter"],
      ],
      [[], [], [], ["Windows"], []]
    ),
    new Series(
      "Fallout (RPG)",
      "The Lone Wanderer",
      null,
      [["Fallout 3"], ["Fallout New Vegas"], ["Fallout 4"]],
      [[], [], []]
    ),
    new Series(
      "Fallout 76",
      "Vault Dweller",
      null,
      [["Fallout 76", "Fallout 76 (Windows)"]],
      [["Windows"]]
    ),
    new Series(
      "Fallout Shelter",
      "Vault Overseer",
      null,
      [["Fallout Shelter"]],
      [[]]
    ),
    new Series(
      "FAR",
      "Lone Toe",
      null,
      [["FAR: Lone Sails"], ["FAR: Changing Tides"]],
      [[], []]
    ),
    new Series(
      "Far Cry",
      "Definition of Insanity",
      "#FFAC34",
      [
        ["Far Cry Classic"],
        ["Far Cry Instincts Predator"],
        ["Far Cry 3 Classic Edition", "Far Cry 3 Classic Edition (Xbox 360)"],
        [
          "Far Cry 3 Blood Dragon Classic Edition",
          "Far Cry 3 Blood Dragon Classic Edition (Xbox 360)",
        ],
        ["Far Cry 4", "Far Cry 4 (Xbox 360)"],
        ["Far Cry Primal"],
        ["Far Cry 5"],
        ["Far Cry New Dawn"],
        ["Far Cry 6"],
      ],
      [[], [], ["360"], ["360"], ["360"], [], [], [], []]
    ),
    new Series(
      "Farming Simulator",
      "Farmer's Favorite",
      null,
      [
        ["Farming Simulator 15", "Farming Simulator 15 (Xbox 360)"],
        ["Farming Simulator 17", "Farming Simulator 17 (Windows)"],
        ["Farming Simulator 19", "Farming Simulator 19 (Windows)"],
        ["Farming Simulator 22", "Farming Simulator 22 (Windows)"],
        ["Farming Simulator 25", "Farming Simulator 25 (Windows)"],
      ],
      [["360"], ["Windows"], ["Windows"], ["Windows"], ["Windows"]]
    ),
    new Series(
      "Fast & Furious",
      "I Don't Have Friends, I've Got Family",
      null,
      [
        ["Fast & Furious Crossroads"],
        ["Fast & Furious: Spy Racers Rise of SH1FT3R"],
      ],
      [[], []]
    ),
    new Series(
      "FATAL FRAME",
      "Voice of the Voiceless",
      null,
      [
        ["FATAL FRAME: Maiden of Black Water"],
        ["FATAL FRAME: Mask of the Lunar Eclipse"],
      ],
      [[], []]
    ),
    new Series(
      "Fatal Fury",
      "King of Fighters",
      null,
      [
        ["ACA NEOGEO FATAL FURY", "ACA NEOGEO FATAL FURY (Windows)"],
        ["ACA NEOGEO FATAL FURY 2", "ACA NEOGEO FATAL FURY 2 (Windows)"],
        ["ACA NEOGEO FATAL FURY 3", "ACA NEOGEO FATAL FURY 3 (Windows)"],
        [
          "ACA NEOGEO FATAL FURY SPECIAL",
          "ACA NEOGEO FATAL FURY SPECIAL (Windows)",
        ],
        [
          "ACA NEOGEO REAL BOUT FATAL FURY",
          "ACA NEOGEO REAL BOUT FATAL FURY (Windows)",
        ],
        [
          "ACA NEOGEO REAL BOUT FATAL FURY 2",
          "ACA NEOGEO REAL BOUT FATAL FURY 2 (Windows)",
        ],
        [
          "ACA NEOGEO REAL BOUT FATAL FURY SPECIAL",
          "ACA NEOGEO REAL BOUT FATAL FURY SPECIAL (Windows)",
        ],
        [
          "ACA NEOGEO GAROU: MARK OF THE WOLVES",
          "ACA NEOGEO GAROU: MARK OF THE WOLVES (Windows)",
        ],
        ["Fatal Fury: City of the Wolves"],
      ],
      [
        ["Windows"],
        ["Windows"],
        ["Windows"],
        ["Windows"],
        ["Windows"],
        ["Windows"],
        ["Windows"],
        ["Windows"],
        [],
      ]
    ),
    new Series(
      "F.E.A.R.",
      "Onryō",
      null,
      [
        ["F.E.A.R.: First Encounter Assault Recon"],
        ["F.E.A.R. Files"],
        ["F.E.A.R. 2: Project Origin"],
        ["F.E.A.R. 3"],
      ],
      [[], [], [], []]
    ),
    new Series(
      "Feeding Frenzy",
      "Frenzy Fanatic",
      null,
      [["Feeding Frenzy"], ["Feeding Frenzy 2: Shipwreck Showdown"]],
      [[], []]
    ),
    new Series(
      "Figment",
      "Back at the Surface",
      "#D1E75E",
      [["Figment: Journey Into the Mind"], ["Figment 2: Creed Valley"]],
      [[], []]
    ),
    new Series(
      "FINAL FANTASY",
      "LIVING LEGACY",
      "#484f9A #925399",
      [
        ["STRANGER OF PARADISE: FINAL FANTASY ORIGIN"],
        ["FINAL FANTASY"],
        ["FINAL FANTASY II"],
        ["FINAL FANTASY III"],
        ["FINAL FANTASY IV"],
        ["FINAL FANTASY V"],
        ["FINAL FANTASY VI"],
        ["CRISIS CORE -FINAL FANTASY VII- REUNION"],
        [
          "FINAL FANTASY VII REMAKE INTERGRADE",
          "FINAL FANTASY VII REMAKE INTERGRADE (Windows)",
        ],
        [
          "FINAL FANTASY VIII Remastered",
          "FINAL FANTASY VIII Remastered (Windows)",
        ],
        ["FINAL FANTASY IX"],
        [
          "FINAL FANTASY X/X-2 HD Remaster",
          "FINAL FANTASY X/X-2 HD Remaster (Windows)",
        ],
        [
          "FINAL FANTASY XII THE ZODIAC AGE",
          "FINAL FANTASY XII THE ZODIAC AGE (Windows)",
        ],
        ["FINAL FANTASY XIII", "FINAL FANTASY XIII (Windows)"],
        ["FINAL FANTASY XIII-2", "FINAL FANTASY XIII-2 (Windows)"],
        [
          "LIGHTNING RETURNS: FINAL FANTASY XIII",
          "LIGHTNING RETURNS: FINAL FANTASY XIII (Windows)",
        ],
        ["FINAL FANTASY TYPE-0 HD"],
        ["A KING'S TALE: FINAL FANTASY XV"],
        [
          "FINAL FANTASY XV POCKET EDITION HD",
          "FINAL FANTASY XV POCKET EDITION HD (Windows)",
        ],
        ["FINAL FANTASY XV MULTIPLAYER: COMRADES"],
        ["FINAL FANTASY XVI"],
        ["FINAL FANTASY TACTICS - The Ivalice Chron"],
        ["WORLD OF FINAL FANTASY MAXIMA"],
      ],
      [
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        ["Windows"],
        ["Windows"],
        [],
        ["Windows"],
        ["Windows"],
        ["Windows"],
        ["Windows"],
        ["Windows"],
        [],
        [],
        ["Windows"],
        [],
        [],
        [],
        [],
      ]
    ),
    new Series(
      "FINAL FANTASY I-VI",
      "LIGHTBRINGER OF LEGEND",
      null,
      [
        ["FINAL FANTASY"],
        ["FINAL FANTASY II"],
        ["FINAL FANTASY III"],
        ["FINAL FANTASY IV"],
        ["FINAL FANTASY V"],
        ["FINAL FANTASY VI"],
      ],
      [[], [], [], [], [], []]
    ),
    new Series(
      "FINAL FANTASY VII",
      "SOLDIER OF LEGEND",
      null,
      [
        ["CRISIS CORE -FINAL FANTASY VII- REUNION"],
        ["FINAL FANTASY VII", "FINAL FANTASY VII (Windows)"],
      ],
      [[], ["Windows"]]
    ),
    new Series(
      "FINAL FANTASY XIII",
      "WARRIOR GODDESS OF LEGEND",
      null,
      [
        ["FINAL FANTASY XIII", "FINAL FANTASY XIII (Windows)"],
        ["FINAL FANTASY XIII-2", "FINAL FANTASY XIII-2 (Windows)"],
        [
          "LIGHTNING RETURNS: FINAL FANTASY XIII",
          "LIGHTNING RETURNS: FINAL FANTASY XIII (Windows)",
        ],
      ],
      [["Windows"], ["Windows"], ["Windows"]]
    ),
    new Series(
      "FINAL FANTASY XIV",
      "ENDWALKER OF LEGEND",
      null,
      [["FINAL FANTASY XIV"]],
      [[]]
    ),
    new Series(
      "FINAL FANTASY XV",
      "TRUE KING OF LEGEND",
      null,
      [
        ["A KING'S TALE: FINAL FANTASY XV"],
        [
          "FINAL FANTASY XV POCKET EDITION HD",
          "FINAL FANTASY XV POCKET EDITION HD (Windows)",
        ],
        ["FINAL FANTASY XV MULTIPLAYER: COMRADES"],
      ],
      [[], ["Windows"], []]
    ),
    new Series(
      "Five Nights at Freddy's",
      "Help Wanted",
      null,
      [
        ["Five Nights at Freddy's"],
        ["Five Nights at Freddy's 2"],
        ["Five Nights at Freddy's 3"],
        ["Five Nights at Freddy's 4"],
        ["Five Nights at Freddy's: Sister Location"],
        ["Five Nights at Freddy's: Help Wanted"],
        ["Five Nights at Freddy's: Help Wanted 2"],
        ["Five Nights at Freddy's: Security Breach"],
        ["Five Nights at Freddy's: Into the Pit"],
        ["Freddy Fazbear's Pizzeria Simulator"],
        ["Ultimate Custom Night"],
      ],
      [[], [], [], [], [], [], [], [], [], [], []]
    ),
    new Series("For Honor", "Abaddon", null, [["For Honor"]], [[]]),
    new Series(
      "For The King",
      "Master of the Fahrul",
      null,
      [["For The King"], ["For The King II"]],
      [[], []]
    ),
    new Series("Fortnite", "The Looper", "#00A5F5", [["Fortnite"]], [[]]),
    new Series(
      "Forza",
      "All Your Race Are Belong To Us",
      "#FE7A45",
      [["Forza Horizon 5"], ["Forza Motorsport"]],
      [[], []]
    ),
    new Series("FragPunk", "Punk Mommy", null, [["FragPunk"]], [[]]),
    new Series(
      "Freddy Spaghetti",
      "Tony Macaroni",
      null,
      [["Freddy Spaghetti"], ["Freddy Spaghetti 2.0"]],
      [[], []]
    ),
    new Series(
      "Friday the 13th",
      "The Masked Killer",
      null,
      [["Friday the 13th: The Game"]],
      [[]]
    ),
    new Series(
      "Frogger",
      "Fearless Frog",
      null,
      [["Frogger"], ["Frogger 2"]],
      [[], []]
    ),
    new Series(
      "FRONT MISSION",
      "E.D.G.E. Master",
      null,
      [["FRONT MISSION 1st: Remake"], ["FRONT MISSION 2: Remake"]],
      [[], []]
    ),
    new Series(
      "Frostpunk",
      "Revered Leader",
      null,
      [
        ["Frostpunk: Console Edition", "Frostpunk: Console Edition (Windows)"],
        ["Frostpunk 2"],
      ],
      [["Windows"], []]
    ),
    new Series(
      "Full of Cats",
      "Feline Finder",
      null,
      [["A Building Full of Cats"], ["A Castle Full of Cats"]],
      [[], []]
    ),
    new Series(
      "Fullbright",
      "#GamerGateOpposer",
      null,
      [["Gone Home: Console Edition"], ["Tacoma"], ["Open Roads"]],
      [[], [], []]
    ),
    new Series(
      "Galaxian",
      "Demon of Death",
      null,
      [
        ["Galaga"],
        ["Galaga Legions"],
        ["Galaga Legions DX"],
        ["ARCADE GAME SERIES: GALAGA"],
      ],
      [[], [], [], []]
    ),
    new Series(
      "Gears of War",
      "Seriously Setlist",
      "#83E3FB #06204A",
      [
        ["Gears of War: E-Day"],
        ["Gears Tactics"],
        [
          "Gears of War: Reloaded",
          "Gears of War: Reloaded (Xbox One)",
          "Gears of War: Reloaded (Xbox 360)",
          "Gears of War: Reloaded (Windows)",
        ],
        ["Gears of War 4"],
        ["Gears 5"],
      ],
      [[], [], ["One", "360", "Windows"], [], []]
    ),
    new Series(
      "Gears of War (Locust Horde)",
      "Seriously Insane",
      null,
      [
        ["Gears of War: E-Day"],
        ["Gears Tactics"],
        [
          "Gears of War: Reloaded",
          "Gears of War: Reloaded (Xbox One)",
          "Gears of War: Reloaded (Xbox 360)",
          "Gears of War: Reloaded (Windows)",
        ],
      ],
      [[], [], ["One", "360", "Windows"]]
    ),
    new Series(
      "Gears of War (Swarm)",
      "Seriously Inconceivable",
      null,
      [["Gears of War 4"], ["Gears 5"]],
      [[], []]
    ),
    new Series(
      "Gems of War",
      "My Kingdom Smells of Rich Mahogany",
      null,
      [["Gems of War"]],
      [[]]
    ),
    new Series(
      "Geometric Sniper",
      "The Last Savior",
      null,
      [
        ["Geometric Sniper"],
        ["Geometric Sniper - Blood in Paris"],
        ["Geometric Sniper Z"],
      ],
      [[], [], []]
    ),
    new Series(
      "Geometry Wars",
      "Geometry Warrior",
      null,
      [
        ["Geometry Wars: Retro Evolved"],
        ["Geometry Wars: Retro Evolved\u00b2"],
        [
          "Geometry Wars\u00b3: Dimensions Evolved",
          "Geometry Wars\u00b3: Dimensions Evolved (Xbox 360)",
        ],
      ],
      [[], [], ["360"]]
    ),
    new Series(
      "Get-A-Grip Chip",
      "Got-A-Grip",
      null,
      [["Get-A-Grip Chip"], ["Get-A-Grip Chip and the Body Bugs"]],
      [[], []]
    ),
    new Series(
      "Ghostbusters",
      "Who You Gonna Call?",
      null,
      [
        ["Ghostbusters: Sanctum of Slime"],
        ["Ghostbusters"],
        [
          "Ghostbusters: The Video Game Remastered",
          "Ghostbusters: The Video Game Remastered (Xbox 360)",
        ],
        ["Ghostbusters: Spirits Unleashed"],
      ],
      [[], [], ["360"], []]
    ),
    new Series(
      "Ghostrunner",
      "Monolith of Humanity",
      "#FEED00",
      [["Ghostrunner"], ["Ghostrunner 2"]],
      [[], []]
    ),
    new Series(
      "G.I. Joe",
      "Real American Hero",
      null,
      [["G.I. JOE: Operation Blackout"], ["G.I. JOE: WRATH OF COBRA"]],
      [[], []]
    ),
    new Series(
      "Giana Sisters",
      "Owlverlord",
      null,
      [
        ["Giana Sisters: Twisted Dreams - Director's Cut"],
        ["Giana Sisters: Dream Runners"],
      ],
      [[], []]
    ),
    new Series(
      "Glass Masquerade",
      "Dream Weaver",
      "#622484",
      [["Glass Masquerade"], ["Glass Masquerade 2: Illusions"]],
      [[], []]
    ),
    new Series(
      "Goat Simulator",
      "I Am Goat",
      "#E0DFDD",
      [
        [
          "Goat Simulator",
          "Goat Simulator (Xbox 360)",
          "Goat Simulator (Windows)",
        ],
        ["Goat Simulator: Remastered"],
        ["Goat Simulator 3", "Goat Simulator 3 (Xbox One)"],
      ],
      [["360", "Windows"], [], ["One"]]
    ),
    new Series(
      "God of War",
      "Ghost of Sparta",
      "#9A1F1F",
      [
        ["God of War (PS3)"],
        ["God of War II"],
        ["God of War III Remastered"],
        ["God of War: Ascension"],
        ["God of War"],
        ["God of War Ragnar\u00f6k"],
      ],
      [[], [], [], [], [], []]
    ),
    new Series(
      "Golden Idol",
      "Effective Detective",
      null,
      [["The Case of the Golden Idol"], ["The Rise of the Golden Idol"]],
      [[], []]
    ),
    new Series(
      "Goosebumps",
      "Reader, Beware!",
      "#AAC63A",
      [
        ["Goosebumps: The Game", "Goosebumps: The Game (Xbox 360)"],
        ["Goosebumps Dead of Night"],
      ],
      [["360"], []]
    ),
    new Series(
      "Grand Theft Auto",
      "Criminal Mastermind",
      "#FEB36F",
      [
        ["Grand Theft Auto III \u2013 The Definitive Edition"],
        ["Grand Theft Auto: Vice City \u2013 The Definitive Edition"],
        [
          "Grand Theft Auto: San Andreas \u2013 The Definitive Edition",
          "Grand Theft Auto: San Andreas \u2013 The Definitive Edition (Xbox 360)",
        ],
        ["Grand Theft Auto IV"],
        [
          "Grand Theft Auto V",
          "Grand Theft Auto V (Xbox One)",
          "Grand Theft Auto V (Xbox One)",
          "Grand Theft Auto V (Windows)",
        ],
        ["Grand Theft Auto VI"],
      ],
      [[], [], ["360"], [], ["One", "One", "Windows"], []]
    ),
    new Series(
      "GRID",
      "Gone in 60 Seconds",
      null,
      [["GRID"], ["GRID Legends"]],
      [[], []]
    ),
    new Series(
      "Guacamelee!",
      "The Chosen Juan",
      "#123DC0",
      [["Guacamelee! Super Turbo Championship Edition"], ["Guacamelee! 2"]],
      [[], []]
    ),
    new Series(
      "Guilty Gear + BlazBlue",
      "Messiah Will Not Come",
      null,
      [
        ["Guilty Gear -Strive-"],
        ["BlazBlue: Chrono Phantasma EXTEND"],
        ["BlazBlue: Cross Tag Battle Special Edition"],
      ],
      [[], [], []]
    ),
    new Series(
      "GUNBIRD",
      "No. 1 Psikyo Shooter",
      null,
      [["GUNBIRD"], ["GUNBIRD 2"], ["GUNBARICH"]],
      [[], [], []]
    ),
    new Series(
      "Gundam",
      "White Shooting Star",
      null,
      [["SD Gundam Battle Alliance"]],
      [[]]
    ),
    new Series(
      "Gungeon",
      "Gungeon Master",
      null,
      [["Enter the Gungeon"], ["Exit the Gungeon"]],
      [[], []]
    ),
    new Series(
      "Gunvolt",
      "The Muse of Hope",
      null,
      [
        ["Azure Striker GUNVOLT"],
        ["Azure Striker GUNVOLT 2"],
        ["Azure Striker GUNVOLT 3"],
        ["Gunvolt Chronicles: Luminous Avenger iX"],
        ["Gunvolt Chronicles: Luminous Avenger iX 2"],
        ["GUNVOLT RECORDS: Cychronicle"],
      ],
      [[], [], [], [], [], []]
    ),
    new Series(
      "Habroxia",
      "Galactic Chaos",
      null,
      [["Habroxia"], ["Habroxia 2"]],
      [[], []]
    ),
    new Series(
      "Halo",
      "Hyper-Lethal Vector",
      "#507D2A #F6DD45",
      [
        [
          "Halo Wars: Definitive Edition",
          "Halo Wars: Definitive Edition (Xbox 360)",
        ],
        ["Halo: The Master Chief Collection"],
        ["Halo: Spartan Assault", "Halo: Spartan Assault (Windows)"],
        ["Halo 5: Guardians"],
        ["Halo Wars 2"],
        ["Halo Infinite"],
      ],
      [["360"], [], ["Windows"], [], [], []]
    ),
    new Series(
      "Bungie Saga",
      "Inheritor",
      null,
      [["Halo: The Master Chief Collection"]],
      [[]]
    ),
    new Series(
      "Reclaimer Saga",
      "Reclaimer",
      null,
      [
        ["Halo: The Master Chief Collection"],
        ["Halo 5: Guardians"],
        ["Halo Infinite"],
      ],
      [[], [], []]
    ),
    new Series(
      "Halo Wars",
      "Forerunner",
      null,
      [
        [
          "Halo Wars: Definitive Edition",
          "Halo Wars: Definitive Edition (Xbox 360)",
        ],
        ["Halo Wars 2"],
      ],
      [["360"], []]
    ),
    new Series(
      "Hammerwatch",
      "Hero of Hammerwatch",
      null,
      [
        ["Hammerwatch Anniversary Edition"],
        ["Hammerwatch II"],
        ["Heroes of Hammerwatch"],
      ],
      [[], [], []]
    ),
    new Series(
      "Hand of Fate",
      "Dungeon Dealer",
      null,
      [["Hand of Fate"], ["Hand of Fate 2"]],
      [[], []]
    ),
    new Series("Happy Wars", "Divine Hammer", null, [["Happy Wars"]], [[]]),
    new Series(
      "Harvest Moon",
      "Agriculture, I Am Thy King",
      null,
      [
        ["Harvest Moon: Mad Dash"],
        ["Harvest Moon: Light of Hope Special Edition Complete"],
        ["Harvest Moon: One World"],
        ["Harvest Moon: The Winds of Anthos"],
        [
          "Story of Seasons: Friends of Mineral Town",
          "Story of Seasons: Friends of Mineral Town (Windows)",
        ],
        ["Story of Seasons: A Wonderful Life"],
      ],
      [[], [], [], [], ["Windows"], []]
    ),
    new Series(
      "Hasbro Games",
      "Murph",
      null,
      [
        ["Battleship"],
        ["Boggle"],
        ["MONOPOLY Deal", "MONOPOLY Deal (Xbox 360)"],
        ["MONOPOLY Plus", "MONOPOLY Plus (Xbox 360)"],
        ["Risk", "Risk (Xbox 360)"],
        ["Risk: Urban Assault", "Risk: Urban Assault (Xbox 360)"],
        ["Scrabble"],
        ["Trivial Pursuit Live!", "Trivial Pursuit Live! (Xbox 360)"],
      ],
      [[], [], ["360"], ["360"], ["360"], ["360"], [], ["360"]]
    ),
    new Series(
      "Hatsune Miku",
      "The First Sound of the Future",
      "#94D1D2",
      [
        ["Hatsune Miku Logic Paint S"],
        ["Hatsune Miku Jigsaw Puzzle"],
        ["Hatsune Miku: The Planet Of Wonder And Fragment Of Wishes"],
      ],
      [[], [], []]
    ),
    new Series("HAWKED", "Hawk Tuah", null, [["HAWKED"]], [[]]),
    new Series(
      "Hazelight Studios",
      "It Took Two",
      "#F7C166",
      [
        [
          "Brothers: A Tale of Two Sons Remake",
          "Brothers: A Tale of Two Sons Remake (Xbox 360)",
        ],
        ["A Way Out"],
        ["It Takes Two"],
        ["Split Fiction"],
      ],
      [["360"], [], [], []]
    ),
    new Series(
      "Hellblade",
      "Goddess of Curses",
      "#20CECC",
      [
        [
          "Hellblade: Senua's Sacrifice",
          "Hellblade: Senua's Sacrifice (Windows)",
        ],
        ["Senua's Saga: Hellblade ll"],
      ],
      [["Windows"], []]
    ),
    new Series(
      "Hello Neighbor",
      "No More Fears",
      "#ADA1C2",
      [
        ["Hello Neighbor"],
        ["Hello Neighbor: Hide & Seek"],
        ["Secret Neighbor"],
        ["Hello Neighbor 2"],
        ["Hello Engineer"],
      ],
      [[], [], [], [], []]
    ),
    new Series(
      "Hexic",
      "Grand Pearl Pooh-Bah",
      null,
      [["Hexic HD"], ["Hexic 2"]],
      [[], []]
    ),
    new Series(
      "Hidden Cats",
      "Space Cat",
      "#6CE4C7",
      [
        ["Hidden Cats in Berlin"],
        ["Hidden Cats in London"],
        ["Hidden Cats in New York"],
        ["Hidden Cats in Paris"],
        ["Hidden Cats in Rome"],
        ["Hidden Cats in Santa's Realm"],
        ["Hidden Cats in Spooky Town"],
        ["Hidden Cats in Tokyo"],
      ],
      [[], [], [], [], [], [], [], []]
    ),
    new Series(
      "Hidden Through Time",
      "Hidden No More!",
      "#C2EEF4",
      [
        ["Hidden Through Time"],
        ["Hidden Through Time 2: Myths & Magic"],
        ["Hidden Through Time 2: Discovery"],
      ],
      [[], [], []]
    ),
    new Series(
      "Hitman",
      "Silent Assassin",
      null,
      [
        ["Hitman HD Pack"],
        ["Hitman: Blood Money HD", "Hitman: Blood Money HD (Xbox 360)"],
        ["Hitman: Absolution HD", "Hitman: Absolution HD (Xbox 360)"],
        ["Hitman: World of Assassination"],
      ],
      [[], ["360"], ["360"], []]
    ),
    new Series(
      "Hot Wheels",
      "World's Best Driver",
      null,
      [
        ["Hot Wheels Unleashed"],
        ["Hot Wheels Unleashed 2 - Turbocharged"],
        ["Hot Wheels Monster Trucks: Stunt Mayhem"],
      ],
      [[], [], []]
    ),
    new Series(
      "Hotline Miami",
      "1-800-GODDAMN",
      "#ED008C",
      [
        ["Hotline Miami Collection"],
        ["Hotline Miami"],
        ["Hotline Miami 2: Wrong Number"],
      ],
      [[], [], []]
    ),
    new Series(
      "House Flipper",
      "(╯°□°)╯︵ ƎSՈOH",
      "#F4C982",
      [["House Flipper"], ["House Flipper 2"]],
      [[], []]
    ),
    new Series(
      "How to Survive",
      "Searched and Dismembered",
      null,
      [
        ["How to Survive: Storm Warning Edition"],
        ["How to Survive 2"],
        ["Welcome to ParadiZe"],
      ],
      [[], [], []]
    ),
    new Series(
      "HoYoverse",
      "Infinitum",
      null,
      [["Genshin Impact"], ["Zenless Zone Zero"]],
      [[], []]
    ),
    new Series(
      "Hunting Simulator",
      "The Apex Headhunter",
      null,
      [
        ["Hunting Simulator"],
        ["Hunting Simulator 2", "Hunting Simulator 2 (Xbox One)"],
      ],
      [[], ["One"]]
    ),
    new Series(
      "Hyper Light",
      "VoidSprinter",
      "#18FBFF",
      [["Hyper Light Drifter"], ["Solar Ash"]],
      [[], []]
    ),
    new Series(
      "Hypnospace",
      "Kataklysmic",
      "#D741F2",
      [
        ["Hypnospace Outlaw"],
        ["Slayers X: Terminal Aftermath: Vengance of the Slayer"],
      ],
      [[], []]
    ),
    new Series(
      "Indiana Jones",
      "The Man With Too Many Names",
      "#EF3D29 #FAED53",
      [
        ["Indiana Jones and the Great Circle"],
        ["LEGO Indiana Jones: Original Adventures"],
        ["LEGO Indiana Jones 2: The Adventure Continues"],
      ],
      [[], [], []]
    ),
    new Series(
      "LEGO Indiana Jones",
      "Don't Call Me Junior",
      null,
      [
        ["LEGO Indiana Jones: Original Adventures"],
        ["LEGO Indiana Jones 2: The Adventure Continues"],
      ],
      [[], []]
    ),
    new Series(
      "Injection π23",
      "Self Death",
      null,
      [
        ["Injection \u03c023 'No Name, No Number'"],
        ["Injection \u03c023 'Ars regia'"],
      ],
      [[], []]
    ),
    new Series(
      "Jackbox Games",
      "Don't Know Jack",
      null,
      [
        ["The Jackbox Party Pack", "The Jackbox Party Pack (Xbox 360)"],
        ["The Jackbox Party Pack 2"],
        ["The Jackbox Party Pack 3"],
        ["The Jackbox Party Pack 4"],
        ["The Jackbox Party Pack 5"],
        ["The Jackbox Party Pack 6"],
        ["The Jackbox Party Pack 7"],
        ["The Jackbox Party Pack 8"],
        ["The Jackbox Party Pack 9"],
        ["The Jackbox Party Pack 10"],
      ],
      [["360"], [], [], [], [], [], [], [], [], []]
    ),
    new Series(
      "Jumanji",
      "Bravestone",
      null,
      [["Jumanji: The Video Game"], ["Jumanji: Wild Adventures"]],
      [[], []]
    ),
    new Series(
      "Jurassic Park",
      "All I Got Was This T-Shirt",
      "#F7221A #FBD126",
      [
        ["Jurassic Park: The Game"],
        ["Jurassic World Evolution"],
        ["Jurassic World Evolution 2"],
        ["Jurassic World Evolution 3"],
        ["Jurassic Park Classic Games Collection"],
        ["LEGO Jurassic World", "LEGO Jurassic World (Xbox 360)"],
      ],
      [[], [], [], [], [], ["360"]]
    ),
    new Series(
      "Jurassic World Evolution",
      "Life Finds A Way",
      null,
      [
        ["Jurassic World Evolution"],
        ["Jurassic World Evolution 2"],
        ["Jurassic World Evolution 3"],
      ],
      [[], [], []]
    ),
    new Series(
      "Just Cause",
      "Rico Was Here",
      "#D21717",
      [["Just Cause"], ["Just Cause 2"], ["Just Cause 3"], ["Just Cause 4"]],
      [[], [], [], []]
    ),
    new Series(
      "Karate Kid",
      "Ex-Degenerate",
      null,
      [
        ["The Karate Kid: Street Rumble"],
        ["Cobra Kai: The Karate Kid Saga Continues"],
      ],
      [[], []]
    ),
    new Series(
      "Katamari",
      "I ❤️ Katamari",
      "#97C94E",
      [
        ["Beautiful Katamari"],
        ["Katamari Damacy Reroll", "Katamari Damacy Reroll (Windows)"],
        ["We Love Katamari REROLL+ Royal Reverie"],
      ],
      [[], ["Windows"], []]
    ),
    new Series(
      "Keflings",
      "Endless Doug",
      "#4DC1F3",
      [
        ["A Kingdom for Keflings"],
        ["A World of Keflings", "A World of Keflings (Windows)"],
      ],
      [[], ["Windows"]]
    ),
    new Series(
      "Killer Instinct",
      "Natural Born Killer",
      null,
      [
        ["Killer Instinct Classic"],
        ["Killer Instinct 2 Classic"],
        ["Killer Instinct"],
      ],
      [[], [], []]
    ),
    new Series(
      "King Kong",
      "King of Beasts",
      null,
      [
        ["Peter Jackson's King Kong"],
        ["Skull Island: Rise of Kong"],
        ["Kong: Survivor Instinct"],
      ],
      [[], [], []]
    ),
    new Series(
      "Kingdom",
      "There Is No Greater Ruler Than Thou",
      null,
      [["Kingdom: New Lands"], ["Kingdom Two Crowns"], ["Kingdom Eighties"]],
      [[], [], []]
    ),
    new Series(
      "Kingdom Come: Deliverance",
      "Hardcore Henry",
      null,
      [["Kingdom Come: Deliverance"], ["Kingdom Come: Deliverance II"]],
      [[], []]
    ),
    new Series(
      "Kingdom Hearts",
      "Heart of Light",
      "#7084BA",
      [
        ["KINGDOM HEARTS - HD 1.5+2.5 ReMIX"],
        ["KINGDOM HEARTS HD 2.8 Final Chapter Prologue"],
        ["KINGDOM HEARTS III"],
        ["KINGDOM HEARTS Melody of Memory"],
      ],
      [[], [], [], []]
    ),
    new Series(
      "Kingdom Rush",
      "Supreme Defender",
      null,
      [["Kingdom Rush"], ["Kingdom Rush Frontiers"], ["Kingdom Rush Origins"]],
      [[], [], []]
    ),
    new Series(
      "Knight Squad",
      "Dreaded Knight",
      null,
      [["Knight Squad"], ["Knight Squad 2"]],
      [[], []]
    ),
    new Series(
      "Kona",
      "Le Survivant",
      "#FDEC88",
      [["Kona"], ["Kona ll: Brume"]],
      [[], []]
    ),
    new Series(
      "Kunio-kun",
      "Guardian of Nekketsu High",
      null,
      [
        ["Stay Cool, Kobayashi-san!: A River City Ransom Story"],
        ["River City Ransom"],
        ["River City Girls", "River City Girls (Windows)"],
        ["River City Girls Zero"],
        ["River City Girls 2"],
      ],
      [[], [], ["Windows"], [], []]
    ),
    new Series(
      "Layers of Fear",
      "Let Insanity Run",
      "#B26459",
      [["Layers of Fear"], ["Layers of Fear (2016)"], ["Layers of Fear 2"]],
      [[], [], []]
    ),
    new Series(
      "League of Legends",
      "Legendary",
      null,
      [
        ["Ruined King: A League of Legends Story"],
        ["The Mageseeker: A League of Legends Story"],
        ["CONVERGENCE: A League of Legends Story"],
        ["Song of Nunu: A League of Legends Story"],
      ],
      [[], [], [], []]
    ),
    new Series(
      "Left 4 Dead",
      "Zombicidal Maniac",
      null,
      [["Left 4 Dead"], ["Left 4 Dead 2"]],
      [[], []]
    ),
    new Series(
      "LEGO",
      "Master Builder",
      "#E51E26 #FFF000",
      [
        ["LEGO Star Wars II: The Original Trilogy"],
        ["LEGO Star Wars: The Complete Saga"],
        ["LEGO Indiana Jones: Original Adventures"],
        ["LEGO Batman"],
        ["LEGO Indiana Jones 2: The Adventure Continues"],
        ["LEGO Star Wars III: The Clone Wars"],
        ["LEGO Pirates of the Caribbean"],
        ["LEGO Batman 2: DC Super Heroes"],
        ["LEGO The Lord of the Rings"],
        ["LEGO Marvel Super Heroes", "LEGO Marvel Super Heroes (Xbox 360)"],
        ["The LEGO Movie Videogame", "The LEGO Movie Videogame (Xbox 360)"],
        ["LEGO The Hobbit", "LEGO The Hobbit (Xbox 360)"],
        [
          "LEGO Batman 3: Beyond Gotham",
          "LEGO Batman 3: Beyond Gotham (Xbox 360)",
        ],
        ["LEGO Jurassic World", "LEGO Jurassic World (Xbox 360)"],
        ["LEGO Dimensions", "LEGO Dimensions (Xbox 360)"],
        ["LEGO Marvel's Avengers", "LEGO Marvel's Avengers (Xbox 360)"],
        [
          "LEGO Star Wars: The Force Awakens",
          "LEGO Star Wars: The Force Awakens (Xbox 360)",
        ],
        ["LEGO Worlds"],
        ["LEGO CITY Undercover"],
        ["The LEGO NINJAGO Movie Video Game"],
        ["LEGO Marvel Super Heroes 2"],
        ["LEGO The Incredibles"],
        ["LEGO DC Super-Villains"],
        [
          "LEGO Harry Potter Collection",
          "LEGO Harry Potter Collection (Xbox One)",
        ],
        ["LEGO Harry Potter: Years 1-4"],
        ["LEGO Harry Potter: Years 5-7"],
        ["The LEGO Movie 2 Videogame"],
        ["LEGO Builder's Journey"],
        ["LEGO Star Wars: The Skywalker Saga"],
        ["LEGO Brawls"],
        ["LEGO Bricktales"],
        ["LEGO 2K Drive"],
        ["LEGO Voyagers"],
        ["LEGO Party!"],
      ],
      [
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        ["360"],
        ["360"],
        ["360"],
        ["360"],
        ["360"],
        ["360"],
        ["360"],
        ["360"],
        [],
        [],
        [],
        [],
        [],
        [],
        ["One"],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
      ]
    ),
    new Series(
      "LEGO DC Comics",
      "Boy Wonder",
      null,
      [
        ["LEGO Batman"],
        ["LEGO Batman 2: DC Super Heroes"],
        [
          "LEGO Batman 3: Beyond Gotham",
          "LEGO Batman 3: Beyond Gotham (Xbox 360)",
        ],
        ["LEGO DC Super-Villains"],
      ],
      [[], [], ["360"], []]
    ),
    new Series(
      "LEGO Disney",
      "Totally Wicked!",
      null,
      [["LEGO Pirates of the Caribbean"], ["LEGO The Incredibles"]],
      [[], []]
    ),
    new Series(
      "LEGO Harry Potter",
      "Unbrickable Spell",
      null,
      [
        [
          "LEGO Harry Potter Collection",
          "LEGO Harry Potter Collection (Xbox One)",
        ],
        ["LEGO Harry Potter: Years 1-4"],
        ["LEGO Harry Potter: Years 5-7"],
      ],
      [["One"], [], []]
    ),
    new Series(
      "LEGO Indiana Jones",
      "Raider of the Lost Brick",
      null,
      [
        ["LEGO Indiana Jones: Original Adventures"],
        ["LEGO Indiana Jones 2: The Adventure Continues"],
      ],
      [[], []]
    ),
    new Series(
      "LEGO Marvel",
      "Armored Avenger Assembled",
      null,
      [
        ["LEGO Marvel Super Heroes", "LEGO Marvel Super Heroes (Xbox 360)"],
        ["LEGO Marvel's Avengers", "LEGO Marvel's Avengers (Xbox 360)"],
        ["LEGO Marvel Super Heroes 2"],
      ],
      [["360"], ["360"], []]
    ),
    new Series(
      "LEGO Middle-earth",
      "Worth Greater Than the Shire",
      null,
      [
        ["LEGO The Lord of the Rings"],
        ["LEGO The Hobbit", "LEGO The Hobbit (Xbox 360)"],
      ],
      [[], ["360"]]
    ),
    new Series(
      "LEGO Movie",
      "Everything is Awesome!",
      null,
      [
        ["The LEGO Movie Videogame", "The LEGO Movie Videogame (Xbox 360)"],
        ["The LEGO Movie 2 Videogame"],
      ],
      [["360"], []]
    ),
    new Series(
      "LEGO Star Wars",
      "A Fine Addition to My Collection",
      null,
      [
        ["LEGO Star Wars II: The Original Trilogy"],
        ["LEGO Star Wars: The Complete Saga"],
        ["LEGO Star Wars III: The Clone Wars"],
        [
          "LEGO Star Wars: The Force Awakens",
          "LEGO Star Wars: The Force Awakens (Xbox 360)",
        ],
        ["LEGO Star Wars: The Skywalker Saga"],
      ],
      [[], [], [], ["360"], []]
    ),
    new Series(
      "Lethal League",
      "Ace Player",
      null,
      [["Lethal League"], ["Lethal League Blaze"]],
      [[], []]
    ),
    new Series(
      "Life is Strange + Lost Records",
      "Quintessential Hipster",
      "#F097A1 #35B8FE",
      [
        [
          "Life is Strange Remastered",
          "Life is Strange Remastered (Xbox One)",
          "Life is Strange Remastered (Xbox 360)",
        ],
        [
          "Life is Strange: Before the Storm Remastered",
          "Life is Strange: Before the Storm Remastered (Xbox One)",
        ],
        ["Life is Strange 2"],
        ["Life is Strange: True Colors"],
        ["Life is Strange: Double Exposure"],
        ["Tell Me Why"],
        ["Lost Records: Bloom & Rage"],
      ],
      [["One", "360"], ["One"], [], [], [], [], []]
    ),
    new Series(
      "Life is Strange",
      "Quintessential Punk",
      null,
      [
        [
          "Life is Strange Remastered",
          "Life is Strange Remastered (Xbox One)",
          "Life is Strange Remastered (Xbox 360)",
        ],
        [
          "Life is Strange: Before the Storm Remastered",
          "Life is Strange: Before the Storm Remastered (Xbox One)",
        ],
        ["Life is Strange 2"],
        ["Life is Strange: True Colors"],
        ["Life is Strange: Double Exposure"],
      ],
      [["One", "360"], ["One"], [], [], []]
    ),
    new Series(
      "Lost Records",
      "Quintessential Rocker",
      null,
      [["Lost Records: Bloom & Rage"], ["Tell Me Why"]],
      [[], []]
    ),
    new Series(
      "LISA",
      "Joyful Edgelord",
      null,
      [
        ["LISA: The Painful - Definitive Edition"],
        ["LISA: The Joyful - Definitive Edition"],
      ],
      [[], []]
    ),
    new Series(
      "Little Nightmares",
      "Little Lost Thing",
      null,
      [
        ["Little Nightmares"],
        ["Little Nightmares II"],
        ["Little Nightmares III"],
      ],
      [[], [], []]
    ),
    new Series(
      "Little Tail Bronx",
      "Shepherd of the Taranis",
      "#F3D265",
      [
        ["Fuga: Melodies of Steel"],
        ["Fuga: Melodies of Steel 2"],
        ["Fuga: Melodies of Steel 3"],
      ],
      [[], [], []]
    ),
    new Series(
      "Lonely Mountains",
      "King of Bikes and Master of Mountains",
      "#ECCC45",
      [["Lonely Mountains: Downhill"], ["Lonely Mountains: Snow Riders"]],
      [[], []]
    ),
    new Series(
      "Lords of the Fallen",
      "I Kill Dead People",
      null,
      [["Lords of the Fallen (2014)"], ["Lords of the Fallen"]],
      [[], []]
    ),
    new Series(
      "Lost in Random",
      "Embraced the Chaos Against All Odds",
      null,
      [["Lost In Random"], ["Lost in Random: The Eternal Die"]],
      [[], []]
    ),
    new Series(
      "Lost Planet",
      "E.X. Trooper",
      null,
      [["Lost Planet: Extreme Condition Colonies Edition"], ["Lost Planet 3"]],
      [[], []]
    ),
    new Series(
      "Lumines",
      "Black Belt Champion",
      null,
      [["Lumines Live!"], ["Lumines Remastered"]],
      [[], []]
    ),
    new Series(
      "Mafia",
      "Capo Dei Capi",
      "#BC9361",
      [
        ["Mafia: The Old Country"],
        ["Mafia: Definitive Edition"],
        [
          "Mafia II: Definitive Edition",
          "Mafia II: Definitive Edition (Xbox 360)",
        ],
        ["Mafia III: Definitive Edition"],
      ],
      [[], [], ["360"], []]
    ),
    new Series(
      "Mana",
      "Seiken Densetsu",
      null,
      [["Trials of Mana"], ["Legend of Mana"], ["Visions of Mana"]],
      [[], [], []]
    ),
    new Series(
      "Mara (Deiland)",
      "Keeper of Mara",
      "#84EF94",
      [
        ["Summer in Mara"],
        ["Koa and the Five Pirates of Mara"],
        ["Deiland: Pocket Planet"],
        ["Ankora: Lost Days"],
      ],
      [[], [], [], []]
    ),
    new Series(
      "Marvel Studios",
      "The Amazing Spider-Man",
      "#DF1D1D #447ABE",
      [
        ["The Amazing Spider-Man 2", "The Amazing Spider-Man 2 (Xbox 360)"],
        ["Deadpool", "Deadpool (Xbox 360)"],
        ["Marvel's Avengers"],
        ["Marvel's Guardians of the Galaxy"],
        ["Marvel's Midnight Suns", "Marvel's Midnight Suns (Xbox One)"],
        ["Marvel Rivals"],
        ["Ultimate Marvel vs. Capcom 3"],
        ["Marvel vs. Capcom: Infinite"],
        ["Marvel vs. Capcom Fighting Collection: Arcade Classics"],
        ["MARVEL Cosmic Invasion"],
        [
          "Marvel's Guardians of the Galaxy: The Telltale Series",
          "Marvel's Guardians of the Galaxy: The Telltale Series (Windows)",
        ],
        ["LEGO Marvel Superheroes", "LEGO Marvel Superheroes (Xbox 360)"],
        ["LEGO Marvel Superheroes 2"],
        ["LEGO Marvel Avengers", "LEGO Marvel Avengers (Xbox 360)"],
      ],
      [
        ["360"],
        ["360"],
        [],
        [],
        ["One"],
        [],
        [],
        [],
        [],
        [],
        ["Windows"],
        ["360"],
        [],
        ["360"],
      ]
    ),
    new Series(
      "LEGO Marvel",
      "Armored Avenger Assembled",
      null,
      [
        ["LEGO Marvel Super Heroes", "LEGO Marvel Super Heroes (Xbox 360)"],
        ["LEGO Marvel's Avengers", "LEGO Marvel's Avengers (Xbox 360)"],
        ["LEGO Marvel Super Heroes 2"],
      ],
      [["360"], ["360"], []]
    ),
    new Series(
      "Marvel's Guardians of the Galaxy",
      "89P13",
      null,
      [
        ["Marvel's Guardians of the Galaxy"],
        [
          "Marvel's Guardians of the Galaxy: The Telltale Series",
          "Marvel's Guardians of the Galaxy: The Telltale Series (Windows)",
        ],
      ],
      [[], ["Windows"]]
    ),
    new Series(
      "Marvel Rivals",
      "God Emperor Doom",
      null,
      [["Marvel Rivals"]],
      [[]]
    ),
    new Series(
      "Marvel vs. Capcom",
      "Weapon X",
      null,
      [
        ["Ultimate Marvel vs. Capcom 3"],
        ["Marvel vs. Capcom: Infinite"],
        ["Marvel vs. Capcom Fighting Collection: Arcade Classics"],
      ],
      [[], [], []]
    ),
    new Series(
      "Mass Effect",
      "SPECTRE",
      "#15A1F8",
      [
        ["Mass Effect Legendary Edition"],
        ["Mass Effect", "Mass Effect (Xbox 360)"],
        ["Mass Effect 2", "Mass Effect 2 (Xbox 360)"],
        ["Mass Effect 3", "Mass Effect 3 (Xbox 360)"],
        ["Mass Effect: Andromeda"],
      ],
      [[], ["360"], ["360"], ["360"], []]
    ),
    new Series("Mecha BREAK", "Cloudpiercer", null, [["Mecha BREAK"]], [[]]),
    new Series(
      "MechWarrior",
      "100-ton Atlas",
      null,
      [["MechWarrior 5: Mercenaries"], ["MechWarrior 5: Clans"]],
      [[], []]
    ),
    new Series(
      "Mega Man",
      "The Blue Bomber",
      "#2250C8 #6CD9F0",
      [
        ["Mega Man Legacy Collection"],
        ["Mega Man Legacy Collection 2"],
        ["Mega Man 11"],
        ["Mega Man X Legacy Collection"],
        ["Mega Man X Legacy Collection 2"],
        ["Mega Man Zero/ZX Legacy Collection"],
      ],
      [[], [], [], [], [], []]
    ),
    new Series(
      "Mega Man Classic",
      "Rockman",
      null,
      [
        ["Mega Man Legacy Collection"],
        ["Mega Man Legacy Collection 2"],
        ["Mega Man 11"],
        ["Mega Man X Legacy Collection"],
        ["Mega Man X Legacy Collection 2"],
      ],
      [[], [], [], [], []]
    ),
    new Series(
      "Meow Moments",
      "Cat Buddy",
      null,
      [
        ["Meow Moments: Celebrating Renewal & Romance"],
        ["Meow Moments: Celebrating Geeks & Athletes"],
      ],
      [[], []]
    ),
    new Series(
      "Metal Gear",
      "Snake Eater",
      "#B13324 #625A57",
      [
        ["Metal Gear & Metal Gear 2: Solid Snake"],
        ["Metal Gear Solid - MCV"],
        ["Metal Gear Solid 2: Sons of Liberty - MCV"],
        ["Metal Gear Solid 3: Snake Eater - MCV"],
        ["Metal Gear Solid: Peace Walker HD"],
        ["Metal Gear Rising: Revengeance"],
        [
          "Metal Gear Solid V: Ground Zeroes",
          "Metal Gear Solid V: Ground Zeroes (Xbox 360)",
        ],
        [
          "Metal Gear Solid V: The Phantom Pain",
          "Metal Gear Solid V: The Phantom Pain (Xbox 360)",
        ],
        ["Metal Gear Survive"],
      ],
      [[], [], [], [], [], [], ["360"], ["360"], []]
    ),
    new Series(
      "Metal Gear (Big Boss)",
      "The Man Who Sold the World",
      null,
      [
        ["Metal Gear Solid 3: Snake Eater - MCV"],
        ["Metal Gear Solid: Peace Walker HD"],
        [
          "Metal Gear Solid V: Ground Zeroes",
          "Metal Gear Solid V: Ground Zeroes (Xbox 360)",
        ],
        [
          "Metal Gear Solid V: The Phantom Pain",
          "Metal Gear Solid V: The Phantom Pain (Xbox 360)",
        ],
      ],
      [[], [], ["360"], ["360"]]
    ),
    new Series(
      "Metal Gear (Raiden)",
      "Jack the Ripper",
      null,
      [
        ["Metal Gear Solid 2: Sons of Liberty - MCV"],
        ["Metal Gear Rising: Revengeance"],
      ],
      [[], []]
    ),
    new Series(
      "Metal Gear (Solid Snake)",
      "The Man Who Makes the Impossible Possible",
      null,
      [["Metal Gear & Metal Gear 2: Solid Snake"], ["Metal Gear Solid - MCV"]],
      [[], []]
    ),
    new Series(
      "Metal Slug",
      "Intelligent Soldier",
      null,
      [
        ["ACA NEOGEO METAL SLUG", "ACA NEOGEO METAL SLUG (Windows)"],
        ["ACA NEOGEO METAL SLUG 2", "ACA NEOGEO METAL SLUG 2 (Windows)"],
        ["ACA NEOGEO METAL SLUG X", "ACA NEOGEO METAL SLUG X (Windows)"],
        ["ACA NEOGEO METAL SLUG 3", "ACA NEOGEO METAL SLUG 3 (Windows)"],
        ["ACA NEOGEO METAL SLUG 4", "ACA NEOGEO METAL SLUG 4 (Windows)"],
        ["ACA NEOGEO METAL SLUG 5", "ACA NEOGEO METAL SLUG 5 (Windows)"],
        ["METAL SLUG ATTACK RELOADED"],
        ["Metal Slug Tactics"],
      ],
      [
        ["Windows"],
        ["Windows"],
        ["Windows"],
        ["Windows"],
        ["Windows"],
        ["Windows"],
        [],
        [],
      ]
    ),
    new Series(
      "Metro",
      "Hardcore Ranger",
      "#FFFAFA",
      [
        ["Metro Redux"],
        [
          "Metro 2033 Redux",
          "Metro 2033 Redux (Xbox 360)",
          "Metro 2033 Redux (Windows)",
        ],
        [
          "Metro: Last Light Redux",
          "Metro: Last Light Redux (Xbox 360)",
          "Metro: Last Light Redux (Windows)",
        ],
        ["Metro Exodus", "Metro Exodus (Windows)"],
      ],
      [[], ["360", "Windows"], ["360", "Windows"], ["Windows"]]
    ),
    new Series(
      "Microsoft Flight",
      "Wing Commander",
      null,
      [["Microsoft Flight Simulator"], ["Microsoft Flight Simulator 2024"]],
      [[], []]
    ),
    new Series(
      "Middle-earth",
      "The Lord of the Ring",
      "#EBCE5C #E06904",
      [
        [
          "Middle-earth: Shadow of Mordor - Game of the Year Edition",
          "Middle-earth: Shadow of Mordor - Game of the Year Edition (Xbox One)",
        ],
        ["Middle-earth: Shadow of War"],
        ["The Lord of the Rings: Gollum"],
        ["The Lord of the Rings: Return to Moria"],
        ["Tales of the Shire: A The Lord of the Rings Game"],
        ["LEGO The Lord of the Rings"],
        ["LEGO The Hobbit"],
      ],
      [["One"], [], [], [], [], [], []]
    ),
    new Series(
      "LEGO Middle-earth",
      "Worth Greater Than the Shire",
      null,
      [
        ["LEGO The Lord of the Rings"],
        ["LEGO The Hobbit", "LEGO The Hobbit (Xbox 360)"],
      ],
      [[], ["360"]]
    ),
    new Series(
      "Middle-earth: Shadow",
      "Gravewalker",
      null,
      [
        [
          "Middle-earth: Shadow of Mordor - Game of the Year Edition",
          "Middle-earth: Shadow of Mordor - Game of the Year Edition (Xbox One)",
        ],
        ["Middle-earth: Shadow of War"],
      ],
      [["One"], []]
    ),
    new Series(
      "Minecraft",
      "Defender of the Overworld",
      "#1DC3C2 #5547BD",
      [
        ["Minecraft", "Minecraft (Windows)"],
        ["Minecraft Dungeons"],
        ["Minecraft Legends"],
        [
          "Minecraft: Story Mode - A Telltale Games Series",
          "Minecraft: Story Mode - A Telltale Games Series (Xbox 360)",
          "Minecraft: Story Mode - A Telltale Games Series (Windows)",
        ],
        [
          "Minecraft: Story Mode - Season Two",
          "Minecraft: Story Mode - Season Two (Xbox 360)",
          "Minecraft: Story Mode - Season Two (Windows)",
        ],
      ],
      [["Windows"], [], [], ["360", "Windows"], ["360", "Windows"]]
    ),
    new Series(
      "Minecraft Realms",
      "Wither Without You",
      null,
      [
        ["Minecraft", "Minecraft (Windows)"],
        ["Minecraft Dungeons"],
        ["Minecraft Legends"],
      ],
      [["Windows"], [], []]
    ),
    new Series(
      "Minecraft: Story Mode",
      "Some Pig",
      null,
      [
        [
          "Minecraft: Story Mode - A Telltale Games Series",
          "Minecraft: Story Mode - A Telltale Games Series (Xbox 360)",
          "Minecraft: Story Mode - A Telltale Games Series (Windows)",
        ],
        [
          "Minecraft: Story Mode - Season Two",
          "Minecraft: Story Mode - Season Two (Xbox 360)",
          "Minecraft: Story Mode - Season Two (Windows)",
        ],
      ],
      [
        ["360", "Windows"],
        ["360", "Windows"],
      ]
    ),
    new Series("Minion Masters", "Contender", null, [["Minion Masters"]], [[]]),
    new Series(
      "Mirror's Edge",
      "Test of Faith",
      null,
      [["Mirror's Edge"], ["Mirror's Edge Catalyst"]],
      [[], []]
    ),
    new Series(
      "Momodora",
      "Kaho's Blessing",
      null,
      [
        ["Momodora: Reverie Under the Moonlight"],
        ["Momodora: Moonlit Farewell"],
        ["Minoria"],
      ],
      [[], [], []]
    ),
    new Series(
      "Monkey Island",
      "Sea Cucumber",
      null,
      [
        ["The Secret of Monkey Island: Special Edition"],
        ["Monkey Island 2 Special Edition: LeChuck's Revenge"],
        ["Return to Monkey Island"],
      ],
      [[], [], []]
    ),
    new Series(
      "MONOPOLY",
      "He Who Controls The Dice...",
      null,
      [
        ["MONOPOLY"],
        ["MONOPOLY Deal", "MONOPOLY Deal (Xbox 360)"],
        ["MONOPOLY Madness"],
        ["MONOPOLY Plus", "MONOPOLY Plus (Xbox 360)"],
      ],
      [[], ["360"], [], ["360"]]
    ),
    new Series(
      "Monster Energy Supercross",
      "Unleashed the Beast",
      null,
      [
        ["Monster Energy Supercross - The Official Videogame"],
        ["Monster Energy Supercross - The Official Videogame 2"],
        ["Monster Energy Supercross - The Official Videogame 3"],
        [
          "Monster Energy Supercross - The Official Videogame 4",
          "Monster Energy Supercross - The Official Videogame 4 (Xbox One)",
        ],
        ["Monster Energy Supercross - The Official Videogame 5"],
        ["Monster Energy Supercross - The Official Videogame 6"],
        ["Monster Energy Supercross 25 - The Official Video Game"],
      ],
      [[], [], [], ["One"], [], [], []]
    ),
    new Series(
      "Monster Hunter",
      "Hunter of the New World",
      "#92B593",
      [
        ["Monster Hunter: World"],
        ["Monster Hunter Rise"],
        ["Monster Hunter Wilds"],
      ],
      [[], [], []]
    ),
    new Series(
      "Monster Jam",
      "Grave Digger",
      null,
      [
        ["Monster Jam Steel Titans"],
        ["Monster Jam Steel Titans 2"],
        ["Monster Jam Showdown"],
      ],
      [[], [], []]
    ),
    new Series(
      "Monster Train",
      "Igniter of Pyre",
      null,
      [["Monster Train"], ["Monster Train 2"]],
      [[], []]
    ),
    new Series(
      "Monument Valley",
      "Queen of the Birds",
      null,
      [["Monument Valley"], ["Monument Valley 2"], ["Monument Valley 3"]],
      [[], [], []]
    ),
    new Series(
      "Morbid",
      "Striver",
      null,
      [["Morbid: The Seven Acolytes"], ["Morbid: The Lords of Ire"]],
      [[], []]
    ),
    new Series(
      "Mortal Kombat",
      "Elder God",
      "#F53624",
      [
        ["Mortal Kombat: Legacy Collection"],
        ["Mortal Kombat X"],
        ["Mortal Kombat 11"],
        ["Mortal Kombat 1"],
      ],
      [[], [], [], []]
    ),
    new Series(
      "MotoGP",
      "Thunder of Cervera",
      null,
      [
        ["MotoGP 15", "MotoGP 15 (Xbox 360)"],
        ["MotoGP 17"],
        ["MotoGP 18"],
        ["MotoGP 19"],
        ["MotoGP 20", "MotoGP 20 (Windows)"],
        ["MotoGP 21", "MotoGP 21 (Xbox One)"],
        ["MotoGP 22"],
        ["MotoGP 23"],
        ["MotoGP 24"],
        ["MotoGP 25"],
      ],
      [["360"], [], [], [], ["Windows"], ["One"], [], [], [], []]
    ),
    new Series(
      "Moving Out",
      "Max F.A.R.T.",
      "#FABF79",
      [["Moving Out", "Moving Out (Windows)"], ["Moving Out 2"]],
      [["Windows"], []]
    ),
    new Series(
      "MudRunner",
      "Ain't No Rest for the Trucker",
      null,
      [
        ["MudRunner"],
        ["SnowRunner", "SnowRunner (Windows)"],
        ["Expeditions: A MudRunner Game"],
      ],
      [[], ["Windows"], []]
    ),
    new Series("MultiVersus", "Superman", null, [["MultiVersus"]], [[]]),
    new Series(
      "MY HERO",
      "Number One Hero",
      null,
      [["MY HERO ONE'S JUSTICE"], ["MY HERO ONE'S JUSTICE 2"]],
      [[], []]
    ),
    new Series(
      "My Time",
      "Calamity SS Builder",
      null,
      [
        ["My Time at Portia"],
        ["My Time at Sandrock"],
        ["My Time at Sandrock Online"],
      ],
      [[], [], []]
    ),
    new Series(
      "NARAKA: BLADEPOINT",
      "Deific Presence",
      null,
      [["NARAKA: BLADEPOINT"]],
      [[]]
    ),
    new Series(
      "Naruto",
      "Nanadaime Hokage",
      null,
      [
        ["Naruto: Ultimate Ninja Storm"],
        [
          "Naruto Shippuden: Ultimate Ninja Storm 2",
          "Naruto Shippuden: Ultimate Ninja Storm 2 (Xbox 360)",
        ],
        [
          "Naruto Shippuden: Ultimate Ninja Storm 3",
          "Naruto Shippuden: Ultimate Ninja Storm 3 (Xbox 360)",
        ],
        [
          "Naruto Shippuden: Ultimate Ninja Storm 4",
          "Naruto Shippuden: Ultimate Ninja Storm 4 (Xbox 360)",
        ],
        ["Naruto To Boruto: Shinobi Striker"],
        ["Naruto x Boruto: Ultimate Ninja STORM CONNECTIONS"],
      ],
      [[], ["360"], ["360"], ["360"], [], []]
    ),
    new Series(
      "NASA",
      "Vomit Comet",
      null,
      [
        ["To the Moon and Beyond"],
        ["Space Science Investigations: Humans in Space"],
      ],
      [[], []]
    ),
    new Series(
      "Need for Speed",
      "Iconoclast",
      "#5891AB",
      [
        ["Need for Speed"],
        ["Need for Speed Payback"],
        ["Need for Speed Heat"],
        [
          "Need for Speed Hot Pursuit Remastered",
          "Need for Speed Hot Pursuit Remastered (Xbox 360)",
        ],
        ["Need for Speed Unbound"],
      ],
      [[], [], [], ["360"], []]
    ),
    new Series(
      "Neverwinter",
      "Mark of Devotion",
      null,
      [["Neverwinter"]],
      [[]]
    ),
    new Series(
      "Nexomon",
      "Nexolord",
      null,
      [["Nexomon"], ["Nexomon: Extinction"]],
      [[], []]
    ),
    new Series(
      "Ni no Kuni",
      "Pure-Hearted One",
      null,
      [
        ["Ni no Kuni: Wrath of the White Witch Remastered"],
        ["Ni no Kuni II: Revenant Kingdom - The Prince's Edition"],
      ],
      [[], []]
    ),
    new Series(
      "Nickelodeon All-Star Brawl",
      "Unleash the DOOM!",
      null,
      [["Nickelodeon All-Star Brawl"], ["Nickelodeon All-Star Brawl 2"]],
      [[], []]
    ),
    new Series(
      "Nickelodeon: Kart Racers",
      "Ghost with the Most",
      null,
      [
        ["Nickelodeon: Kart Racers"],
        ["Nickelodeon Kart Racers 2: Grand Prix"],
        ["Nickelodeon Kart Racers 3: Slime Speedway"],
      ],
      [[], [], []]
    ),
    new Series(
      "NieR",
      "Weight of the World",
      "#A1B9AD",
      [
        [
          "NieR Replicant ver.1.22474487139...",
          "NieR Replicant ver.1.22474487139... (Xbox 360)",
        ],
        [
          "NieR: Automata BECOME AS GODS Edition",
          "NieR: Automata BECOME AS GODS Edition (Windows)",
        ],
      ],
      [["360"], ["Windows"]]
    ),
    new Series(
      "Ninja Gaiden",
      "Hayabusa Ninja",
      "#D20200",
      [
        ["Ninja Gaiden \u03a3"],
        ["NINJA GAIDEN 2 Black", "NINJA GAIDEN 2 Black (Xbox 360)"],
        [
          "Ninja Gaiden 3: Razor's Edge",
          "Ninja Gaiden 3: Razor's Edge (Xbox 360)",
        ],
        ["Ninja Gaiden 4"],
        ["NINJA GAIDEN: Ragebound"],
      ],
      [[], ["360"], ["360"], [], []]
    ),
    new Series(
      "Nomada Studio",
      "Death's Duality",
      null,
      [["GRIS"], ["Neva"]],
      [[], []]
    ),
    new Series(
      "Oceanhorn",
      "Arne of My Youth",
      null,
      [
        ["Oceanhorn - Monster of Uncharted Seas"],
        ["Oceanhorn 2: Knights of the Lost Realm"],
      ],
      [[], []]
    ),
    new Series(
      "Octopath Traveler",
      "A Story All My Own",
      null,
      [["Octopath Traveler"], ["Octopath Traveler ll"]],
      [[], []]
    ),
    new Series(
      "Oddworld",
      "Messiah of the Mudokons",
      null,
      [
        ["Oddworld: New 'n' Tasty"],
        ["Oddworld: Soulstorm Enhanced Edition"],
        ["Oddworld: Stranger's Wrath HD"],
      ],
      [[], [], []]
    ),
    new Series(
      "Oh...Sir!",
      "It Got Boring After An Hour",
      null,
      [["Oh...Sir! The Insult Simulator"], ["Oh...Sir! The Hollywood Roast"]],
      [[], []]
    ),
    new Series(
      "Okami-Gami",
      "Ōhirume no Muchi no Kami",
      null,
      [["Okami HD"], ["Kunitsu-Gami: Path of the Goddess"]],
      [[], []]
    ),
    new Series(
      "OlliOlli",
      "Totally Radical",
      null,
      [["OlliOlli"], ["OlliOlli2: XL Edition"]],
      [[], []]
    ),
    new Series(
      "One More Dungeon",
      "Snail Slayer",
      null,
      [["One More Dungeon"], ["One More Dungeon 2"]],
      [[], []]
    ),
    new Series(
      "ONE PIECE",
      "Joy Boy",
      null,
      [
        ["ONE PIECE: Burning Blood"],
        ["ONE PIECE World Seeker"],
        ["ONE PIECE ODYSSEY"],
        [
          "ONE PIECE: PIRATE WARRIORS 4",
          "ONE PIECE: PIRATE WARRIORS 4 (Windows)",
        ],
      ],
      [[], [], [], ["Windows"]]
    ),
    new Series(
      "Onimusha",
      "Tenkai The Purifier",
      null,
      [
        ["Onimusha: Warlords"],
        ["Onimusha 2: Samurai's Destiny"],
        ["Onimusha: Way of the Sword"],
      ],
      [[], [], []]
    ),
    new Series(
      "Orcs Must Die!",
      "Rift Lord",
      null,
      [["Orcs Must Die!"], ["Orcs Must Die! 3"], ["Orcs Must Die! Deathtrap"]],
      [[], [], []]
    ),
    new Series(
      "Ori",
      "Spirit Guardian",
      "#B5E2FA",
      [
        ["Ori and the Blind Forest: Definitive Edition"],
        ["Ori and the Will of the Wisps"],
      ],
      [[], []]
    ),
    new Series(
      "Outbreak",
      "Congratulations on the Carnage!",
      null,
      [
        ["Outbreak"],
        [
          "Outbreak: The New Nightmare Definitive Edition",
          "Outbreak: The New Nightmare Definitive Edition (Xbox One)",
        ],
        [
          "Outbreak: Epidemic Definitive Edition",
          "Outbreak: Epidemic Definitive Edition (Xbox One)",
        ],
        [
          "Outbreak: The Nightmare Chronicles Definitive Edition",
          "Outbreak: The Nightmare Chronicles Definitive Edition (Xbox One)",
        ],
        [
          "Outbreak: Lost Hope Definitive Edition",
          "Outbreak: Lost Hope Definitive Edition (Xbox One)",
        ],
        ["Outbreak: Endless Nightmares"],
        ["Outbreak: Contagious Memories"],
        ["Outbreak The Fedora Files: What Lydia Knows"],
        ["Outbreak: Shades of Horror Chromatic Split"],
        ["Dinobreak"],
        ["Railbreak"],
      ],
      [[], ["One"], ["One"], ["One"], ["One"], [], [], [], [], [], []]
    ),
    new Series(
      "Outcast",
      "The Ulukaï",
      null,
      [["Outcast - Second Contact"], ["Outcast - A New Beginning"]],
      [[], []]
    ),
    new Series(
      "Outlast",
      "The Thing in the Dark",
      "#2A5641",
      [["Outlast"], ["Outlast 2"], ["The Outlast Trials"]],
      [[], [], []]
    ),
    new Series(
      "Overcooked!",
      "This is Fine",
      "#FF6700",
      [["Overcooked!"], ["Overcooked! 2", "Overcooked! 2 (Windows)"]],
      [[], ["Windows"]]
    ),
    new Series("Overwatch", "Strike Commander", null, [["Overwatch 2"]], [[]]),
    new Series(
      "Pac-Man",
      "Om Nom Nom",
      null,
      [
        ["ARCADE GAME SERIES: Pac-Man"],
        ["ARCADE GAME SERIES: Ms. Pac-Man"],
        ["Pac-Man Championship Edition"],
        ["Pac-Man Championship Edition 2"],
        ["Pac-Man 256"],
        ["Pac-Man Museum+"],
        ["PAC-MAN WORLD Re-PAC"],
        ["Shadow Labyrinth"],
      ],
      [[], [], [], [], [], [], [], []]
    ),
    new Series(
      "Paladins",
      "Pinnacle",
      null,
      [["Paladins: Champions of the Realm"]],
      [[]]
    ),
    new Series("Palia", "HOA-mazing", null, [["Palia"]], [[]]),
    new Series(
      "Party Hard",
      "ПОБЕДА",
      null,
      [["Party Hard"], ["Party Hard 2"]],
      [[], []]
    ),
    new Series(
      "Path of Exile",
      "Exalted",
      "#C7BB86",
      [["Path of Exile"], ["Path of Exile 2"]],
      [[], []]
    ),
    new Series(
      "PAW Patrol",
      "No Job Is Too Big, No Pup Is Too Small!",
      "#EADC29",
      [
        ["PAW Patrol: On a Roll"],
        ["PAW Patrol: Mighty Pups Save Adventure Bay"],
        ["PAW Patrol The Movie: Adventure City Calls"],
        ["PAW Patrol: Grand Prix"],
        ["PAW Patrol World"],
      ],
      [[], [], [], [], []]
    ),
    new Series(
      "PAYDAY",
      "No One Cared Who I Was...",
      null,
      [["PAYDAY 2: Crimewave Edition"], ["PAYDAY 3"]],
      [[], []]
    ),
    new Series(
      "Peggle",
      "Doctor of the Peggle Arts",
      null,
      [["Peggle"], ["Peggle 2"]],
      [[], []]
    ),
    new Series(
      "Pen & Paper",
      "Never Enough Pizza",
      null,
      [
        ["Knights of Pen & Paper +1 Deluxier Edition"],
        ["Knights of Pen & Paper 2 Deluxiest Edition"],
        ["Galaxy of Pen & Paper +1 Edition"],
      ],
      [[], [], []]
    ),
    new Series(
      "Peppa Pig",
      "Lechón",
      null,
      [["My Friend Peppa Pig"], ["Peppa Pig: World Adventures"]],
      [[], []]
    ),
    new Series(
      "Phantom Breaker",
      "Beautiful Harp",
      null,
      [
        ["Phantom Breaker: Omnia"],
        ["Phantom Breaker: Battle Grounds Ultimate"],
      ],
      [[], []]
    ),
    new Series("Phasmophobia", "De Ogen", "#080B11", [["Phasmophobia"]], [[]]),
    new Series(
      "Pillars of Eternity",
      "From the Clouds to the Depths",
      null,
      [
        ["Pillars of Eternity", "Pillars of Eternity (Windows)"],
        [
          "Pillars Of Eternity II: Deadfire",
          "Pillars Of Eternity II: Deadfire (Windows)",
        ],
        ["Avowed"],
      ],
      [["Windows"], ["Windows"], []]
    ),
    new Series(
      "Pixel Strike 3D",
      "Vulcron's Champion",
      null,
      [["Pixel Strike 3D"]],
      [[]]
    ),
    new Series(
      "Plants vs. Zombies",
      "BECAUSE I'M CRAAAAAAAZY!",
      "#8EC63F",
      [
        ["Plants vs. Zombies"],
        [
          "Plants vs. Zombies Garden Warfare",
          "Plants vs. Zombies Garden Warfare (Xbox 360)",
        ],
        ["Plants vs. Zombies: Battle for Neighborville"],
      ],
      [[], ["360"], []]
    ),
    new Series(
      "Playdead",
      "Limboloi Boi",
      "#BE696B",
      [["LIMBO", "LIMBO (Xbox 360)", "LIMBO (Windows)"], ["INSIDE"]],
      [["360", "Windows"], []]
    ),
    new Series(
      "Player Unknown's Battlegrounds",
      "Don't Pan Me Bro!",
      null,
      [["PUBG: Battlegrounds"]],
      [[]]
    ),
    new Series(
      "Poppy Playtime",
      "Poppy's Angel",
      null,
      [
        ["Poppy Playtime: Chapter 1"],
        ["Poppy Playtime: Chapter 2"],
        ["Poppy Playtime: Chapter 3"],
        ["Poppy Playtime: Chapter 4"],
      ],
      [[], [], [], []]
    ),
    new Series(
      "Portal",
      "Vanilla Crazy Cake",
      "#36C0F1",
      [["Portal: Still Alive"], ["Portal 2"], ["Bridge Constructor Portal"]],
      [[], [], []]
    ),
    new Series(
      "Power Rangers",
      "Legendary Ranger",
      null,
      [
        ["Power Rangers: Battle for the Grid"],
        ["Mighty Morphin Power Rangers: Rita's Rewind"],
      ],
      [[], []]
    ),
    new Series(
      "Predecessor",
      "On the Edge of Infinity",
      null,
      [["Predecessor"]],
      [[]]
    ),
    new Series(
      "Prey",
      "I and It...Kill Them All",
      "#B6A777",
      [["Prey", "Prey (Windows)"], ["Prey: Typhon Hunter"]],
      [["Windows"], []]
    ),
    new Series(
      "Prince of Persia",
      "Written in the Sand",
      "#ECDE9D",
      [
        ["Prince of Persia: The Forgotten Sands"],
        ["Prince of Persia: The Lost Crown"],
      ],
      [[], []]
    ),
    new Series(
      "Princess.Loot.Pixel.Again",
      "My Name is Reaper",
      null,
      [["Princess.Loot.Pixel.Again"], ["Princess.Loot.Pixel.Again x2"]],
      [[], []]
    ),
    new Series(
      "Project 13",
      "Overseer",
      null,
      [
        ["PROJECT 13"],
        ["Project 13: Taxidermy Trails"],
        ["Project 13: Nightwatch"],
      ],
      [[], [], []]
    ),
    new Series(
      "Prominence Poker",
      "Billionaire",
      "#9E94B9",
      [["Prominence Poker"]],
      [[]]
    ),
    new Series(
      "Prototype",
      "Something More Than Human",
      null,
      [["Prototype"], ["Prototype 2"]],
      [[], []]
    ),
    new Series(
      "Psychotic Adventure",
      "Divine Retribution",
      null,
      [["MechaNika"], ["Agatha Knife"], ["Colossus Down"]],
      [[], [], []]
    ),
    new Series(
      "Pumped BMX",
      "Until the Wheels Fall Off",
      null,
      [["Pumped BMX +"], ["Pumped BMX Pro"]],
      [[], []]
    ),
    new Series(
      "Puppet Combo",
      "VHS Tape Master",
      "#FF2BFF",
      [
        ["Bloodwash"],
        ["Murder House"],
        ["Rewind or Die"],
        ["Stay Out of the House"],
        ["The Glass Staircase"],
      ],
      [[], [], [], [], []]
    ),
    new Series(
      "Quake",
      "Black Goat of a Thousand Young",
      "#DFDD96",
      [["Quake"], ["Quake II"]],
      [[], []]
    ),
    new Series(
      "Q.U.B.E.",
      "King of Cubes",
      null,
      [["Q.U.B.E. 10th Anniversary"], ["Q.U.B.E. 2 Ultimate Edition"]],
      [[], []]
    ),
    new Series(
      "RAGE",
      "Post-Post-Apocalyptic Poster Child",
      "#FA0BA6",
      [["RAGE"], ["RAGE 2", "RAGE 2 (Windows)"]],
      [[], ["Windows"]]
    ),
    new Series(
      "Raiden",
      "God of Thunder and Lightning",
      null,
      [
        ["Raiden lll x MIKADO MANIAX"],
        ["Raiden lV x MIKADO remix"],
        ["Raiden V"],
      ],
      [[], [], []]
    ),
    new Series(
      "Rare Replay",
      "Stamper Forever",
      "#E9CC40 #1EB1E2",
      [
        ["Kameo: Elements of Power"],
        ["Perfect Dark Zero"],
        ["Perfect Dark (Xbox 360)"],
        ["Jetpac Refuelled"],
        ["Viva Pi\u00f1ata"],
        ["Viva Pi\u00f1ata: Trouble In Paradise"],
        ["Banjo-Kazooie"],
        ["Banjo-Tooie"],
        ["Banjo-Kazooie: Nuts & Bolts"],
        ["GoldenEye 007"],
        ["Rare Replay"],
      ],
      [[], [], [], [], [], [], [], [], [], [], []]
    ),
    new Series(
      "Banjo-Kazooie",
      "Music Maestro",
      null,
      [["Banjo-Kazooie"], ["Banjo-Tooie"], ["Banjo-Kazooie: Nuts & Bolts"]],
      [[], [], []]
    ),
    new Series(
      "Perfect Dark",
      "Perfect Agent",
      null,
      [["Perfect Dark Zero"], ["Perfect Dark (Xbox 360)"]],
      [[], []]
    ),
    new Series(
      "Viva Piñata",
      "Party Animal",
      null,
      [["Viva Pi\u00f1ata"], ["Viva Pi\u00f1ata: Trouble In Paradise"]],
      [[], []]
    ),
    new Series(
      "Raving Rabbids",
      "BWAAAH!!",
      null,
      [
        ["Rabbids Invasion: The Interactive TV Show"],
        ["Rabbids: Party of Legends"],
      ],
      [[], []]
    ),
    new Series(
      "Rayman",
      "Truly Awesome",
      "#B57AAF",
      [
        ["Rayman Origins"],
        ["Rayman 3 HD"],
        ["Rayman Legends", "Rayman Legends (Xbox 360)"],
      ],
      [[], [], ["360"]]
    ),
    new Series(
      "Read Only Memories",
      "Bit-Brained Brobot",
      null,
      [["2064: Read Only Memories"], ["Read Only Memories: NEURODIVER"]],
      [[], []]
    ),
    new Series(
      "Rebel Galaxy",
      "Pirate Killer",
      null,
      [["Rebel Galaxy"], ["Rebel Galaxy Outlaw"]],
      [[], []]
    ),
    new Series(
      "Rec BLOX",
      "Architect of My Own World",
      "#FD663B",
      [["Rec Room"], ["ROBLOX"]],
      [[], []]
    ),
    new Series(
      "Red Dead Redemption",
      "Best In The West",
      "#C90511",
      [["Red Dead Redemption"], ["Red Dead Redemption 2"]],
      [[], []]
    ),
    new Series(
      "Red Faction",
      "Liberator of Mars",
      null,
      [
        [
          "Red Faction: Guerrilla Re-Mars-tered",
          "Red Faction: Guerrilla Re-Mars-tered (Xbox 360)",
        ],
        ["Red Faction: Battlegrounds"],
        ["Red Faction: Armageddon"],
      ],
      [["360"], [], []]
    ),
    new Series(
      "Redout",
      "Redout Grandmaster",
      null,
      [["Redout: Lightspeed Edition"], ["Redout 2"], ["Redout: Space Assault"]],
      [[], [], []]
    ),
    new Series(
      "Remedy Connected Universe",
      "Champion of Light",
      "#F1B130 #C6D4D0",
      [
        ["Alan Wake Remastered", "Alan Wake Remastered (Xbox 360)"],
        ["Alan Wake's American Nightmare"],
        ["Quantum Break"],
        [
          "Control: Ultimate Edition",
          "Control: Ultimate Edition (Xbox One)",
          "Control: Ultimate Edition (Windows)",
        ],
        ["Alan Wake 2"],
        ["FBC: Firebreak"],
        ["Control 2"],
      ],
      [["360"], [], [], ["One", "Windows"], [], [], []]
    ),
    new Series(
      "Alan Wake",
      "I'm a Writer",
      null,
      [
        ["Alan Wake Remastered", "Alan Wake Remastered (Xbox 360)"],
        ["Alan Wake's American Nightmare"],
        ["Alan Wake 2"],
      ],
      [["360"], [], []]
    ),
    new Series(
      "Control",
      "Director of the FBC",
      null,
      [
        [
          "Control: Ultimate Edition",
          "Control: Ultimate Edition (Xbox One)",
          "Control: Ultimate Edition (Windows)",
        ],
        ["Control 2"],
        ["FBC: Firebreak"],
      ],
      [["One", "Windows"], [], []]
    ),
    new Series(
      "Remnant",
      "The One True King",
      "#F27159",
      [["Remnant: From the Ashes"], ["Remnant II"]],
      [[], []]
    ),
    new Series(
      "Remothered",
      "Mirror Breaker",
      null,
      [["Remothered: Tormented Fathers"], ["Remothered: Broken Porcelain"]],
      [[], []]
    ),
    new Series(
      "Resident Evil",
      "Biohazard",
      "#820200 #C2C2C2",
      [
        ["Resident Evil 0", "Resident Evil 0 (Xbox 360)"],
        ["Resident Evil", "Resident Evil (Xbox 360)"],
        ["Resident Evil 2"],
        ["Resident Evil 3"],
        ["Resident Evil Code: Veronica X"],
        ["Resident Evil 4"],
        ["Resident Evil Revelations", "Resident Evil Revelations (Xbox 360)"],
        ["Resident Evil 5", "Resident Evil 5 (Xbox 360)"],
        [
          "Resident Evil Revelations 2",
          "Resident Evil Revelations 2 (Xbox 360)",
        ],
        ["Resident Evil 6", "Resident Evil 6 (Xbox 360)"],
        ["Resident Evil 7: Biohazard"],
        ["Resident Evil Village"],
        ["Resident Evil Requiem"],
        ["Resident Evil: Operation Raccoon City"],
        ["Resident Evil Resistance"],
      ],
      [
        ["360"],
        ["360"],
        [],
        [],
        [],
        [],
        ["360"],
        ["360"],
        ["360"],
        ["360"],
        [],
        [],
        [],
        [],
        [],
      ]
    ),
    new Series(
      "Resident Evil (Chris Redfield)",
      "Hound Wolf",
      null,
      [
        ["Resident Evil", "Resident Evil (Xbox 360)"],
        ["Resident Evil Code: Veronica X"],
        ["Resident Evil Revelations", "Resident Evil Revelations (Xbox 360)"],
        ["Resident Evil 5", "Resident Evil 5 (Xbox 360)"],
        ["Resident Evil 6", "Resident Evil 6 (Xbox 360)"],
        ["Resident Evil 7: Biohazard"],
        ["Resident Evil Village"],
      ],
      [["360"], [], ["360"], ["360"], ["360"], [], []]
    ),
    new Series(
      "Resident Evil (Claire Redfield)",
      "Sizzling Scarlet",
      null,
      [
        ["Resident Evil 2"],
        ["Resident Evil Code: Veronica X"],
        [
          "Resident Evil Revelations 2",
          "Resident Evil Revelations 2 (Xbox 360)",
        ],
      ],
      [[], [], ["360"]]
    ),
    new Series(
      "Resident Evil (Jill Valentine)",
      "Jill Sandwich",
      null,
      [
        ["Resident Evil", "Resident Evil (Xbox 360)"],
        ["Resident Evil 3"],
        ["Resident Evil Revelations", "Resident Evil Revelations (Xbox 360)"],
        ["Resident Evil 5", "Resident Evil 5 (Xbox 360)"],
      ],
      [["360"], [], ["360"], ["360"]]
    ),
    new Series(
      "Resident Evil (Leon S. Kennedy)",
      "Silver Ghost",
      null,
      [
        ["Resident Evil 2"],
        ["Resident Evil 4"],
        ["Resident Evil 6", "Resident Evil 6 (Xbox 360)"],
      ],
      [[], [], ["360"]]
    ),
    new Series(
      "Resident Evil (Ethan Winters)",
      "Shadow of Rose",
      null,
      [["Resident Evil 7: Biohazard"], ["Resident Evil Village"]],
      [[], []]
    ),
    new Series(
      "Revenant",
      "Almighty's Hand",
      null,
      [["Revenant Dogma"], ["Revenant Saga"]],
      [[], []]
    ),
    new Series(
      "RIDE",
      "The Doctor",
      null,
      [
        ["RIDE", "RIDE (Xbox 360)"],
        ["RIDE 2"],
        ["RIDE 3"],
        ["RIDE 4"],
        ["RIDE 5"],
      ],
      [["360"], [], [], [], []]
    ),
    new Series(
      "Risen",
      "Titan Lord",
      null,
      [["Risen", "Risen (Xbox 360)"], ["Risen 2: Dark Waters"]],
      [["360"], []]
    ),
    new Series(
      "Risk of Rain",
      "Maybe One More",
      null,
      [["Risk of Rain"], ["Risk of Rain 2"]],
      [[], []]
    ),
    new Series(
      "Road 96",
      "Smells Like Teen Spirit",
      null,
      [["Road 96"], ["Road 96: Mile 0"]],
      [[], []]
    ),
    new Series(
      "Robin Hood",
      "Prince of Thieves",
      null,
      [["Gangs of Sherwood"], ["Robin Hood - Sherwood Builders"]],
      [[], []]
    ),
    new Series(
      "Rock of Ages",
      "Golden Boulder",
      null,
      [
        ["Rock of Ages"],
        ["Rock of Ages II: Bigger and Boulder"],
        ["Rock of Ages 3: Make & Break"],
      ],
      [[], [], []]
    ),
    new Series(
      "Rocket League",
      "Supersonic Legend",
      "#E2CEFC",
      [["Rocket League"], ["Turbo Golf Racing"], ["Metaball"]],
      [[], [], []]
    ),
    new Series(
      "Rogue Company",
      "All I Do Is Win",
      null,
      [["Rogue Company"]],
      [[]]
    ),
    new Series(
      "Rogue Legacy",
      "Rogue's Legacy",
      null,
      [["Rogue Legacy"], ["Rogue Legacy 2"]],
      [[], []]
    ),
    new Series(
      "Roller Champions",
      "Underdogs 'Til the End",
      null,
      [["Roller Champions"]],
      [[]]
    ),
    new Series(
      "Rumble Fish",
      "Fighter Who Survived Valor",
      null,
      [["The Rumble Fish +"], ["The Rumble Fish 2"]],
      [[], []]
    ),
    new Series(
      "RWBY",
      "Red Like Roses",
      null,
      [["RWBY: Grimm Eclipse"], ["RWBY: Arrowfell"]],
      [[], []]
    ),
    new Series(
      "Sabotage Connected Universe",
      "Solstice Warrior",
      "#7AFFFE",
      [["The Messenger", "The Messenger (Windows)"], ["Sea of Stars"]],
      [["Windows"], []]
    ),
    new Series(
      "SaGa",
      "Lord of all Gods",
      null,
      [["Romancing SaGa 2"], ["Romancing SaGa 3"]],
      [[], []]
    ),
    new Series(
      "Saints Row",
      "3rd Street Saint",
      "#9B00FF",
      [
        ["Saints Row (2006)"],
        ["Saints Row 2"],
        [
          "Saints Row: The Third Remastered",
          "Saints Row: The Third Remastered (Xbox 360)",
        ],
        [
          "Saints Row IV: Re-Elected",
          "Saints Row IV: Re-Elected (Xbox 360)",
          "Saints Row IV: Re-Elected (Windows)",
        ],
        [
          "Saints Row: Gat Out of Hell",
          "Saints Row: Gat Out of Hell (Xbox 360)",
        ],
        ["Saints Row"],
      ],
      [[], [], ["360"], ["360", "Windows"], ["360"], []]
    ),
    new Series(
      "Sam & Max",
      "God of Vulgar Novelty Items",
      null,
      [
        ["Sam & Max Save the World", "Sam & Max Save the World (Xbox 360)"],
        [
          "Sam & Max: Beyond Time and Space",
          "Sam & Max: Beyond Time and Space (Xbox 360)",
        ],
        ["Sam & Max: The Devil's Playhouse"],
      ],
      [["360"], ["360"], []]
    ),
    new Series(
      "Saturn Tribute",
      "One to a Million",
      null,
      [
        ["Assault Suit Leynos 2 Saturn Tribute"],
        ["BATSUGUN Saturn Tribute Boosted"],
        ["Cleopatra Fortune S-Tribute"],
        ["Elevator Action -Returns- S-Tribute"],
        ["Layer Section & Galactic Attack S-Tribute"],
        ["Metal Black S-Tribute"],
        ["Puzzle Bobble 2X & 3 S-Tribute"],
        ["Wolf Fang / Skull Fang Saturn Tribute Boosted"],
      ],
      [[], [], [], [], [], [], [], []]
    ),
    new Series(
      "Savage Planet",
      "4th Best Satirical Savage",
      "#F78700",
      [
        [
          "Journey to the Savage Planet: Employee of the Month Edition",
          "Journey to the Savage Planet: Employee of the Month Edition (Xbox One)",
          "Journey to the Savage Planet: Employee of the Month Edition (Windows)",
        ],
        [
          "Revenge of the Savage Planet",
          "Revenge of the Savage Planet (Windows)",
        ],
      ],
      [["One", "Windows"], ["Windows"]]
    ),
    new Series(
      "Science Adventure",
      "Lab Member No. 001",
      null,
      [
        ["Steins;Gate"],
        ["Chaos;Child"],
        ["OCCULTIC;NINE"],
        ["Steins;Gate: Hiyoku-Renri no Darling"],
        ["Steins;Gate: Senkei Kousoku no Phenogram"],
        ["Steins;Gate 0"],
      ],
      [[], [], [], [], [], []]
    ),
    new Series(
      "Scribblenauts",
      "Unlimited Imagination",
      "#FFE546",
      [["Scribblenauts: Showdown"], ["Scribblenauts Mega Pack"]],
      [[], []]
    ),
    new Series(
      "Sea of Thieves",
      "Legend of the Sea of Thieves",
      null,
      [["Sea of Thieves"]],
      [[]]
    ),
    new Series(
      "Sense",
      "Gin Wai",
      null,
      [["Sense - A Cyberpunk Ghost Story"], ["SENSEs: Midnight"]],
      [[], []]
    ),
    new Series(
      "Serial Cleaner",
      "Mr. Hygeni",
      null,
      [["Serial Cleaner"], ["Serial Cleaners"]],
      [[], []]
    ),
    new Series(
      "Serious Sam",
      "Seriously Mental",
      null,
      [
        ["Serious Sam Collection"],
        ["Serious Sam 4", "Serious Sam 4 (Windows)"],
        [
          "Serious Sam: Siberian Mayhem",
          "Serious Sam: Siberian Mayhem (Windows)",
        ],
      ],
      [[], ["Windows"], ["Windows"]]
    ),
    new Series(
      "Shadow Tactics",
      "Ronin",
      null,
      [
        ["Shadow Tactics: Blades of the Shogun"],
        ["Shadow Tactics: Aiko's Choice"],
      ],
      [[], []]
    ),
    new Series(
      "Shadow Warrior",
      "No Ordinary Wang",
      null,
      [
        ["Shadow Warrior"],
        ["Shadow Warrior 2", "Shadow Warrior 2 (Windows)"],
        ["Shadow Warrior 3: Definitive Edition"],
      ],
      [[], ["Windows"], []]
    ),
    new Series(
      "Shadowrun",
      "Metahuman",
      null,
      [
        ["Shadowrun Returns"],
        ["Shadowrun: Dragonfall - Director's Cut"],
        ["Shadowrun: Hong Kong - Extended Edition"],
      ],
      [[], [], []]
    ),
    new Series(
      "Shalnor Legends",
      "Full Metal Hunter",
      null,
      [
        ["Shalnor Legends: Sacred Lands"],
        ["Shalnor Legends 2: Trials of Thunder"],
      ],
      [[], []]
    ),
    new Series(
      "Shantae",
      "Half-Genie Hero",
      "#AE7DD9",
      [
        ["Shantae: Risky's Revenge - Director's Cut"],
        ["Shantae and the Pirate's Curse"],
        ["Shantae: Half-Genie Hero Ultimate Edition"],
        ["Shantae and the Seven Sirens"],
        ["Shantae Advance: Risky Revolution"],
      ],
      [[], [], [], [], []]
    ),
    new Series(
      "Shaolin vs Wutang",
      "The Best Under Heaven",
      null,
      [["Shaolin vs Wutang"], ["Shaolin vs Wutang 2"]],
      [[], []]
    ),
    new Series(
      "Shenmue",
      "Forklift's Revenge",
      null,
      [["Shenmue I & II (Windows)"], ["Shenmue"], ["Shenmue II"]],
      [[], [], []]
    ),
    new Series(
      "Sherlock Holmes",
      "World's Only Consulting Detective",
      null,
      [
        [
          "Sherlock Holmes: Crimes and Punishments Redux",
          "Sherlock Holmes: Crimes and Punishments Redux (Xbox 360)",
        ],
        ["Sherlock Holmes: The Devil's Daughter Redux"],
        ["Sherlock Holmes Chapter One"],
        ["Sherlock Holmes The Awakened"],
      ],
      [["360"], [], [], []]
    ),
    new Series(
      "Shin Megami Tensei",
      "King Eternal, Immortal, Unbroken",
      "#15F5F8 #5027E7",
      [
        ["Soul Hackers 2"],
        ["RAIDOU Remastered: The Mystery of the Soulless Army"],
        ["Persona 3 Reloaded"],
        ["Persona 4 Revival"],
        ["Persona 4 Golden"],
        ["Persona 5 Royal"],
        ["Persona 5 Tactica"],
        ["Shin Megami Tensei V: Vengeance"],
      ],
      [[], [], [], [], [], [], [], []]
    ),
    new Series(
      "Shin Megami Tensei",
      "Architect of Divine Providence",
      null,
      [["Shin Megami Tensei V: Vengeance"]],
      [[]]
    ),
    new Series(
      "Devil Summoner",
      "Beyond the Infinite",
      null,
      [
        ["Soul Hackers 2"],
        ["RAIDOU Remastered: The Mystery of the Soulless Army"],
      ],
      [[], []]
    ),
    new Series(
      "Persona",
      "Master of Akihabara",
      null,
      [
        ["Persona 3 Reloaded"],
        ["Persona 4 Revival"],
        ["Persona 4 Golden"],
        ["Persona 5 Royal"],
        ["Persona 5 Tactica"],
      ],
      [[], [], [], [], []]
    ),
    new Series(
      "Shovel Knight",
      "Bound by the Code of Shovelry",
      null,
      [
        ["Shovel Knight: Treasure Trove"],
        ["Shovel Knight: Shovel of Hope DX"],
        ["Shovel Knight Dig"],
      ],
      [[], [], []]
    ),
    new Series(
      "Silent Hill",
      "Manifestation of Punishment",
      "#C5D2DA",
      [
        ["Silent Hill HD Collection"],
        ["Silent Hill Homecoming"],
        ["Silent Hill: Downpour"],
        ["SILENT HILL f"],
      ],
      [[], [], [], []]
    ),
    new Series(
      "Skautfold",
      "Last Knight of an Angelic Empire",
      null,
      [
        ["Skautfold: Shrouded in Sanity"],
        ["Skautfold: Usurper"],
        ["Skautfold: Into the Fray"],
      ],
      [[], [], []]
    ),
    new Series(
      "Sker",
      "Head of the Hotel",
      null,
      [["Maid of Sker"], ["Sker Ritual"]],
      [[], []]
    ),
    new Series(
      "Sky Force",
      "Bird of Prey",
      null,
      [["Sky Force Anniversary"], ["Sky Force Reloaded"]],
      [[], []]
    ),
    new Series(
      "Sly Cooper",
      "True Thievius Raccoonus",
      "#5C53A3",
      [
        ["Sly Cooper and the Thievius Raccoonus"],
        ["Sly 2: Band of Thieves"],
        ["Sly 3: Honor Among Thieves"],
        ["Sly Cooper: Thieves in Time"],
      ],
      [[], [], [], []]
    ),
    new Series("SMITE", "Godlike", null, [["SMITE"], ["SMITE 2"]], [[], []]),
    new Series(
      "Sniper Elite + Zombie Army",
      "The Desert Ghost",
      "#EBC570 #2A748D",
      [
        ["Sniper Elite V2 Remastered", "Sniper Elite V2 Remastered (Xbox 360)"],
        ["Sniper Elite 4"],
        ["Sniper Elite 5"],
        ["Sniper Elite: Resistance"],
        ["Zombie Army Trilogy"],
        ["Zombie Army 4: Dead War"],
      ],
      [["360"], [], [], [], [], []]
    ),
    new Series(
      "Sniper Elite",
      "The Shadow",
      null,
      [
        ["Sniper Elite V2 Remastered", "Sniper Elite V2 Remastered (Xbox 360)"],
        ["Sniper Elite 4"],
        ["Sniper Elite 5"],
        ["Sniper Elite: Resistance"],
      ],
      [["360"], [], [], []]
    ),
    new Series(
      "Zombie Army",
      "None More Hard",
      null,
      [["Zombie Army Trilogy"], ["Zombie Army 4: Dead War"]],
      [[], []]
    ),
    new Series(
      "Sniper: Ghost Warrior",
      "Supplier of Death",
      null,
      [
        ["Sniper: Ghost Warrior 3"],
        ["Sniper: Ghost Warrior Contracts"],
        ["Sniper: Ghost Warrior Contracts 2"],
      ],
      [[], [], []]
    ),
    new Series(
      "Sonic",
      "Chaos Hedgehog",
      null,
      [
        ["Sonic Unleashed"],
        ["Sonic & All-Stars Racing Transformed"],
        ["Team Sonic Racing"],
        ["Sonic Mania"],
        ["Sonic Forces"],
        ["Sonic Colors: Ultimate"],
        ["Sonic Origins"],
        ["Sonic Frontiers"],
        ["Sonic Superstars"],
        ["Sonic X Shadow Generations"],
        ["Sonic Racing: CrossWorlds"],
      ],
      [[], [], [], [], [], [], [], [], [], [], []]
    ),
    new Series(
      "Soulsborne",
      "The Soul of Cinder",
      "#E02316 #FAE678",
      [
        ["Dark Souls: Remastered", "Dark Souls: Remastered (Xbox 360)"],
        [
          "Dark Souls II: Scholar of the First Sin",
          "Dark Souls II: Scholar of the First Sin (Xbox 360)",
        ],
        ["Dark Souls III"],
        ["Sekiro: Shadows Die Twice"],
        ["ELDEN RING"],
        ["ELDEN RING NIGHTREIGN"],
      ],
      [["360"], ["360"], [], [], [], []]
    ),
    new Series(
      "Dark Souls",
      "The Abysswalker",
      null,
      [
        ["Dark Souls: Remastered", "Dark Souls: Remastered (Xbox 360)"],
        [
          "Dark Souls II: Scholar of the First Sin",
          "Dark Souls II: Scholar of the First Sin (Xbox 360)",
        ],
        ["Dark Souls III"],
      ],
      [["360"], ["360"], []]
    ),
    new Series(
      "Sekiro",
      "One-Armed Wolf",
      null,
      [["Sekiro: Shadows Die Twice"]],
      [[]]
    ),
    new Series(
      "ELDEN RING",
      "The Tarnished",
      null,
      [["ELDEN RING"], ["ELDEN RING NIGHTREIGN"]],
      [[], []]
    ),
    new Series(
      "South Park",
      "Man Bear Pig",
      null,
      [
        [
          "South Park: The Stick of Truth",
          "South Park: The Stick of Truth (Xbox 360)",
        ],
        ["South Park: The Fractured but Whole"],
        ["South Park: Snow Day!"],
      ],
      [["360"], [], []]
    ),
    new Series(
      "Space Potato",
      "Glorious Potato",
      null,
      [["Space Gladiators"], ["Brotato"]],
      [[], []]
    ),
    new Series(
      "Spacelords",
      "Raider of the Broken Planet",
      null,
      [["Spacelords"]],
      [[]]
    ),
    new Series(
      "Spectre Divide",
      "Forged in Duality",
      null,
      [["Spectre Divide"]],
      [[]]
    ),
    new Series(
      "Spirit of the North",
      "Kindred Spirit",
      null,
      [["Spirit of the North: Enhanced Edition"], ["Spirit of the North 2"]],
      [[], []]
    ),
    new Series(
      "Splitgate",
      "Professor Portal",
      null,
      [["Splitgate"], ["Splitgate 2"]],
      [[], []]
    ),
    new Series(
      "SpongeBob SquarePants",
      "Goofy Goober",
      "#F6A3A5",
      [
        [
          "SpongeBob SquarePants: Battle for Bikini Bottom - Rehydrated",
          "SpongeBob SquarePants: Battle for Bikini Bottom - Rehydrated (Windows)",
        ],
        ["SpongeBob SquarePants: The Cosmic Shake"],
        ["SpongeBob SquarePants: The Patrick Star Game"],
      ],
      [["Windows"], [], []]
    ),
    new Series(
      "S.T.A.L.K.E.R.",
      "Marked One",
      null,
      [
        ["S.T.A.L.K.E.R. Shadow of Chornobyl"],
        ["S.T.A.L.K.E.R. Clear Sky"],
        ["S.T.A.L.K.E.R. Call of Pripyat"],
        ["S.T.A.L.K.E.R. 2: Heart of Chornobyl"],
      ],
      [[], [], [], []]
    ),
    new Series(
      "Star Ocean",
      "The Spirit of all Creation",
      null,
      [["Star Ocean: The Last Hope"], ["Star Ocean The Divine Force"]],
      [[], []]
    ),
    new Series(
      "Star Trek",
      "Beam Me Up, Scotty",
      null,
      [
        ["Star Trek Online"],
        ["Star Trek Prodigy: Supernova"],
        ["Star Trek: Resurgence"],
        ["Star Trek: Legends"],
      ],
      [[], [], [], []]
    ),
    new Series(
      "Star Wars",
      "The Chosen One",
      "#0240F5 #CDE3F3",
      [
        ["Star Wars Battlefront"],
        ["Star Wars Battlefront II"],
        ["Star Wars: Battlefront Classic Collection"],
        ["Star Wars: Squadrons"],
        ["Star Wars Jedi: Fallen Order"],
        ["Star Wars Jedi: Survivor"],
        ["Star Wars Outlaws"],
        ["Star Wars Eclipse"],
        ["Star Wars: The Force Unleashed"],
        ["Star Wars: The Force Unleashed II"],
        ["STAR WARS: Episode I: Jedi Power Battles"],
        ["Star Wars Episode I Racer"],
        ["Star Wars: Dark Forces Remaster"],
        ["Star Wars: Bounty Hunter"],
        ["LEGO Star Wars II: The Original Trilogy"],
        ["LEGO Star Wars: The Complete Saga"],
        ["LEGO Star Wars III: The Clone Wars"],
        [
          "LEGO Star Wars: The Force Awakens",
          "LEGO Star Wars: The Force Awakens (Xbox 360)",
        ],
        ["LEGO Star Wars: The Skywalker Saga"],
      ],
      [
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        ["360"],
        [],
      ]
    ),
    new Series(
      "LEGO Star Wars",
      "A Fine Addition to My Collection",
      null,
      [
        ["LEGO Star Wars II: The Original Trilogy"],
        ["LEGO Star Wars: The Complete Saga"],
        ["LEGO Star Wars III: The Clone Wars"],
        [
          "LEGO Star Wars: The Force Awakens",
          "LEGO Star Wars: The Force Awakens (Xbox 360)",
        ],
        ["LEGO Star Wars: The Skywalker Saga"],
      ],
      [[], [], [], ["360"], []]
    ),
    new Series(
      "Star Wars: Battlefront",
      "Ackbar's Elite",
      null,
      [
        ["Star Wars Battlefront"],
        ["Star Wars Battlefront II"],
        ["Star Wars: Battlefront Classic Collection"],
      ],
      [[], [], []]
    ),
    new Series(
      "Star Wars: Classics",
      "Mandalorian's Pride",
      null,
      [
        ["Star Wars: Battlefront Classic Collection"],
        ["STAR WARS: Episode I: Jedi Power Battles"],
        ["Star Wars Episode I Racer"],
        ["Star Wars: Dark Forces Remaster"],
        ["Star Wars: Bounty Hunter"],
      ],
      [[], [], [], [], []]
    ),
    new Series(
      "Star Wars: Jedi",
      "Jedi Master",
      null,
      [["Star Wars Jedi: Fallen Order"], ["Star Wars Jedi: Survivor"]],
      [[], []]
    ),
    new Series(
      "Star Wars: Squadrons",
      "The Galaxy's Finest",
      null,
      [["Star Wars: Squadrons"]],
      [[]]
    ),
    new Series(
      "Star Wars: The Force Unleashed",
      "Sith Master",
      null,
      [
        ["Star Wars: The Force Unleashed"],
        ["Star Wars: The Force Unleashed II"],
      ],
      [[], []]
    ),
    new Series(
      "Starpoint Gemini",
      "Legendary Gemini League Hero",
      null,
      [["Starpoint Gemini 2"], ["Starpoint Gemini: Warlords"]],
      [[], []]
    ),
    new Series(
      "State of Decay",
      "Survivor of the Blood Red Valley",
      null,
      [
        ["State of Decay: Year-One"],
        ["State of Decay 2: Juggernaut Edition"],
        ["State of Decay 3"],
      ],
      [[], [], []]
    ),
    new Series(
      "SteamWorld",
      "Assimilated",
      null,
      [
        ["SteamWorld Dig"],
        ["SteamWorld Dig 2"],
        ["SteamWorld Build"],
        ["SteamWorld Heist II"],
      ],
      [[], [], [], []]
    ),
    new Series(
      "Steven Universe",
      "Pink Diamond",
      null,
      [
        ["Steven Universe: Save The Light"],
        ["Steven Universe: Unleash the Light"],
      ],
      [[], []]
    ),
    new Series(
      "Stories",
      "Harbinger of Life",
      null,
      [["Stories: The Path of Destinies"], ["Omensight"]],
      [[], []]
    ),
    new Series(
      "Street Fighter",
      "Sekai no Senshi",
      null,
      [["Street Fighter 30th Anniversary Collection"], ["Street Fighter 6"]],
      [[], []]
    ),
    new Series(
      "Sturmfront",
      "Heidelberg Deleta",
      null,
      [["SturmFront - The Mutant War: Ubel Edition"], ["Heidelberg 1693"]],
      [[], []]
    ),
    new Series(
      "Submerged",
      "Last Vestige of Humanity",
      null,
      [["Submerged"], ["Submerged: Hidden Depths"]],
      [[], []]
    ),
    new Series(
      "Subnautica",
      "Sea Emperor Leviathan",
      "#7DCFE7",
      [["Subnautica"], ["Subnautica: Below Zero"], ["Subnautica 2"]],
      [[], [], []]
    ),
    new Series(
      "Sunless",
      "An Enemy of All Gods",
      null,
      [
        ["Sunless Sea: Zubmariner Edition"],
        ["Sunless Skies: Sovereign Edition"],
      ],
      [[], []]
    ),
    new Series("Sunset Overdrive", "OD'd", null, [["Sunset Overdrive"]], [[]]),
    new Series(
      "Super Lucky's Tale",
      "Guardian of Guardians",
      "#FF5900",
      [["Super Lucky's Tale"], ["New Super Lucky's Tale"]],
      [[], []]
    ),
    new Series(
      "Super Meat Boy",
      "I'm a Golden God!",
      null,
      [
        ["Super Meat Boy"],
        ["Super Meat Boy 3D"],
        ["Super Meat Boy Forever"],
        ["Dr. Fetus' Mean Meat Machine"],
      ],
      [[], [], [], []]
    ),
    new Series(
      "Super Monkey Ball",
      "Super Monkey Baller",
      null,
      [
        ["Super Monkey Ball: Banana Blitz HD"],
        ["Super Monkey Ball Banana Mania"],
      ],
      [[], []]
    ),
    new Series(
      "SUPERHOT",
      "Avar1ce",
      "#F81001",
      [["SUPERHOT", "SUPERHOT (Windows)"], ["SUPERHOT: MIND CONTROL DELETE"]],
      [["Windows"], []]
    ),
    new Series(
      "Supraland",
      "Suprastar",
      null,
      [["Supraland", "Supraland (Windows)"], ["Supraland: Six Inches Under"]],
      [["Windows"], []]
    ),
    new Series(
      "Sword Art Online",
      "The Black Swordsman",
      null,
      [
        ["SWORD ART ONLINE: Fatal Bullet"],
        ["SWORD ART ONLINE: Alicization Lycoris"],
        ["SWORD ART ONLINE: Last Recollection"],
        ["SWORD ART ONLINE: Fractured Daydream"],
      ],
      [[], [], [], []]
    ),
    new Series(
      "Sword of the Necromancer",
      "No Matter the Cost",
      null,
      [
        ["Sword of the Necromancer: Resurrection"],
        ["Sword of the Necromancer: Revenant"],
        ["Whispike Survivors: Sword of the Necromancer"],
      ],
      [[], [], []]
    ),
    new Series(
      "Taiko no Tatsujin",
      "Donderful Everyday",
      "#68C0C1",
      [
        ["Taiko no Tatsujin: The Drum Master!"],
        ["Taiko no Tatsujin: Rhythm Festival"],
      ],
      [[], []]
    ),
    new Series(
      "Tails of Iron",
      "Bloody Whiskers",
      null,
      [["Tails of Iron"], ["Tails of Iron 2: Whiskers of Winter"]],
      [[], []]
    ),
    new Series(
      "Tales",
      "They Call Me...",
      null,
      [
        ["Tales of Symphonia Remastered"],
        [
          "Tales of Vesperia: Definitive Edition",
          "Tales of Vesperia: Definitive Edition (Windows)",
        ],
        ["Tales of Graces f Remastered"],
        [
          "Tales of Arise",
          "Tales of Arise (Xbox One)",
          "Tales of Arise (Windows)",
        ],
      ],
      [[], ["Windows"], [], ["One", "Windows"]]
    ),
    new Series(
      "Technomancer Saga",
      "Martian Forever",
      null,
      [["Mars: War Logs"], ["The Technomancer"]],
      [[], []]
    ),
    new Series(
      "Telltale Game Series",
      "I've Got a Story To Tell",
      "#FFA202 #690B0B",
      [
        [
          "Back to the Future: The Game - 30th Anniversary Edition",
          "Back to the Future: The Game - 30th Anniversary Edition (Xbox 360)",
        ],
        [
          "Batman: The Telltale Series",
          "Batman: The Telltale Series (Xbox 360)",
          "Batman: The Telltale Series (Windows)",
        ],
        [
          "Batman: The Enemy Within - The Telltale Series",
          "Batman: The Enemy Within - The Telltale Series (Windows)",
        ],
        [
          "Game of Thrones: A Telltale Games Series",
          "Game of Thrones: A Telltale Games Series (Xbox 360)",
        ],
        ["Jurassic Park: The Game"],
        [
          "Marvel's Guardians of the Galaxy: The Telltale Series",
          "Marvel's Guardians of the Galaxy: The Telltale Series (Windows)",
        ],
        [
          "Minecraft: Story Mode - A Telltale Games Series",
          "Minecraft: Story Mode - A Telltale Games Series (Xbox 360)",
          "Minecraft: Story Mode - A Telltale Games Series (Windows)",
        ],
        [
          "Minecraft: Story Mode - Season Two",
          "Minecraft: Story Mode - Season Two (Xbox 360)",
          "Minecraft: Story Mode - Season Two (Windows)",
        ],
        ["Tales from the Borderlands", "Tales from the Borderlands (Xbox 360)"],
        ["New Tales From The Borderlands"],
        ["The Expanse: A Telltale Series"],
        ["The Expanse: Osiris Reborn"],
        ["The Walking Dead Collection - The Telltale Series"],
        [
          "The Walking Dead",
          "The Walking Dead (Xbox 360)",
          "The Walking Dead (Windows)",
        ],
        [
          "The Walking Dead: Season Two",
          "The Walking Dead: Season Two (Xbox 360)",
          "The Walking Dead: Season Two (Windows)",
        ],
        [
          "The Walking Dead: Michonne",
          "The Walking Dead: Michonne (Xbox 360)",
          "The Walking Dead: Michonne (Windows)",
        ],
        [
          "The Walking Dead: A New Frontier",
          "The Walking Dead: A New Frontier (Windows)",
        ],
        [
          "The Walking Dead: The Final Season",
          "The Walking Dead: The Final Season (Windows)",
        ],
        [
          "The Wolf Among Us",
          "The Wolf Among Us (Xbox 360)",
          "The Wolf Among Us (Windows)",
        ],
        ["The Wolf Among Us 2"],
      ],
      [
        ["360"],
        ["360", "Windows"],
        ["Windows"],
        ["360"],
        [],
        ["Windows"],
        ["360", "Windows"],
        ["360", "Windows"],
        ["360"],
        [],
        [],
        [],
        [],
        ["360", "Windows"],
        ["360", "Windows"],
        ["360", "Windows"],
        ["Windows"],
        ["Windows"],
        ["360", "Windows"],
        [],
      ]
    ),
    new Series(
      "Batman: The Telltale Series",
      "Clown Prince of Crime",
      null,
      [
        [
          "Batman: The Telltale Series",
          "Batman: The Telltale Series (Xbox 360)",
          "Batman: The Telltale Series (Windows)",
        ],
        [
          "Batman: The Enemy Within - The Telltale Series",
          "Batman: The Enemy Within - The Telltale Series (Windows)",
        ],
      ],
      [["360", "Windows"], ["Windows"]]
    ),
    new Series(
      "Minecraft: Story Mode",
      "Some Pig",
      null,
      [
        [
          "Minecraft: Story Mode - A Telltale Games Series",
          "Minecraft: Story Mode - A Telltale Games Series (Xbox 360)",
          "Minecraft: Story Mode - A Telltale Games Series (Windows)",
        ],
        [
          "Minecraft: Story Mode - Season Two",
          "Minecraft: Story Mode - Season Two (Xbox 360)",
          "Minecraft: Story Mode - Season Two (Windows)",
        ],
      ],
      [
        ["360", "Windows"],
        ["360", "Windows"],
      ]
    ),
    new Series(
      "Tales from the Borderlands",
      "Tall Tale Vault Hunter",
      null,
      [
        ["Tales from the Borderlands", "Tales from the Borderlands (Xbox 360)"],
        ["New Tales From The Borderlands"],
      ],
      [["360"], []]
    ),
    new Series(
      "The Walking Dead: The Telltale Series",
      "Take Us Back",
      null,
      [
        ["The Walking Dead Collection - The Telltale Series"],
        [
          "The Walking Dead",
          "The Walking Dead (Xbox 360)",
          "The Walking Dead (Windows)",
        ],
        [
          "The Walking Dead: Season Two",
          "The Walking Dead: Season Two (Xbox 360)",
          "The Walking Dead: Season Two (Windows)",
        ],
        [
          "The Walking Dead: Michonne",
          "The Walking Dead: Michonne (Xbox 360)",
          "The Walking Dead: Michonne (Windows)",
        ],
        [
          "The Walking Dead: A New Frontier",
          "The Walking Dead: A New Frontier (Windows)",
        ],
        [
          "The Walking Dead: The Final Season",
          "The Walking Dead: The Final Season (Windows)",
        ],
      ],
      [
        [],
        ["360", "Windows"],
        ["360", "Windows"],
        ["360", "Windows"],
        ["Windows"],
        ["Windows"],
      ]
    ),
    new Series(
      "The Wolf Among Us",
      "Big Bad Wolf",
      null,
      [
        [
          "The Wolf Among Us",
          "The Wolf Among Us (Xbox 360)",
          "The Wolf Among Us (Windows)",
        ],
        ["The Wolf Among Us 2"],
      ],
      [["360", "Windows"], []]
    ),
    new Series(
      "Tekken",
      "King of the Iron Fist",
      null,
      [["Tekken Tag Tournament 2"], ["Tekken 6"], ["Tekken 7"], ["Tekken 8"]],
      [[], [], [], []]
    ),
    new Series("TERA", "The Exiled", null, [["TERA"]], [[]]),
    new Series(
      "Tesla vs Lovecraft",
      "Crimson King",
      null,
      [["Tesla vs Lovecraft Game of the Year Edition"], ["Tesla Force"]],
      [[], []]
    ),
    new Series(
      "Tetris",
      "Tetris® Master",
      null,
      [
        ["Puyo Puyo Tetris"],
        ["Puyo Puyo Tetris 2"],
        ["Tetris Forever"],
        ["Tetris Effect: Connected"],
      ],
      [[], [], [], []]
    ),
    new Series(
      "The Banner Saga",
      "The Slayer and the Slain",
      null,
      [["The Banner Saga"], ["The Banner Saga 2"], ["The Banner Saga 3"]],
      [[], [], []]
    ),
    new Series(
      "The Bard's Tale",
      "Hero of Skara Brae",
      null,
      [
        ["The Bard's Tale Trilogy"],
        ["The Bard's Tale IV: Director's Cut"],
        ["The Bard's Tale ARPG : Remastered and Resnarkled"],
      ],
      [[], [], []]
    ),
    new Series(
      "The Bridge Curse",
      "Honorary Alumni of TungHu University",
      null,
      [
        ["The Bridge Curse: Road to Salvation"],
        ["The Bridge Curse 2: The Extrication"],
      ],
      [[], []]
    ),
    new Series(
      "The Coma",
      "The Dance of Death Is Over",
      null,
      [
        ["The Coma: Recut"],
        ["The Coma 2: Vicious Sisters"],
        ["The Coma 2B: Catacomb"],
      ],
      [[], [], []]
    ),
    new Series(
      "The Crew",
      "Coast to Coast",
      "#FBF12F",
      [["The Crew 2"], ["The Crew Motorfest"]],
      [[], []]
    ),
    new Series(
      "The Darkness",
      "Embraced the Dark",
      null,
      [["The Darkness"], ["The Darkness II"]],
      [[], []]
    ),
    new Series(
      "The Elder Scrolls",
      "The Avatar of Akatosh",
      "#AFDEF2 #F3B323",
      [
        [
          "The Elder Scrolls IV: Oblivion Remastered",
          "The Elder Scrolls IV: Oblivion Remastered (Xbox 360)",
        ],
        [
          "The Elder Scrolls V: Skyrim Special Edition",
          "The Elder Scrolls V: Skyrim Special Edition (Xbox 360)",
        ],
        ["The Elder Scrolls VI"],
        ["The Elder Scrolls Online"],
      ],
      [["360"], ["360"], [], []]
    ),
    new Series(
      "The Elder Scrolls (RPG)",
      "Laat Dovahkiin",
      null,
      [
        [
          "The Elder Scrolls IV: Oblivion Remastered",
          "The Elder Scrolls IV: Oblivion Remastered (Xbox 360)",
        ],
        [
          "The Elder Scrolls V: Skyrim Special Edition",
          "The Elder Scrolls V: Skyrim Special Edition (Xbox 360)",
        ],
        ["The Elder Scrolls VI"],
      ],
      [["360"], ["360"], []]
    ),
    new Series(
      "The Elder Scrolls Online",
      "Savior of Tamriel",
      null,
      [["The Elder Scrolls Online"]],
      [[]]
    ),
    new Series(
      "The Escapists",
      "Crook of all Trades",
      null,
      [
        ["The Escapists"],
        ["The Escapists 2"],
        [
          "The Escapists: The Walking Dead",
          "The Escapists: The Walking Dead (Windows)",
        ],
        ["The Survivalists"],
      ],
      [[], [], ["Windows"], []]
    ),
    new Series(
      "The Evil Within",
      "Mentality Eroded",
      "#C6C7C8",
      [
        [
          "The Evil Within",
          "The Evil Within (Xbox 360)",
          "The Evil Within (Xbox 360)",
        ],
        ["The Evil Within 2", "The Evil Within 2 (Windows)"],
      ],
      [["360", "360"], ["Windows"]]
    ),
    new Series(
      "The Fall",
      "Self-Discovered",
      null,
      [["The Fall"], ["The Fall Part 2: Unbound"]],
      [[], []]
    ),
    new Series("The Finals", "Broke the Bank", null, [["The Finals"]], [[]]),
    new Series(
      "The First Descendant",
      "Ironheart of Ingris",
      null,
      [["The First Descendant"]],
      [[]]
    ),
    new Series(
      "The House of Da Vinci",
      "Salaì",
      null,
      [
        ["The House of Da Vinci"],
        ["The House of Da Vinci 2"],
        ["The House of Da Vinci 3"],
      ],
      [[], [], []]
    ),
    new Series(
      "The Journey Down",
      "Bombastic",
      null,
      [
        ["The Journey Down: Chapter One"],
        ["The Journey Down: Chapter Two"],
        ["The Journey Down: Chapter Three"],
      ],
      [[], [], []]
    ),
    new Series("The Sims", "Za Woka Genava", null, [["The Sims 4"]], [[]]),
    new Series(
      "The Surge",
      "Cleansed of Imperfection",
      null,
      [
        ["The Surge", "The Surge (Windows)"],
        ["The Surge 2", "The Surge 2 (Windows)"],
      ],
      [["Windows"], ["Windows"]]
    ),
    new Series(
      "The Talos Principle",
      "Thorough Researcher",
      null,
      [["The Talos Principle: Reawakened"], ["The Talos Principle II"]],
      [[], []]
    ),
    new Series(
      "The Walking Dead",
      "Still. Not. Bitten.",
      "#558DCB #2D3257",
      [
        ["The Walking Dead: Destinies"],
        ["The Walking Dead Collection - The Telltale Series"],
        [
          "The Walking Dead",
          "The Walking Dead (Xbox 360)",
          "The Walking Dead (Windows)",
        ],
        [
          "The Walking Dead: Season Two",
          "The Walking Dead: Season Two (Xbox 360)",
          "The Walking Dead: Season Two (Windows)",
        ],
        [
          "The Walking Dead: Michonne",
          "The Walking Dead: Michonne (Xbox 360)",
          "The Walking Dead: Michonne (Windows)",
        ],
        [
          "The Walking Dead: A New Frontier",
          "The Walking Dead: A New Frontier (Windows)",
        ],
        [
          "The Walking Dead: The Final Season",
          "The Walking Dead: The Final Season (Windows)",
        ],
        [
          "The Escapists: The Walking Dead",
          "The Escapists: The Walking Dead (Windows)",
        ],
        ["Bridge Constructor: The Walking Dead"],
      ],
      [
        [],
        [],
        ["360", "Windows"],
        ["360", "Windows"],
        ["360", "Windows"],
        ["Windows"],
        ["Windows"],
        ["Windows"],
        [],
      ]
    ),
    new Series(
      "The Walking Dead: The Telltale Series",
      "Take Us Back",
      null,
      [
        ["The Walking Dead Collection - The Telltale Series"],
        [
          "The Walking Dead",
          "The Walking Dead (Xbox 360)",
          "The Walking Dead (Windows)",
        ],
        [
          "The Walking Dead: Season Two",
          "The Walking Dead: Season Two (Xbox 360)",
          "The Walking Dead: Season Two (Windows)",
        ],
        [
          "The Walking Dead: Michonne",
          "The Walking Dead: Michonne (Xbox 360)",
          "The Walking Dead: Michonne (Windows)",
        ],
        [
          "The Walking Dead: A New Frontier",
          "The Walking Dead: A New Frontier (Windows)",
        ],
        [
          "The Walking Dead: The Final Season",
          "The Walking Dead: The Final Season (Windows)",
        ],
      ],
      [
        [],
        ["360", "Windows"],
        ["360", "Windows"],
        ["360", "Windows"],
        ["Windows"],
        ["Windows"],
      ]
    ),
    new Series(
      "The Witcher",
      "Gwynbleidd",
      "#E2BC20",
      [
        ["The Witcher Remake"],
        ["The Witcher 2: Assassins of Kings"],
        ["The Witcher 3: Wild Hunt - Complete Edition"],
        ["The Witcher IV"],
        ["Thronebreaker: The Witcher Tales"],
      ],
      [[], [], [], [], []]
    ),
    new Series(
      "Thief Simulator",
      "What's Yours Is Mine",
      null,
      [["Thief Simulator"], ["Thief Simulator 2"]],
      [[], []]
    ),
    new Series(
      "THRONE AND LIBERTY",
      "Failed Immortal",
      "#CD9D68",
      [["THRONE AND LIBERTY"]],
      [[]]
    ),
    new Series(
      "Titanfall",
      "Apex Predator",
      "#E0DFD3 #B2303A",
      [
        ["Titanfall", "Titanfall (Xbox 360)"],
        ["Titanfall 2"],
        ["Apex Legends"],
      ],
      [["360"], [], []]
    ),
    new Series(
      "Titanfall (Mainline)",
      "First to Fall",
      null,
      [["Titanfall", "Titanfall (Xbox 360)"], ["Titanfall 2"]],
      [["360"], []]
    ),
    new Series("Apex Legends", "All to Ashes", null, [["Apex Legends"]], [[]]),
    new Series(
      "TMNT",
      "The Last Ronin",
      null,
      [
        [
          "Teenage Mutant Ninja Turtles: Mutants in Manhattan",
          "Teenage Mutant Ninja Turtles: Mutants in Manhattan (Xbox 360)",
        ],
        ["Teenage Mutant Ninja Turtles: Shredder's Revenge"],
        ["Teenage Mutant Ninja Turtles: The Cowabunga Collection"],
        ["Teenage Mutant Ninja Turtles Arcade: Wrath Of The Mutants"],
        ["Teenage Mutant Ninja Turtles: Mutants Unleashed"],
        ["Teenage Mutant Ninja Turtles: Splintered Fate"],
        ["Teenage Mutant Ninja Turtles: The Last Ronin"],
      ],
      [["360"], [], [], [], [], [], []]
    ),
    new Series(
      "Tom Clancy's",
      "Sum Of All Fears",
      "#DFC8D6 #C40D71",
      [
        ["Tom Clancy's Ghost Recon Wildlands"],
        ["Tom Clancy's Ghost Recon Breakpoint"],
        ["Tom Clancy's Rainbow Six Siege X"],
        ["Tom Clancy's Rainbow Six Extraction"],
        ["Tom Clancy's Splinter Cell Double Agent"],
        ["Tom Clancy's Splinter Cell Conviction"],
        ["Tom Clancy's Splinter Cell Blacklist"],
        ["Tom Clancy's The Division"],
        ["Tom Clancy's The Division 2"],
        ["Tom Clancy's The Division 3"],
      ],
      [[], [], [], [], [], [], [], [], [], []]
    ),
    new Series(
      "Tom Clancy's Ghost Recon",
      "Synchronized and Deadly",
      null,
      [
        ["Tom Clancy's Ghost Recon Wildlands"],
        ["Tom Clancy's Ghost Recon Breakpoint"],
      ],
      [[], []]
    ),
    new Series(
      "Tom Clancy's Rainbow Six",
      "Infiltration Specialist",
      null,
      [
        ["Tom Clancy's Rainbow Six Siege X"],
        ["Tom Clancy's Rainbow Six Extraction"],
      ],
      [[], []]
    ),
    new Series(
      "Tom Clancy's Splinter Cell",
      "Enhanced Lethality Demonstrated",
      null,
      [
        ["Tom Clancy's Splinter Cell Double Agent"],
        ["Tom Clancy's Splinter Cell Conviction"],
        ["Tom Clancy's Splinter Cell Blacklist"],
      ],
      [[], [], []]
    ),
    new Series(
      "Tom Clancy's The Division",
      "Objectively Experienced",
      null,
      [
        ["Tom Clancy's The Division"],
        ["Tom Clancy's The Division 2"],
        ["Tom Clancy's The Division 3"],
      ],
      [[], [], []]
    ),
    new Series(
      "Tomb Raider",
      "The Divine Ponytail",
      "#F5C373 #AB732B",
      [
        ["Tomb Raider I-III Remastered"],
        ["Tomb Raider IV-VI Remastered"],
        ["Tomb Raider: Anniversary"],
        ["Tomb Raider: Legend"],
        ["Tomb Raider: Underworld"],
        ["Lara Croft and the Guardian of Light"],
        ["Lara Croft and the Temple of Osiris"],
        [
          "Tomb Raider: Definitive Edition",
          "Tomb Raider: Definitive Edition (Xbox 360)",
        ],
        ["Rise of the Tomb Raider", "Rise of the Tomb Raider (Windows)"],
        ["Shadow of the Tomb Raider"],
      ],
      [[], [], [], [], [], [], [], ["360"], ["Windows"], []]
    ),
    new Series(
      "Tomb Raider (Original)",
      "Once and Future Adventurer",
      null,
      [["Tomb Raider I-III Remastered"], ["Tomb Raider IV-VI Remastered"]],
      [[], []]
    ),
    new Series(
      "Tomb Raider (Legend)",
      "11th Countess of Abbingdon",
      null,
      [
        ["Tomb Raider: Anniversary"],
        ["Tomb Raider: Legend"],
        ["Tomb Raider: Underworld"],
        ["Lara Croft and the Guardian of Light"],
        ["Lara Croft and the Temple of Osiris"],
      ],
      [[], [], [], [], []]
    ),
    new Series(
      "Tomb Raider (Survivor)",
      "Sister of Artemis",
      null,
      [
        [
          "Tomb Raider: Definitive Edition",
          "Tomb Raider: Definitive Edition (Xbox 360)",
        ],
        ["Rise of the Tomb Raider", "Rise of the Tomb Raider (Windows)"],
        ["Shadow of the Tomb Raider"],
      ],
      [["360"], ["Windows"], []]
    ),
    new Series(
      "Tony Hawk",
      "Birdman",
      null,
      [
        [
          "Tony Hawk's Pro Skater 1 + 2",
          "Tony Hawk's Pro Skater 1 + 2 (Windows)",
        ],
        ["Tony Hawk's Pro Skater 3 + 4"],
      ],
      [["Windows"], []]
    ),
    new Series(
      "Torchlight",
      "The Dark Alchemist",
      null,
      [["Torchlight"], ["Torchlight II"], ["Torchlight III"]],
      [[], [], []]
    ),
    new Series(
      "Trackmania",
      "Trackmaster",
      null,
      [["Trackmania Turbo"], ["Trackmania"]],
      [[], []]
    ),
    new Series(
      "Transformers",
      "Matrix of Leadership",
      null,
      [
        ["Transformers: Devastation"],
        ["Transformers: Battlegrounds"],
        ["Transformers: EarthSpark - Expedition"],
        ["Transformers: Galactic Trials"],
      ],
      [[], [], [], []]
    ),
    new Series(
      "Trials",
      "Goldlynx",
      "#F8BA3D",
      [
        ["Trials HD"],
        ["Trials Fusion", "Trials Fusion (Xbox 360)"],
        ["Trials Rising"],
        ["Trials of the Blood Dragon"],
      ],
      [[], ["360"], [], []]
    ),
    new Series(
      "Trine",
      "Hero of Trine",
      null,
      [
        ["Trine Enchanted Edition"],
        ["Trine 3: The Artifacts of Power"],
        ["Trine 4: The Nightmare Prince"],
        ["Trine 5: A Clockwork Conspiracy"],
      ],
      [[], [], [], []]
    ),
    new Series(
      "TRON",
      "End of Line",
      null,
      [["Discs Of Tron"], ["Tron: Evolution"], ["TRON: Catalyst"]],
      [[], [], []]
    ),
    new Series(
      "Tropico",
      "Presidente For Life",
      null,
      [
        ["Tropico 4"],
        [
          "Tropico 5 - Penultimate Edition",
          "Tropico 5 - Penultimate Edition (Xbox 360)",
        ],
        [
          "Tropico 6 - Next Gen Edition",
          "Tropico 6 - Next Gen Edition (Xbox One)",
          "Tropico 6 - Next Gen Edition (Windows)",
        ],
      ],
      [[], ["360"], ["One", "Windows"]]
    ),
    new Series(
      "Trove",
      "Charter of the Constellations",
      null,
      [["Trove"]],
      [[]]
    ),
    new Series(
      "True Fear",
      "Dead All Along",
      null,
      [
        ["True Fear: Forsaken Souls Part 1"],
        ["True Fear: Forsaken Souls Part 2"],
        ["True Fear: Forsaken Souls Part 3"],
      ],
      [[], [], []]
    ),
    new Series(
      "Turnip Boy",
      "Turnip-Chan",
      "#F3CBA4",
      [["Turnip Boy Commits Tax Evasion"], ["Turnip Boy Robs a Bank"]],
      [[], []]
    ),
    new Series(
      "Turok",
      "Space-Time Warrior",
      null,
      [
        ["Turok"],
        ["Turok 2: Seeds of Evil"],
        ["Turok 3: Shadow of Oblivion Remastered"],
      ],
      [[], [], []]
    ),
    new Series(
      "Two Point",
      "PhDarn Good",
      null,
      [
        ["Two Point Hospital", "Two Point Hospital (Windows)"],
        ["Two Point Campus"],
        ["Two Point Museum"],
      ],
      [["Windows"], [], []]
    ),
    new Series(
      "TY the Tasmanian Tiger",
      "RavenXXXCore's Fursona",
      null,
      [
        ["TY the Tasmanian Tiger HD"],
        ["TY the Tasmanian Tiger 2: Bush Rescue HD"],
      ],
      [[], []]
    ),
    new Series(
      "Ultra Foodmess",
      "McCOOKIE",
      null,
      [["Ultra Foodmess Deluxe"], ["Ultra Foodmess 2"]],
      [[], []]
    ),
    new Series(
      "Unbound Creations",
      "Poops on Parades",
      null,
      [["Rain on Your Parade"], ["Just Crow Things"]],
      [[], []]
    ),
    new Series(
      "Undead Horde",
      "King of Necromancy",
      null,
      [["Undead Horde"], ["Undead Horde 2: Necropolis"]],
      [[], []]
    ),
    new Series(
      "Unravel",
      "The Red Thread",
      "#D31E22",
      [["Unravel"], ["Unravel Two"]],
      [[], []]
    ),
    new Series(
      "Valfaris",
      "More Metal Than Man",
      null,
      [["Valfaris"], ["Valfaris: Mecha Therion"]],
      [[], []]
    ),
    new Series(
      "Valiant Hearts",
      "To Those Who Fell",
      null,
      [
        [
          "Valiant Hearts: The Great War",
          "Valiant Hearts: The Great War (Xbox 360)",
        ],
        ["Valiant Hearts: Coming Home"],
      ],
      [["360"], []]
    ),
    new Series(
      "Valkyria",
      "War Hero",
      null,
      [["Valkyria Revolution"], ["Valkyria Chronicles 4"]],
      [[], []]
    ),
    new Series("VALORANT", "Radiant", "#FE345A", [["VALORANT"]], [[]]),
    new Series(
      "Van Helsing",
      "Hunter of Hunters",
      null,
      [
        ["The Incredible Adventures of Van Helsing"],
        ["The Incredible Adventures of Van Helsing II"],
        ["The Incredible Adventures of Van Helsing III"],
        ["World of Van Helsing: Deathtrap"],
      ],
      [[], [], [], []]
    ),
    new Series("Vigor", "Farmacist", null, [["Vigor"]], [[]]),
    new Series(
      "War Robots: Frontiers",
      "Titan of the Wild Ten",
      null,
      [["War Robots: Frontiers"]],
      [[]]
    ),
    new Series(
      "Warface",
      "A Brand of My Own",
      null,
      [["Warface: Clutch"]],
      [[]]
    ),
    new Series(
      "Warframe",
      "True Master of Gun and Blade",
      "#EBD467",
      [["Warframe"]],
      [[]]
    ),
    new Series(
      "Wargroove",
      "Advanced Groove",
      null,
      [["Wargroove"], ["Wargroove 2"]],
      [[], []]
    ),
    new Series(
      "Warhammer",
      "The God-Emperor of Mankind",
      "#1A9DF8 #FFDD84",
      [
        ["Blood Bowl 2"],
        ["Blood Bowl 3"],
        ["Mordheim: City of the Damned"],
        ["Necromunda: Hired Gun"],
        ["Necromunda: Underhive Wars"],
        [
          "Warhammer 40,000: Battlesector",
          "Warhammer 40,000: Battlesector (Windows)",
        ],
        ["Warhammer 40,000: Boltgun"],
        ["Warhammer 40,000: Boltgun 2"],
        [
          "Warhammer 40,000: Chaos Gate - Daemonhunters",
          "Warhammer 40,000: Chaos Gate - Daemonhunters (Windows)",
        ],
        ["Warhammer 40,000: Dark Heresy"],
        ["Warhammer 40,000: Darktide"],
        ["Warhammer 40,000: Inquisitor - Martyr"],
        ["Warhammer 40,000: Mechanicus"],
        ["Warhammer 40,000: Mechanicus II"],
        ["Warhammer 40,000: Space Marine - Master Crafted Edition"],
        ["Warhammer 40,000: Space Marine II"],
        ["Warhammer 40,000: Space Marine III"],
        ["Warhammer Age of Sigmar: Realms of Ruin"],
        ["Warhammer Age of Sigmar: Storm Ground"],
        ["Warhammer Quest 2: The End Times"],
        [
          "Warhammer: Chaosbane Slayer Edition",
          "Warhammer: Chaosbane Slayer Edition (Xbox One)",
        ],
        ["Warhammer: End Times - Vermintide"],
        ["Warhammer: Vermintide 2"],
      ],
      [
        [],
        [],
        [],
        [],
        [],
        ["Windows"],
        [],
        [],
        ["Windows"],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        ["One"],
        [],
        [],
      ]
    ),
    new Series(
      "Warhammer (40K)",
      "Emperor of Mankind",
      null,
      [
        ["Necromunda: Hired Gun"],
        ["Necromunda: Underhive Wars"],
        [
          "Warhammer 40,000: Battlesector",
          "Warhammer 40,000: Battlesector (Windows)",
        ],
        ["Warhammer 40,000: Boltgun"],
        [
          "Warhammer 40,000: Chaos Gate - Daemonhunters",
          "Warhammer 40,000: Chaos Gate - Daemonhunters (Windows)",
        ],
        ["Warhammer 40,000: Dark Heresy"],
        ["Warhammer 40,000: Darktide"],
        ["Warhammer 40,000: Inquisitor - Martyr"],
        ["Warhammer 40,000: Mechanicus"],
        ["Warhammer 40,000: Mechanicus II"],
        ["Warhammer 40,000: Space Marine II"],
        ["Warhammer 40,000: Space Marine III"],
      ],
      [[], [], ["Windows"], [], ["Windows"], [], [], [], [], [], [], []]
    ),
    new Series(
      "Warhammer (Fantasy)",
      "Emperor of Man",
      null,
      [
        ["Blood Bowl 2"],
        ["Blood Bowl 3"],
        ["Mordheim: City of the Damned"],
        ["Warhammer Age of Sigmar: Realms of Ruin"],
        ["Warhammer Age of Sigmar: Storm Ground"],
        ["Warhammer Quest 2: The End Times"],
        [
          "Warhammer: Chaosbane Slayer Edition",
          "Warhammer: Chaosbane Slayer Edition (Xbox One)",
        ],
        ["Warhammer: End Times - Vermintide"],
        ["Warhammer: Vermintide 2"],
      ],
      [[], [], [], [], [], [], ["One"], [], []]
    ),
    new Series(
      "Age of Sigmar",
      "Living Weapon of Azyr",
      null,
      [
        ["Warhammer Age of Sigmar: Realms of Ruin"],
        ["Warhammer Age of Sigmar: Storm Ground"],
      ],
      [[], []]
    ),
    new Series(
      "Blood Bowl",
      "Are You Not Entertained?",
      null,
      [["Blood Bowl 2"], ["Blood Bowl 3"]],
      [[], []]
    ),
    new Series(
      "Boltgun",
      "True Son of the Emperor",
      null,
      [["Warhammer 40,000: Boltgun"], ["Warhammer 40,000: Boltgun 2"]],
      [[], []]
    ),
    new Series(
      "Necromunda",
      "Merciless of Martyr's End",
      null,
      [["Necromunda: Underhive Wars"], ["Necromunda: Hired Gun"]],
      [[], []]
    ),
    new Series(
      "Space Marine",
      "Instrument of the Emperor's Will",
      null,
      [
        ["Warhammer 40,000: Space Marine - Master Crafted Edition"],
        ["Warhammer 40,000: Space Marine II"],
        ["Warhammer 40,000: Space Marine III"],
      ],
      [[], [], []]
    ),
    new Series(
      "Vermintide",
      "A Vessel of Wrath, Forged in Blood",
      null,
      [["Warhammer: End Times - Vermintide"], ["Warhammer: Vermintide 2"]],
      [[], []]
    ),
    new Series(
      "Warriors",
      "True Warrior of the Musou",
      "#F9F0BE #737D6E",
      [
        ["Arslan: The Warriors of Legend"],
        ["Dynasty Warriors 8 Empires"],
        ["Dynasty Warriors 9"],
        ["Dynasty Warriors 9 Empires"],
        ["Dynasty Warriors: Origins"],
        [
          "ONE PIECE: PIRATE WARRIORS 4",
          "ONE PIECE: PIRATE WARRIORS 4 (Windows)",
        ],
        ["Samurai Warriors 5"],
        ["Warriors Orochi 3 Ultimate"],
        ["Warriors Orochi 4"],
        ["WARRIORS: Abyss"],
      ],
      [[], [], [], [], [], ["Windows"], [], [], [], []]
    ),
    new Series(
      "Dynasty Warriors",
      "True Warrior of the Three Kingdoms",
      null,
      [
        ["Dynasty Warriors 8 Empires"],
        ["Dynasty Warriors 9"],
        ["Dynasty Warriors 9 Empires"],
        ["Dynasty Warriors: Origins"],
      ],
      [[], [], [], []]
    ),
    new Series(
      "Warriors Orochi",
      "True Warrior of the Divine",
      null,
      [["Warriors Orochi 3 Ultimate"], ["Warriors Orochi 4"]],
      [[], []]
    ),
    new Series(
      "Wasteland",
      "Wasteland Warrior",
      null,
      [
        ["Wasteland Remastered"],
        ["Wasteland 2: Director's Cut"],
        ["Wasteland 3", "Wasteland 3 (Windows)"],
      ],
      [[], [], ["Windows"]]
    ),
    new Series(
      "Watch Dogs",
      "Vigilante",
      "#D5862A.",
      [
        ["Watch_Dogs", "Watch_Dogs (Xbox 360)"],
        ["Watch_Dogs 2"],
        ["Watch_Dogs: Legion"],
      ],
      [["360"], [], []]
    ),
    new Series(
      "We Were Here",
      "Friendship is Golden",
      "#988791",
      [
        ["We Were Here"],
        ["We Were Here Too"],
        ["We Were Here Together"],
        ["We Were Here Forever"],
        ["We Were Here Expeditions: The FriendShip"],
      ],
      [[], [], [], [], []]
    ),
    new Series(
      "Werewolf: The Apocalypse",
      "Warrior of Gaia",
      null,
      [
        [
          "Werewolf: The Apocalypse - Earthblood",
          "Werewolf: The Apocalypse - Earthblood (Xbox One)",
        ],
        ["Werewolf: The Apocalypse - Heart of the Forest"],
        ["Werewolf: The Apocalypse - Purgatory"],
      ],
      [["One"], [], []]
    ),
    new Series(
      "White Day",
      "Occult Club President",
      "#2D4744",
      [
        ["White Day: A Labyrinth Named School"],
        ["White Day 2: The Flower That Tells Lies - Complete Edition"],
      ],
      [[], []]
    ),
    new Series(
      "Wizard of Legend",
      "Wizard of Legend",
      null,
      [["Wizard of Legend"], ["Wizard of Legend 2"]],
      [[], []]
    ),
    new Series(
      "Wizarding World",
      "The Boy Who Lived",
      "#AC3238 #47F3AE",
      [
        ["Hogwarts Legacy"],
        ["Harry Potter: Quidditch Champions"],
        [
          "LEGO Harry Potter Collection",
          "LEGO Harry Potter Collection (Xbox One)",
        ],
        ["LEGO Harry Potter: Years 1-4"],
        ["LEGO Harry Potter: Years 5-7"],
      ],
      [[], [], ["One"], [], []]
    ),
    new Series(
      "LEGO Harry Potter",
      "Unbrickable Spell",
      null,
      [
        [
          "LEGO Harry Potter Collection",
          "LEGO Harry Potter Collection (Xbox One)",
        ],
        ["LEGO Harry Potter: Years 1-4"],
        ["LEGO Harry Potter: Years 5-7"],
      ],
      [["One"], [], []]
    ),
    new Series(
      "Wolfenstein",
      "I AM Death Incarnate",
      "#C20116",
      [
        ["Wolfenstein 3D"],
        ["Wolfenstein: The New Order"],
        ["Wolfenstein: The Old Blood"],
        ["Wolfenstein II: The New Colossus"],
        ["Wolfenstein: Youngblood"],
      ],
      [[], [], [], [], []]
    ),
    new Series(
      "Wonder Boy",
      "The Savior of Monster World",
      null,
      [
        ["Wonder Boy: The Dragon's Trap"],
        ["Monster Boy and the Cursed Kingdom"],
      ],
      [[], []]
    ),
    new Series(
      "World Rally Championship",
      "If in Doubt, Flat Out!",
      null,
      [
        ["WRC 5", "WRC 5 (Xbox 360)"],
        ["WRC 6"],
        ["WRC 7"],
        ["WRC 8"],
        ["WRC 9"],
        ["WRC 10"],
        ["WRC Generations"],
        ["EA SPORTS WRC"],
      ],
      [["360"], [], [], [], [], [], [], []]
    ),
    new Series(
      "Worms",
      "Absolute Donkey!",
      null,
      [
        ["Worms Armageddon: Anniversary Edition"],
        ["Worms Battlegrounds"],
        ["Worms Rumble"],
      ],
      [[], [], []]
    ),
    new Series(
      "XCOM",
      "The Few and the Proud",
      null,
      [
        ["XCOM: Enemy Unknown"],
        ["The Bureau: XCOM Declassified"],
        ["XCOM: Enemy Within"],
        ["XCOM 2"],
      ],
      [[], [], [], []]
    ),
    new Series("XDefiant", "Advanced Warfighter", null, [["XDefiant"]], [[]]),
    new Series(
      "Yakuza",
      "Gokudō",
      "#B70912 #F5BB25",
      [
        ["Yakuza 0", "Yakuza 0 (Windows)"],
        ["Yakuza Kiwami", "Yakuza Kiwami (Windows)"],
        ["Yakuza Kiwami 2", "Yakuza Kiwami 2 (Windows)"],
        ["Yakuza 3 Remastered", "Yakuza 3 Remastered (Windows)"],
        ["Yakuza 4 Remastered", "Yakuza 4 Remastered (Windows)"],
        ["Yakuza 5 Remastered", "Yakuza 5 Remastered (Windows)"],
        ["Yakuza 6: The Song of Life", "Yakuza 6: The Song of Life (Windows)"],
        ["Judgment"],
        ["Yakuza: Like a Dragon"],
        ["Lost Judgment"],
        ["Like a Dragon Gaiden: The Man Who Erased His Name"],
        ["Like a Dragon: Infinite Wealth"],
        ["Like a Dragon: Pirate Yakuza in Hawaii"],
        ["Like a Dragon: Ishin!"],
      ],
      [
        ["Windows"],
        ["Windows"],
        ["Windows"],
        ["Windows"],
        ["Windows"],
        ["Windows"],
        ["Windows"],
        [],
        [],
        [],
        [],
        [],
        [],
        [],
      ]
    ),
    new Series(
      "Yakuza (Kiryu Saga)",
      "The Dragon of Dojima",
      null,
      [
        ["Yakuza 0", "Yakuza 0 (Windows)"],
        ["Yakuza Kiwami", "Yakuza Kiwami (Windows)"],
        ["Yakuza Kiwami 2", "Yakuza Kiwami 2 (Windows)"],
        ["Yakuza 3 Remastered", "Yakuza 3 Remastered (Windows)"],
        ["Yakuza 4 Remastered", "Yakuza 4 Remastered (Windows)"],
        ["Yakuza 5 Remastered", "Yakuza 5 Remastered (Windows)"],
        ["Yakuza 6: The Song of Life", "Yakuza 6: The Song of Life (Windows)"],
      ],
      [
        ["Windows"],
        ["Windows"],
        ["Windows"],
        ["Windows"],
        ["Windows"],
        ["Windows"],
        ["Windows"],
      ]
    ),
    new Series(
      "Yakuza (Ichiban Saga)",
      "The Dragon of Rock Bottom",
      null,
      [
        ["Yakuza: Like a Dragon"],
        ["Like a Dragon Gaiden: The Man Who Erased His Name"],
        ["Like a Dragon: Infinite Wealth"],
        ["Like a Dragon: Pirate Yakuza in Hawaii"],
      ],
      [[], [], [], []]
    ),
    new Series(
      "Yakuza (Spin-off)",
      "The Mad Dog of Shimano",
      null,
      [
        ["Like a Dragon Gaiden: The Man Who Erased His Name"],
        ["Like a Dragon: Pirate Yakuza in Hawaii"],
        ["Like a Dragon: Ishin!"],
      ],
      [[], [], []]
    ),
    new Series(
      "Judgment",
      "Yagamichi",
      null,
      [["Judgment"], ["Lost Judgment"]],
      [[], []]
    ),
    new Series(
      "Yooka-Laylee",
      "World's Biggest T.W.I.T.",
      "#BA85D1",
      [
        ["Yooka-Laylee", "Yooka-Laylee (Windows)"],
        [
          "Yooka-Laylee and the Impossible Lair",
          "Yooka-Laylee and the Impossible Lair (Windows)",
        ],
      ],
      [["Windows"], ["Windows"]]
    ),
    new Series(
      "Yu-Gi-Oh!",
      "The Forbidden One",
      null,
      [
        ["Yu-Gi-Oh! Legacy of the Duelist"],
        ["Yu-Gi-Oh! Legacy of the Duelist: Link Evolution"],
        ["Yu-Gi-Oh! Master Duel"],
      ],
      [[], [], []]
    ),
    new Series(
      "Zero Escape",
      "RED and DEAD",
      "#A12902",
      [["Zero Escape: The Nonary Games"], ["Zero Escape: Zero Time Dilemma"]],
      [[], []]
    ),
    new Series(
      "Ziggurat",
      "Linked to the Gods",
      null,
      [["Ziggurat"], ["Ziggurat 2"]],
      [[], []]
    ),
  ];
}
